/* tslint:disable */
/* eslint-disable */
/**
 * PopshopLive API
 * PopshopLive API service
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    AccessSourceSearchResponse,
    AgenciesSearchResponse,
    AgencyUsersSearchResponse,
    AggregateSellerLiveStreamsStatsResponse,
    AggregateSellerPeriodStatsResponse,
    AggregateSellerUnshippedOrdersResponse,
    AppSellerApplicationsSearchResponse,
    BuyerStats,
    CampaignsSearchResponse,
    CategoriesSearchResponse,
    CategorizedResourcesSearchResponse,
    CouponsSearchResponse,
    ExportLiveStreamUserStatsParams,
    FeaturedShowSearchResponse,
    FeaturedStorePublicListingSearchResponse,
    FeaturedStoresSearchResponse,
    GoogleProductCategoriesSearchResponse,
    LinksSearchResponse,
    ListingsAggregatePerShowItem,
    LiveStreamAudiencesSearchResponse,
    LiveStreamBuyerAddressSearchResponse,
    LiveStreamsSearchResponse,
    MailsSearchResponse,
    MessageReportSearchResponse,
    MessagesSearchResponse,
    ModerationStatusEnumItem,
    MyStoreListingSearchResponse,
    OnboardingPushSearchResponse,
    OrderDetailsSearchResponse,
    OrderEnumItem,
    OrderTransactionSearchResponse,
    OrdersAggregateByPickupStatusResponse,
    OrdersSearchResponse,
    PopStoreUserAccessLevelEnumItem,
    PostCommentSearchResponse,
    PostSearchResponse,
    PostStatusEnumItem,
    PrivateProfilesPayoutHistorySearchResponse,
    ProductCategoriesSearchResponse,
    ProductCollectionsSearchResponse,
    ProfileSearchResponse,
    ProfilesFollowersSearchResponse,
    ProfilesFollowingsSearchResponse,
    PurchasedStoresResponse,
    RolesSearchResponse,
    SearchAccountsResponse,
    SearchAggregateLiveStreamUserStatsResponse,
    SearchAnlsUsersStatsResponse,
    SearchAvailableBillingCountryCodesResponse,
    SearchBadgeUsersResponse,
    SearchBadgesResponse,
    SearchCategoryDiscoveryRowsResponse,
    SearchCommunityWaitlistUsersResponse,
    SearchCreatedGiveawaysResponse,
    SearchFeaturedTagsResponse,
    SearchLiveStreamCommentsResponse,
    SearchLiveStreamUserStatsParams,
    SearchLiveStreamUserStatsResponse,
    SearchPastFinishedGiveawaysResponse,
    SearchPopStoreDropshipApplicationsResponse,
    SearchPopStoreOnboardingContestSubmissionsResponse,
    SearchPopStoreOnboardingSessionsResponse,
    SearchPopStoreThemeTemplatePurposeEnumItem,
    SearchPostCommentSortByEnumItem,
    SearchPostSortByEnumItem,
    SearchProductsResponse,
    SearchRedeemedCouponsResponse,
    SearchReferralGiftsResponse,
    SearchSellerGiveawayResponse,
    SearchSellerLifeTimeStatsResponse,
    SearchSellerLiveStreamsStatsRequest,
    SearchSellerLiveStreamsStatsResponse,
    SearchSellerMainOrderStatsRequest,
    SearchSellerMainOrderStatsResponse,
    SearchSellerPeriodStatsResponse,
    SearchSellerTagsResponse,
    SearchSellerViewersParams,
    SearchSellerViewersResponse,
    SearchSeriesElementsSortByEnumItem,
    SearchShipmentsResponse,
    SearchShowEventSellerApplicationsResponse,
    SearchShowsResponse,
    SearchStoreBlockedUsersResponse,
    SearchUserGiveawayResponse,
    SeriesElementSearchResponse,
    SeriesElementSearchResponseV2,
    SeriesSearchResponse,
    SeriesTypeEnumItem,
    ShowEventsFeaturedShowSearchResponse,
    ShowEventsSearchResponse,
    ShowTicketsSearchResponse,
    StoreIncentivePayoutSearchResponse,
    StoreListingSearchResponse,
    StoreOnboardingPushSearchResponse,
    StorePackageTemplatesSearchResponse,
    StoreTypeEnumItem,
    StoresSearchResponse,
    ThemeTemplatesSearchResponse,
    UpcomingShowSearchResponse,
    UpcomingShowsWatchersSearchResponse,
    UserDetailSearchResponse,
    UserGroupsSearchResponse,
    UserReferralsSearchResponse,
    WithdrawTransactionsSearchResponse,
} from '../models';

export interface SearchApiControllerAdminSearchThemeTemplatesRequest {
    pageNo: number;
    pageSize: number;
    order?: SearchApiControllerAdminSearchThemeTemplatesOrderEnum;
    id?: Array<string>;
    name?: string;
    sortBy?: SearchApiControllerAdminSearchThemeTemplatesSortByEnum;
    createdByUserId?: string;
    moderationStatus?: ModerationStatusEnumItem;
}

export interface SearchApiControllerAggregateOrdersByPickupStatusRequest {
    sellerId: string;
    liveStreamId?: string;
    query?: string;
}

export interface SearchApiControllerAggregateSellerLiveStreamsStatsRequest {
    sellerId: string;
}

export interface SearchApiControllerAggregateSellerPeriodStatsRequest {
    sellerId: string;
    period: SearchApiControllerAggregateSellerPeriodStatsPeriodEnum;
    periodStartDate?: string;
    periodEndDate?: string;
}

export interface SearchApiControllerAggregateShowListingRequest {
    liveStreamId: string;
}

export interface SearchApiControllerExportLiveStreamUserStatsRequest {
    liveStreamId: string;
    exportLiveStreamUserStatsParams: ExportLiveStreamUserStatsParams;
}

export interface SearchApiControllerExportMyStoreListingsRequest {
    sellerId: string;
    pageNo: number;
    pageSize: number;
    order?: SearchApiControllerExportMyStoreListingsOrderEnum;
    id?: Array<string>;
    type?: Array<SearchApiControllerExportMyStoreListingsTypeEnum>;
    excludeType?: Array<SearchApiControllerExportMyStoreListingsExcludeTypeEnum>;
    query?: string;
    status?: SearchApiControllerExportMyStoreListingsStatusEnum;
    filterOutLiveListings?: boolean;
    loadLiveStatus?: boolean;
    tags?: Array<string>;
    soldOut?: boolean;
    minPrice?: number;
    maxPrice?: number;
    shopifyStoreIds?: Array<string>;
    sortBy?: SearchApiControllerExportMyStoreListingsSortByEnum;
    tagsFilterOperator?: SearchApiControllerExportMyStoreListingsTagsFilterOperatorEnum;
    supplierId?: number;
    partnerId?: number;
    collectionId?: string;
    productCategoryId?: Array<string>;
    includeChildCategories?: boolean;
    isDropship?: boolean;
    isShopify?: boolean;
    minMeetingStartDate?: string;
    maxMeetingStartDate?: string;
}

export interface SearchApiControllerExportSellerLiveStreamsStatsRequest {
    sellerId: string;
    searchSellerLiveStreamsStatsRequest: SearchSellerLiveStreamsStatsRequest;
}

export interface SearchApiControllerExportSellerMainOrderStatsCSVRequest {
    sellerId: string;
    searchSellerMainOrderStatsRequest: SearchSellerMainOrderStatsRequest;
}

export interface SearchApiControllerExportSellerOrderDetailsRequest {
    sellerId: string;
    pageNo: number;
    pageSize: number;
    order?: SearchApiControllerExportSellerOrderDetailsOrderEnum;
    ids?: Array<string>;
    query?: string;
    masterOrderId?: Array<string>;
    orderNumber?: string;
    liveStreamId?: string;
    status?: Array<SearchApiControllerExportSellerOrderDetailsStatusEnum>;
    orderGroupStatus?: Array<SearchApiControllerExportSellerOrderDetailsOrderGroupStatusEnum>;
    pickupStatus?: Array<SearchApiControllerExportSellerOrderDetailsPickupStatusEnum>;
    groupStatusMaster?: boolean;
    groupStatus?: Array<SearchApiControllerExportSellerOrderDetailsGroupStatusEnum>;
    packed?: boolean;
    allOrders?: boolean;
    shippingMethod?: Array<SearchApiControllerExportSellerOrderDetailsShippingMethodEnum>;
    createdBefore?: string;
    createdAfter?: string;
    couponCode?: string;
    aggregateTax?: boolean;
    buyerUserType?: SearchApiControllerExportSellerOrderDetailsBuyerUserTypeEnum;
    platform?: SearchApiControllerExportSellerOrderDetailsPlatformEnum;
    listingType?: SearchApiControllerExportSellerOrderDetailsListingTypeEnum;
    showTitle?: string;
    noLiveStreamId?: boolean;
    mainOrderNumber?: string;
    mainStatus?: Array<SearchApiControllerExportSellerOrderDetailsMainStatusEnum>;
    mainPacked?: boolean;
    showCreatedBefore?: string;
    showCreatedAfter?: string;
    shippingLabelStatus?: Array<SearchApiControllerExportSellerOrderDetailsShippingLabelStatusEnum>;
    mainShippingLabelStatus?: Array<SearchApiControllerExportSellerOrderDetailsMainShippingLabelStatusEnum>;
    shippingStatus?: SearchApiControllerExportSellerOrderDetailsShippingStatusEnum;
    rateStatus?: SearchApiControllerExportSellerOrderDetailsRateStatusEnum;
    mainShippingStatus?: SearchApiControllerExportSellerOrderDetailsMainShippingStatusEnum;
    filterLabelStatus?: SearchApiControllerExportSellerOrderDetailsFilterLabelStatusEnum;
    sortBy?: SearchApiControllerExportSellerOrderDetailsSortByEnum;
    paymentType?: Array<SearchApiControllerExportSellerOrderDetailsPaymentTypeEnum>;
    transactionDateBefore?: string;
    transactionDateAfter?: string;
    isUsingShippoPlatform?: boolean;
    loadShippingCosts?: boolean;
    minWeight?: number;
    maxWeight?: number;
    minQuantity?: number;
    maxQuantity?: number;
    sourceType?: SearchApiControllerExportSellerOrderDetailsSourceTypeEnum;
    sourceId?: string;
    timezone?: string;
}

export interface SearchApiControllerExportWithdrawTransactionsBySellerRequest {
    sellerId: string;
    pageNo: number;
    pageSize: number;
    order?: SearchApiControllerExportWithdrawTransactionsBySellerOrderEnum;
    id?: Array<string>;
    query?: string;
    status?: Array<SearchApiControllerExportWithdrawTransactionsBySellerStatusEnum>;
    userId?: string;
    minCreatedAt?: string;
    maxCreatedAt?: string;
    sortBy?: SearchApiControllerExportWithdrawTransactionsBySellerSortByEnum;
    timezone?: string;
}

export interface SearchApiControllerGetBlockedAccessSourcesRequest {
    pageNo: number;
    pageSize: number;
    order?: SearchApiControllerGetBlockedAccessSourcesOrderEnum;
    type?: SearchApiControllerGetBlockedAccessSourcesTypeEnum;
    source?: string;
    userId?: string;
    sortBy?: SearchApiControllerGetBlockedAccessSourcesSortByEnum;
}

export interface SearchApiControllerGetBuyerStatsForGivenStoreRequest {
    storeId: string;
    buyerId: string;
}

export interface SearchApiControllerGetMyStoreListingTagsRequest {
    sellerId: string;
}

export interface SearchApiControllerGetOnboardingPushRecipientsRequest {
    id: string;
    pageNo: number;
    pageSize: number;
    order?: SearchApiControllerGetOnboardingPushRecipientsOrderEnum;
    query?: string;
    viewed?: boolean;
    sortBy?: SearchApiControllerGetOnboardingPushRecipientsSortByEnum;
}

export interface SearchApiControllerGetOnboardingPushesRequest {
    pageNo: number;
    pageSize: number;
    order?: SearchApiControllerGetOnboardingPushesOrderEnum;
    query?: string;
    id?: Array<string>;
    sortBy?: SearchApiControllerGetOnboardingPushesSortByEnum;
}

export interface SearchApiControllerRandomPickLiveStreamsViewersRequest {
    liveStreamId: string;
    name?: string;
    size?: number;
    userGroupId?: string;
}

export interface SearchApiControllerSearchRequest {
    pageNo: number;
    pageSize: number;
    order?: SearchApiControllerSearchOrderEnum;
    sortBy?: SearchApiControllerSearchSortByEnum;
}

export interface SearchApiControllerSearchAccountsRequest {
    pageNo: number;
    pageSize: number;
    query?: string;
    isSeller?: boolean;
    xPopPlatform?: SearchApiControllerSearchAccountsXPopPlatformEnum;
}

export interface SearchApiControllerSearchAgenciesRequest {
    pageNo: number;
    pageSize: number;
    order?: SearchApiControllerSearchAgenciesOrderEnum;
    query?: string;
    id?: Array<string>;
    status?: SearchApiControllerSearchAgenciesStatusEnum;
    sortBy?: SearchApiControllerSearchAgenciesSortByEnum;
}

export interface SearchApiControllerSearchAgencyUsersRequest {
    agencyId: string;
    pageNo: number;
    pageSize: number;
    order?: SearchApiControllerSearchAgencyUsersOrderEnum;
    query?: string;
    id?: Array<string>;
    agencyId2?: string;
    sortBy?: SearchApiControllerSearchAgencyUsersSortByEnum;
}

export interface SearchApiControllerSearchAggregateLiveStreamUserStatsRequest {
    liveStreamId: string;
}

export interface SearchApiControllerSearchAllStoresListingsRequest {
    pageNo: number;
    pageSize: number;
    order?: SearchApiControllerSearchAllStoresListingsOrderEnum;
    id?: Array<string>;
    type?: Array<SearchApiControllerSearchAllStoresListingsTypeEnum>;
    excludeType?: Array<SearchApiControllerSearchAllStoresListingsExcludeTypeEnum>;
    query?: string;
    status?: SearchApiControllerSearchAllStoresListingsStatusEnum;
    sellerId?: string;
    approverEmail?: string;
    approverName?: string;
    minCreatedAt?: string;
    maxCreatedAt?: string;
    moderationStatus?: SearchApiControllerSearchAllStoresListingsModerationStatusEnum;
    sortBy?: SearchApiControllerSearchAllStoresListingsSortByEnum;
}

export interface SearchApiControllerSearchAnlsUsersStatsRequest {
    pageNo: number;
    pageSize: number;
    userIds?: Array<string>;
}

export interface SearchApiControllerSearchAppSellerApplicationsRequest {
    pageNo: number;
    pageSize: number;
    order?: SearchApiControllerSearchAppSellerApplicationsOrderEnum;
    sortBy?: SearchApiControllerSearchAppSellerApplicationsSortByEnum;
    storeType?: SearchApiControllerSearchAppSellerApplicationsStoreTypeEnum;
    status?: SearchApiControllerSearchAppSellerApplicationsStatusEnum;
    phone?: any;
    query?: any;
}

export interface SearchApiControllerSearchBadgeUsersRequest {
    badgeId: string;
    pageNo: number;
    pageSize: number;
    order?: SearchApiControllerSearchBadgeUsersOrderEnum;
    id?: Array<string>;
    query?: string;
    sortBy?: SearchApiControllerSearchBadgeUsersSortByEnum;
}

export interface SearchApiControllerSearchBadgesRequest {
    pageNo: number;
    pageSize: number;
    order?: SearchApiControllerSearchBadgesOrderEnum;
    id?: Array<string>;
    storeIds?: Array<string>;
    query?: string;
    status?: Array<SearchApiControllerSearchBadgesStatusEnum>;
    sortBy?: SearchApiControllerSearchBadgesSortByEnum;
}

export interface SearchApiControllerSearchBadgesByUserIdRequest {
    userId: string;
    pageNo: number;
    pageSize: number;
    order?: SearchApiControllerSearchBadgesByUserIdOrderEnum;
    id?: Array<string>;
    query?: string;
    sortBy?: SearchApiControllerSearchBadgesByUserIdSortByEnum;
}

export interface SearchApiControllerSearchCampaignsRequest {
    pageNo: number;
    pageSize: number;
    order?: SearchApiControllerSearchCampaignsOrderEnum;
    isActive?: boolean;
    sortBy?: SearchApiControllerSearchCampaignsSortByEnum;
}

export interface SearchApiControllerSearchCategoriesRequest {
    pageNo: number;
    pageSize: number;
    order?: SearchApiControllerSearchCategoriesOrderEnum;
    id?: Array<string>;
    enabled?: boolean;
    query?: string;
    rootCategory?: SearchApiControllerSearchCategoriesRootCategoryEnum;
    sortBy?: SearchApiControllerSearchCategoriesSortByEnum;
}

export interface SearchApiControllerSearchCategorizedResourcesRequest {
    pageNo: number;
    pageSize: number;
    order?: SearchApiControllerSearchCategorizedResourcesOrderEnum;
    query?: string;
    categoryId?: string;
    storeId?: string;
    userId?: string;
    liveStreamId?: string;
    upcomingShowId?: string;
    resourceType?: SearchApiControllerSearchCategorizedResourcesResourceTypeEnum;
    sortBy?: SearchApiControllerSearchCategorizedResourcesSortByEnum;
}

export interface SearchApiControllerSearchCategoryDiscoveryRowCategorizedResourcesRequest {
    categoryRowId: string;
    pageNo: number;
    pageSize: number;
    order?: SearchApiControllerSearchCategoryDiscoveryRowCategorizedResourcesOrderEnum;
    query?: string;
    categoryId?: string;
    storeId?: string;
    userId?: string;
    liveStreamId?: string;
    upcomingShowId?: string;
    resourceType?: SearchApiControllerSearchCategoryDiscoveryRowCategorizedResourcesResourceTypeEnum;
    sortBy?: SearchApiControllerSearchCategoryDiscoveryRowCategorizedResourcesSortByEnum;
}

export interface SearchApiControllerSearchCategoryDiscoveryRowsRequest {
    pageNo: number;
    pageSize: number;
    order?: SearchApiControllerSearchCategoryDiscoveryRowsOrderEnum;
    id?: Array<string>;
    categoryIds?: Array<string>;
    query?: string;
    enabled?: boolean;
    sortBy?: SearchApiControllerSearchCategoryDiscoveryRowsSortByEnum;
}

export interface SearchApiControllerSearchCategoryRowFeaturedStoresRequest {
    categoryRowId: string;
    pageNo: number;
    pageSize: number;
    order?: SearchApiControllerSearchCategoryRowFeaturedStoresOrderEnum;
    sortBy?: SearchApiControllerSearchCategoryRowFeaturedStoresSortByEnum;
}

export interface SearchApiControllerSearchCommunityWaitlistUsersRequest {
    pageNo: number;
    pageSize: number;
    order?: SearchApiControllerSearchCommunityWaitlistUsersOrderEnum;
    sortBy?: SearchApiControllerSearchCommunityWaitlistUsersSortByEnum;
}

export interface SearchApiControllerSearchCouponsRequest {
    pageNo: number;
    pageSize: number;
    order?: SearchApiControllerSearchCouponsOrderEnum;
    query?: string;
    storeName?: string;
    active?: boolean;
    couponCreateMethod?: SearchApiControllerSearchCouponsCouponCreateMethodEnum;
    sortBy?: SearchApiControllerSearchCouponsSortByEnum;
}

export interface SearchApiControllerSearchCreatedGiveawaysRequest {
    userId?: string;
}

export interface SearchApiControllerSearchFeaturedShowsRequest {
    pageNo: number;
    pageSize: number;
    order?: SearchApiControllerSearchFeaturedShowsOrderEnum;
    id?: Array<string>;
    query?: string;
    active?: boolean;
    autoFeaturedStoreShow?: boolean;
    filterOutExpiredUpcomingShows?: boolean;
    filterOutLiveLiveStreams?: boolean;
    minSortedAt?: string;
    type?: Array<SearchApiControllerSearchFeaturedShowsTypeEnum>;
    sortBy?: SearchApiControllerSearchFeaturedShowsSortByEnum;
}

export interface SearchApiControllerSearchFeaturedStoresRequest {
    pageNo: number;
    pageSize: number;
    order?: SearchApiControllerSearchFeaturedStoresOrderEnum;
    sortBy?: SearchApiControllerSearchFeaturedStoresSortByEnum;
}

export interface SearchApiControllerSearchFeaturedStoresPublicListingsRequest {
    pageNo: number;
    pageSize: number;
    order?: SearchApiControllerSearchFeaturedStoresPublicListingsOrderEnum;
    id?: Array<string>;
    query?: string;
    minQuantity?: number;
    featured?: boolean;
    sortBy?: SearchApiControllerSearchFeaturedStoresPublicListingsSortByEnum;
}

export interface SearchApiControllerSearchFeaturedTagsRequest {
    pageNo: number;
    pageSize: number;
    order?: SearchApiControllerSearchFeaturedTagsOrderEnum;
    sortBy?: SearchApiControllerSearchFeaturedTagsSortByEnum;
    query?: string;
    ids?: Array<string>;
}

export interface SearchApiControllerSearchFinishedGiveawaysRequest {
    size: number;
}

export interface SearchApiControllerSearchGiveawaysBySellerRequest {
    sellerId: string;
    pageNo: number;
    pageSize: number;
    order?: SearchApiControllerSearchGiveawaysBySellerOrderEnum;
    source?: SearchApiControllerSearchGiveawaysBySellerSourceEnum;
    showId?: string;
    sortBy?: SearchApiControllerSearchGiveawaysBySellerSortByEnum;
}

export interface SearchApiControllerSearchGiveawaysByUserRequest {
    userId: string;
    pageNo: number;
    pageSize: number;
}

export interface SearchApiControllerSearchGoogleProductCategoriesRequest {
    pageNo: number;
    pageSize: number;
    order?: SearchApiControllerSearchGoogleProductCategoriesOrderEnum;
    query?: string;
    id?: Array<string>;
    parentId?: string;
    isRoot?: boolean;
    enabled?: boolean;
    sortBy?: SearchApiControllerSearchGoogleProductCategoriesSortByEnum;
}

export interface SearchApiControllerSearchIncentivePayoutsRequest {
    pageNo: number;
    pageSize: number;
    order?: SearchApiControllerSearchIncentivePayoutsOrderEnum;
    id?: Array<string>;
    query?: string;
    status?: SearchApiControllerSearchIncentivePayoutsStatusEnum;
    minCreatedAt?: string;
    maxCreatedAt?: string;
    sortBy?: SearchApiControllerSearchIncentivePayoutsSortByEnum;
    sellerId?: string;
}

export interface SearchApiControllerSearchLinksRequest {
    pageNo: number;
    pageSize: number;
    order?: SearchApiControllerSearchLinksOrderEnum;
    isActive?: boolean;
    type?: SearchApiControllerSearchLinksTypeEnum;
    shareTargetType?: Array<SearchApiControllerSearchLinksShareTargetTypeEnum>;
    query?: string;
    sortBy?: SearchApiControllerSearchLinksSortByEnum;
}

export interface SearchApiControllerSearchLiveStreamAudiencesRequest {
    liveStreamId: string;
    pageNo: number;
    pageSize: number;
    fetchDefault?: boolean;
    query?: string;
}

export interface SearchApiControllerSearchLiveStreamBuyerAddressesRequest {
    liveStreamId: string;
    pageNo: number;
    pageSize: number;
    order?: SearchApiControllerSearchLiveStreamBuyerAddressesOrderEnum;
    id?: Array<string>;
    sortBy?: SearchApiControllerSearchLiveStreamBuyerAddressesSortByEnum;
}

export interface SearchApiControllerSearchLiveStreamCommentsRequest {
    liveStreamId: string;
    pageNo: number;
    pageSize: number;
    order?: SearchApiControllerSearchLiveStreamCommentsOrderEnum;
    query?: string;
    type?: SearchApiControllerSearchLiveStreamCommentsTypeEnum;
    sortBy?: SearchApiControllerSearchLiveStreamCommentsSortByEnum;
}

export interface SearchApiControllerSearchLiveStreamUserStatsRequest {
    liveStreamId: string;
    searchLiveStreamUserStatsParams: SearchLiveStreamUserStatsParams;
}

export interface SearchApiControllerSearchLiveStreamsRequest {
    pageNo: number;
    pageSize: number;
    order?: SearchApiControllerSearchLiveStreamsOrderEnum;
    id?: Array<string>;
    eventId?: string;
    title?: string;
    query?: string;
    storeName?: string;
    status?: SearchApiControllerSearchLiveStreamsStatusEnum;
    isReplayable?: boolean;
    permission?: Array<SearchApiControllerSearchLiveStreamsPermissionEnum>;
    sortBy?: SearchApiControllerSearchLiveStreamsSortByEnum;
    userId?: string;
    loadStats?: boolean;
}

export interface SearchApiControllerSearchLiveStreamsListingsRequest {
    liveStreamId: string;
    pageNo: number;
    pageSize: number;
    order?: SearchApiControllerSearchLiveStreamsListingsOrderEnum;
    id?: Array<string>;
    query?: string;
    status?: SearchApiControllerSearchLiveStreamsListingsStatusEnum;
    sortBy?: SearchApiControllerSearchLiveStreamsListingsSortByEnum;
}

export interface SearchApiControllerSearchMailsRequest {
    pageNo: number;
    pageSize: number;
    query?: string;
    filterBy?: SearchApiControllerSearchMailsFilterByEnum;
    order?: SearchApiControllerSearchMailsOrderEnum;
    sortBy?: SearchApiControllerSearchMailsSortByEnum;
    state?: SearchApiControllerSearchMailsStateEnum;
}

export interface SearchApiControllerSearchMessagesRequest {
    pageNo: number;
    pageSize: number;
    filterBy: SearchApiControllerSearchMessagesFilterByEnum;
    order?: SearchApiControllerSearchMessagesOrderEnum;
    id?: Array<string>;
    orderIds?: Array<string>;
    available?: boolean;
    featured?: boolean;
    userIdTo?: string;
    userIdFrom?: string;
    sellerId?: string;
    buyerId?: string;
    listingId?: string;
    orderId?: string;
    query?: string;
    reportFilterBy?: SearchApiControllerSearchMessagesReportFilterByEnum;
    purpose?: SearchApiControllerSearchMessagesPurposeEnum;
    thankYouType?: Array<SearchApiControllerSearchMessagesThankYouTypeEnum>;
    sortBy?: SearchApiControllerSearchMessagesSortByEnum;
}

export interface SearchApiControllerSearchMessagesReportsRequest {
    messageId: string;
    pageNo: number;
    pageSize: number;
    order?: SearchApiControllerSearchMessagesReportsOrderEnum;
    id?: Array<string>;
    reason?: Array<SearchApiControllerSearchMessagesReportsReasonEnum>;
    resolveStatus?: Array<SearchApiControllerSearchMessagesReportsResolveStatusEnum>;
    reporterId?: string;
    sortBy?: SearchApiControllerSearchMessagesReportsSortByEnum;
}

export interface SearchApiControllerSearchMyStoreListingsRequest {
    sellerId: string;
    pageNo: number;
    pageSize: number;
    order?: SearchApiControllerSearchMyStoreListingsOrderEnum;
    id?: Array<string>;
    type?: Array<SearchApiControllerSearchMyStoreListingsTypeEnum>;
    excludeType?: Array<SearchApiControllerSearchMyStoreListingsExcludeTypeEnum>;
    query?: string;
    status?: SearchApiControllerSearchMyStoreListingsStatusEnum;
    filterOutLiveListings?: boolean;
    loadLiveStatus?: boolean;
    tags?: Array<string>;
    soldOut?: boolean;
    minPrice?: number;
    maxPrice?: number;
    shopifyStoreIds?: Array<string>;
    sortBy?: SearchApiControllerSearchMyStoreListingsSortByEnum;
    tagsFilterOperator?: SearchApiControllerSearchMyStoreListingsTagsFilterOperatorEnum;
    supplierId?: number;
    partnerId?: number;
    collectionId?: string;
    productCategoryId?: Array<string>;
    includeChildCategories?: boolean;
    isDropship?: boolean;
    isShopify?: boolean;
    minMeetingStartDate?: string;
    maxMeetingStartDate?: string;
}

export interface SearchApiControllerSearchMyStorePublicListingsRequest {
    sellerId: string;
    pageNo: number;
    pageSize: number;
    order?: SearchApiControllerSearchMyStorePublicListingsOrderEnum;
    id?: Array<string>;
    query?: string;
    categoryRowId?: string;
    categoryId?: string;
    productCategoryId?: Array<string>;
    includeChildCategories?: boolean;
    collectionId?: string;
    tags?: Array<string>;
    sellerTags?: Array<string>;
    status?: SearchApiControllerSearchMyStorePublicListingsStatusEnum;
    minQuantity?: number;
    sortBy?: SearchApiControllerSearchMyStorePublicListingsSortByEnum;
    tagsFilterOperator?: SearchApiControllerSearchMyStorePublicListingsTagsFilterOperatorEnum;
    sellerIds?: Array<string>;
    featured?: boolean;
    prefetchFeaturedStatus?: boolean;
    listingType?: Array<SearchApiControllerSearchMyStorePublicListingsListingTypeEnum>;
    excludeListingType?: Array<SearchApiControllerSearchMyStorePublicListingsExcludeListingTypeEnum>;
    minMeetingStartDate?: string;
    maxMeetingStartDate?: string;
}

export interface SearchApiControllerSearchOrderTransactionsRequest {
    pageNo: number;
    pageSize: number;
    order?: SearchApiControllerSearchOrderTransactionsOrderEnum;
    orderId?: string;
    orderNumber?: string;
    sellerId?: string;
    buyerId?: string;
    type?: SearchApiControllerSearchOrderTransactionsTypeEnum;
    status?: SearchApiControllerSearchOrderTransactionsStatusEnum;
    sortBy?: SearchApiControllerSearchOrderTransactionsSortByEnum;
}

export interface SearchApiControllerSearchOrdersRequest {
    pageNo: number;
    pageSize: number;
    order?: SearchApiControllerSearchOrdersOrderEnum;
    ids?: Array<string>;
    query?: string;
    masterOrderId?: Array<string>;
    orderNumber?: string;
    liveStreamId?: string;
    status?: Array<SearchApiControllerSearchOrdersStatusEnum>;
    orderGroupStatus?: Array<SearchApiControllerSearchOrdersOrderGroupStatusEnum>;
    pickupStatus?: Array<SearchApiControllerSearchOrdersPickupStatusEnum>;
    groupStatusMaster?: boolean;
    groupStatus?: Array<SearchApiControllerSearchOrdersGroupStatusEnum>;
    packed?: boolean;
    allOrders?: boolean;
    shippingMethod?: Array<SearchApiControllerSearchOrdersShippingMethodEnum>;
    createdBefore?: string;
    createdAfter?: string;
    couponCode?: string;
    aggregateTax?: boolean;
    buyerUserType?: SearchApiControllerSearchOrdersBuyerUserTypeEnum;
    platform?: SearchApiControllerSearchOrdersPlatformEnum;
    listingType?: SearchApiControllerSearchOrdersListingTypeEnum;
    eventId?: string;
    listingId?: string;
    sellerId?: string;
    buyerId?: string;
    shippingLabelFailed?: boolean;
    filterBy?: SearchApiControllerSearchOrdersFilterByEnum;
    giftingStatus?: Array<SearchApiControllerSearchOrdersGiftingStatusEnum>;
    isGiftPackage?: boolean;
    sourceType?: SearchApiControllerSearchOrdersSourceTypeEnum;
    hasShipmentParcel?: boolean;
    shipmentOriginalParcelSource?: Array<SearchApiControllerSearchOrdersShipmentOriginalParcelSourceEnum>;
    sourceId?: string;
    refundWholeness?: Array<SearchApiControllerSearchOrdersRefundWholenessEnum>;
    isUsingShippoPlatform?: boolean;
    sortBy?: SearchApiControllerSearchOrdersSortByEnum;
}

export interface SearchApiControllerSearchPopStoreDropshipApplicationsRequest {
    pageNo: number;
    pageSize: number;
    order?: SearchApiControllerSearchPopStoreDropshipApplicationsOrderEnum;
    id?: Array<string>;
    minCreatedAt?: string;
    maxCreatedAt?: string;
    minUpdatedAt?: string;
    maxUpdatedAt?: string;
    creatorId?: Array<string>;
    state?: Array<string>;
    instagramId?: Array<string>;
    auditorId?: Array<string>;
    sortBy?: SearchApiControllerSearchPopStoreDropshipApplicationsSortByEnum;
}

export interface SearchApiControllerSearchPopStoreOnboardingContestSubmissionsRequest {
    pageNo: number;
    pageSize: number;
    order?: SearchApiControllerSearchPopStoreOnboardingContestSubmissionsOrderEnum;
    id?: Array<string>;
    creatorId?: Array<string>;
    minWeek?: string;
    maxWeek?: string;
    isWinner?: boolean;
    sortBy?: SearchApiControllerSearchPopStoreOnboardingContestSubmissionsSortByEnum;
}

export interface SearchApiControllerSearchPopStoreOnboardingSessionsRequest {
    pageNo: number;
    pageSize: number;
    order?: SearchApiControllerSearchPopStoreOnboardingSessionsOrderEnum;
    id?: Array<string>;
    minCreatedAt?: string;
    maxCreatedAt?: string;
    reg?: Array<string>;
    userId?: Array<string>;
    loginPhoneNumber?: Array<string>;
    loginEmail?: Array<string>;
    sortBy?: SearchApiControllerSearchPopStoreOnboardingSessionsSortByEnum;
}

export interface SearchApiControllerSearchPopStoreReplayLiveStreamsRequest {
    pageNo: number;
    pageSize: number;
    order?: SearchApiControllerSearchPopStoreReplayLiveStreamsOrderEnum;
    userId?: string;
    storeName?: string;
    hasListing?: boolean;
    hasOrder?: boolean;
    moderationStatus?: SearchApiControllerSearchPopStoreReplayLiveStreamsModerationStatusEnum;
    sortBy?: SearchApiControllerSearchPopStoreReplayLiveStreamsSortByEnum;
}

export interface SearchApiControllerSearchPostsRequest {
    storeId: string;
    pageNo: number;
    pageSize: number;
    order?: OrderEnumItem;
    query?: string;
    id?: Array<string>;
    permaLink?: string;
    moderationStatus?: Array<ModerationStatusEnumItem>;
    status?: Array<PostStatusEnumItem>;
    sortBy?: SearchPostSortByEnumItem;
    xPopPlatform?: SearchApiControllerSearchPostsXPopPlatformEnum;
}

export interface SearchApiControllerSearchPostsCommentsRequest {
    storeId: string;
    postId: string;
    pageNo: number;
    pageSize: number;
    order?: OrderEnumItem;
    query?: string;
    rootComment?: boolean;
    id?: Array<string>;
    parentId?: string;
    sortBy?: SearchPostCommentSortByEnumItem;
}

export interface SearchApiControllerSearchPostsGloballyRequest {
    pageNo: number;
    pageSize: number;
    order?: OrderEnumItem;
    query?: string;
    id?: Array<string>;
    permaLink?: string;
    storeId?: string;
    moderationStatus?: Array<ModerationStatusEnumItem>;
    approverEmail?: string;
    approverName?: string;
    minCreatedAt?: string;
    maxCreatedAt?: string;
    minPublishedAt?: string;
    maxPublishedAt?: string;
    sortBy?: SearchPostSortByEnumItem;
}

export interface SearchApiControllerSearchPrivateProfilesPayoutHistoryRequest {
    sellerId: string;
    pageNo: number;
    pageSize: number;
    order?: SearchApiControllerSearchPrivateProfilesPayoutHistoryOrderEnum;
    id?: Array<string>;
    status?: Array<SearchApiControllerSearchPrivateProfilesPayoutHistoryStatusEnum>;
    sourceType?: Array<SearchApiControllerSearchPrivateProfilesPayoutHistorySourceTypeEnum>;
    userId?: string;
    operatorId?: string;
    sortBy?: SearchApiControllerSearchPrivateProfilesPayoutHistorySortByEnum;
}

export interface SearchApiControllerSearchProductCollectionsRequest {
    storeId: string;
    pageNo: number;
    pageSize: number;
    order?: SearchApiControllerSearchProductCollectionsOrderEnum;
    query?: string;
    id?: Array<string>;
    archived?: boolean;
    loadLinkedProductCategories?: boolean;
    sortBy?: SearchApiControllerSearchProductCollectionsSortByEnum;
}

export interface SearchApiControllerSearchProductsRequest {
    pageNo: number;
    pageSize: number;
    query?: string;
    xPopPlatform?: SearchApiControllerSearchProductsXPopPlatformEnum;
}

export interface SearchApiControllerSearchProfilesRequest {
    pageNo: number;
    pageSize: number;
    order?: SearchApiControllerSearchProfilesOrderEnum;
    id?: Array<string>;
    filterBy?: SearchApiControllerSearchProfilesFilterByEnum;
    query?: string;
    userType?: Array<SearchApiControllerSearchProfilesUserTypeEnum>;
    sortBy?: SearchApiControllerSearchProfilesSortByEnum;
}

export interface SearchApiControllerSearchProfilesFollowersRequest {
    userId: string;
    pageNo: number;
    pageSize: number;
    order?: SearchApiControllerSearchProfilesFollowersOrderEnum;
    query?: string;
    expand?: boolean;
    sortBy?: SearchApiControllerSearchProfilesFollowersSortByEnum;
}

export interface SearchApiControllerSearchProfilesFollowingsRequest {
    userId: string;
    pageNo: number;
    pageSize: number;
    order?: SearchApiControllerSearchProfilesFollowingsOrderEnum;
    query?: string;
    sortBy?: SearchApiControllerSearchProfilesFollowingsSortByEnum;
    userType?: Array<SearchApiControllerSearchProfilesFollowingsUserTypeEnum>;
}

export interface SearchApiControllerSearchPslCategoriesRequest {
    pageNo: number;
    pageSize: number;
    order?: SearchApiControllerSearchPslCategoriesOrderEnum;
    query?: string;
    id?: Array<string>;
    parentId?: string;
    isRoot?: boolean;
    enabled?: boolean;
    custom?: boolean;
    digital?: boolean;
    loadLinkedGoogleCategories?: boolean;
    sortBy?: SearchApiControllerSearchPslCategoriesSortByEnum;
}

export interface SearchApiControllerSearchPublicListingsRequest {
    pageNo: number;
    pageSize: number;
    order?: SearchApiControllerSearchPublicListingsOrderEnum;
    id?: Array<string>;
    query?: string;
    categoryRowId?: string;
    categoryId?: string;
    productCategoryId?: Array<string>;
    includeChildCategories?: boolean;
    collectionId?: string;
    tags?: Array<string>;
    sellerTags?: Array<string>;
    status?: SearchApiControllerSearchPublicListingsStatusEnum;
    minQuantity?: number;
    sortBy?: SearchApiControllerSearchPublicListingsSortByEnum;
    tagsFilterOperator?: SearchApiControllerSearchPublicListingsTagsFilterOperatorEnum;
    sellerIds?: Array<string>;
    featured?: boolean;
    prefetchFeaturedStatus?: boolean;
    listingType?: Array<SearchApiControllerSearchPublicListingsListingTypeEnum>;
    excludeListingType?: Array<SearchApiControllerSearchPublicListingsExcludeListingTypeEnum>;
    minMeetingStartDate?: string;
    maxMeetingStartDate?: string;
}

export interface SearchApiControllerSearchPublicListingsV2Request {
    pageNo: number;
    pageSize: number;
    order?: SearchApiControllerSearchPublicListingsV2OrderEnum;
    id?: Array<string>;
    query?: string;
    categoryRowId?: string;
    categoryId?: string;
    productCategoryId?: Array<string>;
    includeChildCategories?: boolean;
    collectionId?: string;
    tags?: Array<string>;
    sellerTags?: Array<string>;
    status?: SearchApiControllerSearchPublicListingsV2StatusEnum;
    minQuantity?: number;
    sortBy?: SearchApiControllerSearchPublicListingsV2SortByEnum;
    tagsFilterOperator?: SearchApiControllerSearchPublicListingsV2TagsFilterOperatorEnum;
    sellerIds?: Array<string>;
    featured?: boolean;
    prefetchFeaturedStatus?: boolean;
    listingType?: Array<SearchApiControllerSearchPublicListingsV2ListingTypeEnum>;
    excludeListingType?: Array<SearchApiControllerSearchPublicListingsV2ExcludeListingTypeEnum>;
    minMeetingStartDate?: string;
    maxMeetingStartDate?: string;
    xPopPlatform?: SearchApiControllerSearchPublicListingsV2XPopPlatformEnum;
}

export interface SearchApiControllerSearchPurchasedStoresRequest {
    userId: string;
    size?: number;
}

export interface SearchApiControllerSearchRedeemedCouponsRequest {
    pageNo: number;
    pageSize: number;
    order?: SearchApiControllerSearchRedeemedCouponsOrderEnum;
    id?: Array<string>;
    filterBy?: SearchApiControllerSearchRedeemedCouponsFilterByEnum;
    query?: string;
    used?: boolean;
    sortBy?: SearchApiControllerSearchRedeemedCouponsSortByEnum;
}

export interface SearchApiControllerSearchReferralGiftsRequest {
    pageNo: number;
    pageSize: number;
    order?: SearchApiControllerSearchReferralGiftsOrderEnum;
    id?: Array<string>;
    storeId?: string;
    query?: string;
    sortBy?: SearchApiControllerSearchReferralGiftsSortByEnum;
}

export interface SearchApiControllerSearchReplayLiveStreamsRequest {
    pageNo: number;
    pageSize: number;
    order?: SearchApiControllerSearchReplayLiveStreamsOrderEnum;
    userId?: string;
    storeName?: string;
    approverName?: string;
    approverEmail?: string;
    hasListing?: boolean;
    hasOrder?: boolean;
    popStoreOnly?: boolean;
    minCreatedAt?: string;
    maxCreatedAt?: string;
    moderationStatus?: SearchApiControllerSearchReplayLiveStreamsModerationStatusEnum;
    sortBy?: SearchApiControllerSearchReplayLiveStreamsSortByEnum;
}

export interface SearchApiControllerSearchReviewsByUserRequest {
    userId: string;
    pageNo: number;
    pageSize: number;
    order?: SearchApiControllerSearchReviewsByUserOrderEnum;
    sortBy?: SearchApiControllerSearchReviewsByUserSortByEnum;
}

export interface SearchApiControllerSearchReviewsToSellerRequest {
    sellerId: string;
    pageNo: number;
    pageSize: number;
    order?: SearchApiControllerSearchReviewsToSellerOrderEnum;
    sortBy?: SearchApiControllerSearchReviewsToSellerSortByEnum;
}

export interface SearchApiControllerSearchRolesRequest {
    pageNo: number;
    pageSize: number;
    order?: SearchApiControllerSearchRolesOrderEnum;
    query?: string;
    uid?: string;
    isAdmin?: boolean;
    roles?: Array<SearchApiControllerSearchRolesRolesEnum>;
    sortBy?: SearchApiControllerSearchRolesSortByEnum;
}

export interface SearchApiControllerSearchSellerIncentivePayoutsRequest {
    sellerId: string;
    pageNo: number;
    pageSize: number;
    order?: SearchApiControllerSearchSellerIncentivePayoutsOrderEnum;
    id?: Array<string>;
    query?: string;
    status?: SearchApiControllerSearchSellerIncentivePayoutsStatusEnum;
    minCreatedAt?: string;
    maxCreatedAt?: string;
    sortBy?: SearchApiControllerSearchSellerIncentivePayoutsSortByEnum;
}

export interface SearchApiControllerSearchSellerLifeTimeStatsRequest {
    sellerId: string;
}

export interface SearchApiControllerSearchSellerLiveStreamsStatsRequest {
    sellerId: string;
    searchSellerLiveStreamsStatsRequest: SearchSellerLiveStreamsStatsRequest;
}

export interface SearchApiControllerSearchSellerMainOrderStatsRequest {
    sellerId: string;
    searchSellerMainOrderStatsRequest: SearchSellerMainOrderStatsRequest;
}

export interface SearchApiControllerSearchSellerMessagesRequest {
    sellerId: string;
    pageNo: number;
    pageSize: number;
    filterBy: SearchApiControllerSearchSellerMessagesFilterByEnum;
    order?: SearchApiControllerSearchSellerMessagesOrderEnum;
    id?: Array<string>;
    orderIds?: Array<string>;
    available?: boolean;
    featured?: boolean;
    userIdTo?: string;
    userIdFrom?: string;
    sellerId2?: string;
    buyerId?: string;
    listingId?: string;
    orderId?: string;
    query?: string;
    reportFilterBy?: SearchApiControllerSearchSellerMessagesReportFilterByEnum;
    purpose?: SearchApiControllerSearchSellerMessagesPurposeEnum;
    thankYouType?: Array<SearchApiControllerSearchSellerMessagesThankYouTypeEnum>;
    sortBy?: SearchApiControllerSearchSellerMessagesSortByEnum;
}

export interface SearchApiControllerSearchSellerOrderDetailsRequest {
    sellerId: string;
    pageNo: number;
    pageSize: number;
    order?: SearchApiControllerSearchSellerOrderDetailsOrderEnum;
    ids?: Array<string>;
    query?: string;
    masterOrderId?: Array<string>;
    orderNumber?: string;
    liveStreamId?: string;
    status?: Array<SearchApiControllerSearchSellerOrderDetailsStatusEnum>;
    orderGroupStatus?: Array<SearchApiControllerSearchSellerOrderDetailsOrderGroupStatusEnum>;
    pickupStatus?: Array<SearchApiControllerSearchSellerOrderDetailsPickupStatusEnum>;
    groupStatusMaster?: boolean;
    groupStatus?: Array<SearchApiControllerSearchSellerOrderDetailsGroupStatusEnum>;
    packed?: boolean;
    allOrders?: boolean;
    shippingMethod?: Array<SearchApiControllerSearchSellerOrderDetailsShippingMethodEnum>;
    createdBefore?: string;
    createdAfter?: string;
    couponCode?: string;
    aggregateTax?: boolean;
    buyerUserType?: SearchApiControllerSearchSellerOrderDetailsBuyerUserTypeEnum;
    platform?: SearchApiControllerSearchSellerOrderDetailsPlatformEnum;
    listingType?: SearchApiControllerSearchSellerOrderDetailsListingTypeEnum;
    showTitle?: string;
    noLiveStreamId?: boolean;
    mainOrderNumber?: string;
    mainStatus?: Array<SearchApiControllerSearchSellerOrderDetailsMainStatusEnum>;
    mainPacked?: boolean;
    showCreatedBefore?: string;
    showCreatedAfter?: string;
    shippingLabelStatus?: Array<SearchApiControllerSearchSellerOrderDetailsShippingLabelStatusEnum>;
    mainShippingLabelStatus?: Array<SearchApiControllerSearchSellerOrderDetailsMainShippingLabelStatusEnum>;
    shippingStatus?: SearchApiControllerSearchSellerOrderDetailsShippingStatusEnum;
    rateStatus?: SearchApiControllerSearchSellerOrderDetailsRateStatusEnum;
    mainShippingStatus?: SearchApiControllerSearchSellerOrderDetailsMainShippingStatusEnum;
    filterLabelStatus?: SearchApiControllerSearchSellerOrderDetailsFilterLabelStatusEnum;
    sortBy?: SearchApiControllerSearchSellerOrderDetailsSortByEnum;
    paymentType?: Array<SearchApiControllerSearchSellerOrderDetailsPaymentTypeEnum>;
    transactionDateBefore?: string;
    transactionDateAfter?: string;
    isUsingShippoPlatform?: boolean;
    loadShippingCosts?: boolean;
    minWeight?: number;
    maxWeight?: number;
    minQuantity?: number;
    maxQuantity?: number;
    sourceType?: SearchApiControllerSearchSellerOrderDetailsSourceTypeEnum;
    sourceId?: string;
}

export interface SearchApiControllerSearchSellerOrdersRequest {
    storeId: string;
    pageNo: number;
    pageSize: number;
    order?: SearchApiControllerSearchSellerOrdersOrderEnum;
    ids?: Array<string>;
    query?: string;
    masterOrderId?: Array<string>;
    orderNumber?: string;
    liveStreamId?: string;
    status?: Array<SearchApiControllerSearchSellerOrdersStatusEnum>;
    orderGroupStatus?: Array<SearchApiControllerSearchSellerOrdersOrderGroupStatusEnum>;
    pickupStatus?: Array<SearchApiControllerSearchSellerOrdersPickupStatusEnum>;
    groupStatusMaster?: boolean;
    groupStatus?: Array<SearchApiControllerSearchSellerOrdersGroupStatusEnum>;
    packed?: boolean;
    allOrders?: boolean;
    shippingMethod?: Array<SearchApiControllerSearchSellerOrdersShippingMethodEnum>;
    createdBefore?: string;
    createdAfter?: string;
    couponCode?: string;
    aggregateTax?: boolean;
    buyerUserType?: SearchApiControllerSearchSellerOrdersBuyerUserTypeEnum;
    platform?: SearchApiControllerSearchSellerOrdersPlatformEnum;
    listingType?: SearchApiControllerSearchSellerOrdersListingTypeEnum;
    noLiveStreamId?: boolean;
    sortBy?: SearchApiControllerSearchSellerOrdersSortByEnum;
    sellerId?: string;
    buyerId?: string;
    listingId?: string;
}

export interface SearchApiControllerSearchSellerPeriodStatsRequest {
    sellerId: string;
    period: SearchApiControllerSearchSellerPeriodStatsPeriodEnum;
    periodStartDate?: string;
    periodEndDate?: string;
}

export interface SearchApiControllerSearchSellerStatsRequest {
    pageNo: number;
    pageSize: number;
    order?: SearchApiControllerSearchSellerStatsOrderEnum;
    id?: Array<string>;
    agencyId?: string;
    popStoreOnly?: boolean;
    storeType?: Array<StoreTypeEnumItem>;
    loadAgency?: boolean;
    phone?: string;
    minLastLiveStreamDate?: string;
    maxLastLiveStreamDate?: string;
    sellerOnboardingCompleted?: boolean;
    commentChatConnectStatus?: SearchApiControllerSearchSellerStatsCommentChatConnectStatusEnum;
    commentChatOnboardingFinished?: boolean;
    billingCountryCodes?: Array<string>;
    query?: string;
    sortBy?: SearchApiControllerSearchSellerStatsSortByEnum;
}

export interface SearchApiControllerSearchSellerTagsRequest {
    pageNo: number;
    pageSize: number;
    order?: SearchApiControllerSearchSellerTagsOrderEnum;
    sortBy?: SearchApiControllerSearchSellerTagsSortByEnum;
    query?: string;
}

export interface SearchApiControllerSearchSellerViewersRequest {
    sellerId: string;
    searchSellerViewersParams: SearchSellerViewersParams;
}

export interface SearchApiControllerSearchSeriesRequest {
    storeId: string;
    pageNo: number;
    pageSize: number;
    order?: SearchApiControllerSearchSeriesOrderEnum;
    query?: string;
    id?: Array<string>;
    accessLevel?: Array<PopStoreUserAccessLevelEnumItem>;
    popClipId?: Array<string>;
    type?: Array<SeriesTypeEnumItem>;
    parentId?: Array<string>;
    archived?: boolean;
    sortBy?: SearchApiControllerSearchSeriesSortByEnum;
}

export interface SearchApiControllerSearchSeriesElementsRequest {
    storeId: string;
    seriesId: string;
    pageNo: number;
    pageSize: number;
    order?: SearchApiControllerSearchSeriesElementsOrderEnum;
    query?: string;
    id?: Array<string>;
    popClipId?: Array<string>;
    includeElementsFromSubSeries?: boolean;
    sortBy?: SearchSeriesElementsSortByEnumItem;
}

export interface SearchApiControllerSearchSeriesElementsV2Request {
    storeId: string;
    seriesId: string;
    pageNo: number;
    pageSize: number;
    order?: SearchApiControllerSearchSeriesElementsV2OrderEnum;
    query?: string;
    id?: Array<string>;
    popClipId?: Array<string>;
    includeElementsFromSubSeries?: boolean;
    sortBy?: SearchSeriesElementsSortByEnumItem;
}

export interface SearchApiControllerSearchShipmentsRequest {
    pageNo: number;
    pageSize: number;
    order?: SearchApiControllerSearchShipmentsOrderEnum;
    buyerId?: string;
    sellerId?: string;
    orderId?: string;
    shippoTransactionId?: string;
    trackingStatus?: string;
    carrier?: Array<SearchApiControllerSearchShipmentsCarrierEnum>;
    sortBy?: SearchApiControllerSearchShipmentsSortByEnum;
}

export interface SearchApiControllerSearchShowEventFeaturedStoresRequest {
    showEventId: string;
    pageNo: number;
    pageSize: number;
    order?: SearchApiControllerSearchShowEventFeaturedStoresOrderEnum;
    sortBy?: SearchApiControllerSearchShowEventFeaturedStoresSortByEnum;
}

export interface SearchApiControllerSearchShowEventSellerApplicationsRequest {
    eventId: string;
    pageNo: number;
    pageSize: number;
    order?: SearchApiControllerSearchShowEventSellerApplicationsOrderEnum;
    id?: Array<string>;
    sellerId?: string;
    status?: Array<SearchApiControllerSearchShowEventSellerApplicationsStatusEnum>;
    sellerUserGroupIds?: Array<string>;
    templateId?: string;
    sortBy?: SearchApiControllerSearchShowEventSellerApplicationsSortByEnum;
}

export interface SearchApiControllerSearchShowEventsRequest {
    pageNo: number;
    pageSize: number;
    order?: SearchApiControllerSearchShowEventsOrderEnum;
    id?: Array<string>;
    sellerIds?: Array<string>;
    sellerUserGroupIds?: Array<string>;
    query?: string;
    active?: boolean;
    isClosed?: boolean;
    countScheduledShows?: boolean;
    sortBy?: SearchApiControllerSearchShowEventsSortByEnum;
}

export interface SearchApiControllerSearchShowEventsFeaturedShowsRequest {
    showEventId: string;
    pageNo: number;
    pageSize: number;
    order?: SearchApiControllerSearchShowEventsFeaturedShowsOrderEnum;
    id?: Array<string>;
    query?: string;
    active?: boolean;
    autoFeaturedStoreShow?: boolean;
    filterOutExpiredUpcomingShows?: boolean;
    filterOutLiveLiveStreams?: boolean;
    minSortedAt?: string;
    type?: Array<SearchApiControllerSearchShowEventsFeaturedShowsTypeEnum>;
    sortBy?: SearchApiControllerSearchShowEventsFeaturedShowsSortByEnum;
}

export interface SearchApiControllerSearchShowEventsSellerApplicationsRequest {
    pageNo: number;
    pageSize: number;
    order?: SearchApiControllerSearchShowEventsSellerApplicationsOrderEnum;
    id?: Array<string>;
    sellerId?: string;
    status?: Array<SearchApiControllerSearchShowEventsSellerApplicationsStatusEnum>;
    sellerUserGroupIds?: Array<string>;
    templateId?: string;
    sortBy?: SearchApiControllerSearchShowEventsSellerApplicationsSortByEnum;
    eventId?: string;
}

export interface SearchApiControllerSearchShowEventsTicketsRequest {
    pageNo: number;
    pageSize: number;
    eventId: string;
    order?: SearchApiControllerSearchShowEventsTicketsOrderEnum;
    isActive?: boolean;
    query?: string;
    sortBy?: SearchApiControllerSearchShowEventsTicketsSortByEnum;
}

export interface SearchApiControllerSearchShowsRequest {
    pageNo: number;
    pageSize: number;
    query?: string;
    categoryRowId?: string;
    xPopPlatform?: SearchApiControllerSearchShowsXPopPlatformEnum;
}

export interface SearchApiControllerSearchStoreBlockedUsersRequest {
    storeId: string;
    pageNo: number;
    pageSize: number;
    order?: SearchApiControllerSearchStoreBlockedUsersOrderEnum;
    id?: Array<string>;
    query?: string;
    reason?: Array<SearchApiControllerSearchStoreBlockedUsersReasonEnum>;
    sortBy?: SearchApiControllerSearchStoreBlockedUsersSortByEnum;
}

export interface SearchApiControllerSearchStoreLevelSeriesElementsRequest {
    storeId: string;
    pageNo: number;
    pageSize: number;
    order?: SearchApiControllerSearchStoreLevelSeriesElementsOrderEnum;
    query?: string;
    id?: Array<string>;
    popClipId?: Array<string>;
    includeElementsFromSubSeries?: boolean;
    sortBy?: SearchSeriesElementsSortByEnumItem;
}

export interface SearchApiControllerSearchStoreLevelSeriesElementsV2Request {
    storeId: string;
    pageNo: number;
    pageSize: number;
    order?: SearchApiControllerSearchStoreLevelSeriesElementsV2OrderEnum;
    query?: string;
    id?: Array<string>;
    popClipId?: Array<string>;
    includeElementsFromSubSeries?: boolean;
    sortBy?: SearchSeriesElementsSortByEnumItem;
}

export interface SearchApiControllerSearchStoreListingShopifyStoreIdsRequest {
    sellerId: string;
}

export interface SearchApiControllerSearchStoreLiveStreamsRequest {
    sellerId: string;
    pageNo: number;
    pageSize: number;
    order?: SearchApiControllerSearchStoreLiveStreamsOrderEnum;
    id?: Array<string>;
    eventId?: string;
    title?: string;
    query?: string;
    storeName?: string;
    status?: SearchApiControllerSearchStoreLiveStreamsStatusEnum;
    isReplayable?: boolean;
    permission?: Array<SearchApiControllerSearchStoreLiveStreamsPermissionEnum>;
    sortBy?: SearchApiControllerSearchStoreLiveStreamsSortByEnum;
    liveOrEnded?: boolean;
    minCreatedAt?: string;
    maxCreatedAt?: string;
    shippingMode?: Array<SearchApiControllerSearchStoreLiveStreamsShippingModeEnum>;
}

export interface SearchApiControllerSearchStoresRequest {
    pageNo: number;
    pageSize: number;
    filterBy: SearchApiControllerSearchStoresFilterByEnum;
    order?: SearchApiControllerSearchStoresOrderEnum;
    id?: Array<string>;
    query?: string;
    sortBy?: SearchApiControllerSearchStoresSortByEnum;
}

export interface SearchApiControllerSearchThemeTemplatesRequest {
    storeId: string;
    pageNo: number;
    pageSize: number;
    purpose: SearchPopStoreThemeTemplatePurposeEnumItem;
    order?: SearchApiControllerSearchThemeTemplatesOrderEnum;
    id?: Array<string>;
    name?: string;
    sortBy?: SearchApiControllerSearchThemeTemplatesSortByEnum;
    type?: string;
}

export interface SearchApiControllerSearchUpcomingShowsRequest {
    pageNo: number;
    pageSize: number;
    order?: SearchApiControllerSearchUpcomingShowsOrderEnum;
    id?: Array<string>;
    query?: string;
    storeName?: string;
    userId?: string;
    available?: boolean;
    noEventId?: boolean;
    loadWatchListCount?: boolean;
    minStartsAt?: string;
    maxStartsAt?: string;
    sortBy?: SearchApiControllerSearchUpcomingShowsSortByEnum;
}

export interface SearchApiControllerSearchUpcomingShowsWatchersRequest {
    upcomingShowId: string;
    pageNo: number;
    pageSize: number;
    isFollower?: boolean;
}

export interface SearchApiControllerSearchUserDetailsRequest {
    pageNo: number;
    pageSize: number;
    order?: SearchApiControllerSearchUserDetailsOrderEnum;
    id?: Array<string>;
    filterBy?: SearchApiControllerSearchUserDetailsFilterByEnum;
    query?: string;
    userType?: Array<SearchApiControllerSearchUserDetailsUserTypeEnum>;
    phone?: string;
    agencyId?: string;
    minPendingBalance?: number;
    popStoreOnly?: boolean;
    pslOnly?: boolean;
    storeType?: Array<StoreTypeEnumItem>;
    billingCountryCodes?: Array<string>;
    sortBy?: SearchApiControllerSearchUserDetailsSortByEnum;
}

export interface SearchApiControllerSearchUserGroupsRequest {
    pageNo: number;
    pageSize: number;
    order?: SearchApiControllerSearchUserGroupsOrderEnum;
    query?: string;
    id?: Array<string>;
    active?: boolean;
    sortBy?: SearchApiControllerSearchUserGroupsSortByEnum;
}

export interface SearchApiControllerSearchUserGroupsUsersRequest {
    userGroupId: string;
    pageNo: number;
    pageSize: number;
    order?: SearchApiControllerSearchUserGroupsUsersOrderEnum;
    query?: string;
    userType?: Array<SearchApiControllerSearchUserGroupsUsersUserTypeEnum>;
    sortBy?: SearchApiControllerSearchUserGroupsUsersSortByEnum;
}

export interface SearchApiControllerSearchUserMessagesRequest {
    userId: string;
    pageNo: number;
    pageSize: number;
    type: SearchApiControllerSearchUserMessagesTypeEnum;
    order?: SearchApiControllerSearchUserMessagesOrderEnum;
    available?: boolean;
    sortBy?: SearchApiControllerSearchUserMessagesSortByEnum;
}

export interface SearchApiControllerSearchUserOrdersRequest {
    userId: string;
    pageNo: number;
    pageSize: number;
    order?: SearchApiControllerSearchUserOrdersOrderEnum;
    ids?: Array<string>;
    query?: string;
    masterOrderId?: Array<string>;
    orderNumber?: string;
    liveStreamId?: string;
    status?: Array<SearchApiControllerSearchUserOrdersStatusEnum>;
    orderGroupStatus?: Array<SearchApiControllerSearchUserOrdersOrderGroupStatusEnum>;
    pickupStatus?: Array<SearchApiControllerSearchUserOrdersPickupStatusEnum>;
    groupStatusMaster?: boolean;
    groupStatus?: Array<SearchApiControllerSearchUserOrdersGroupStatusEnum>;
    packed?: boolean;
    allOrders?: boolean;
    shippingMethod?: Array<SearchApiControllerSearchUserOrdersShippingMethodEnum>;
    createdBefore?: string;
    createdAfter?: string;
    couponCode?: string;
    aggregateTax?: boolean;
    buyerUserType?: SearchApiControllerSearchUserOrdersBuyerUserTypeEnum;
    platform?: SearchApiControllerSearchUserOrdersPlatformEnum;
    listingType?: SearchApiControllerSearchUserOrdersListingTypeEnum;
    noLiveStreamId?: boolean;
    sortBy?: SearchApiControllerSearchUserOrdersSortByEnum;
    sellerId?: string;
    buyerId?: string;
    listingId?: string;
}

export interface SearchApiControllerSearchUserStatsUserReferralPresentersRequest {
    userId: string;
}

export interface SearchApiControllerSearchUserStatsUserReferralsRequest {
    userId: string;
    pageNo: number;
    pageSize: number;
    order?: SearchApiControllerSearchUserStatsUserReferralsOrderEnum;
    referrerUserType?: Array<SearchApiControllerSearchUserStatsUserReferralsReferrerUserTypeEnum>;
    presenteeUserType?: Array<SearchApiControllerSearchUserStatsUserReferralsPresenteeUserTypeEnum>;
    minCreatedAt?: string;
    maxCreatedAt?: string;
    sortBy?: SearchApiControllerSearchUserStatsUserReferralsSortByEnum;
}

export interface SearchApiControllerSearchUserStatsUserReferralsByAdminRequest {
    pageNo: number;
    pageSize: number;
    order?: SearchApiControllerSearchUserStatsUserReferralsByAdminOrderEnum;
    referrerUserType?: Array<SearchApiControllerSearchUserStatsUserReferralsByAdminReferrerUserTypeEnum>;
    presenteeUserType?: Array<SearchApiControllerSearchUserStatsUserReferralsByAdminPresenteeUserTypeEnum>;
    minCreatedAt?: string;
    maxCreatedAt?: string;
    sortBy?: SearchApiControllerSearchUserStatsUserReferralsByAdminSortByEnum;
    type?: SearchApiControllerSearchUserStatsUserReferralsByAdminTypeEnum;
    subType?: SearchApiControllerSearchUserStatsUserReferralsByAdminSubTypeEnum;
    presenteeUserId?: Array<string>;
    referrerUserId?: string;
}

export interface SearchApiControllerSearchWithdrawTransactionsRequest {
    pageNo: number;
    pageSize: number;
    order?: SearchApiControllerSearchWithdrawTransactionsOrderEnum;
    id?: Array<string>;
    query?: string;
    status?: Array<SearchApiControllerSearchWithdrawTransactionsStatusEnum>;
    userId?: string;
    minCreatedAt?: string;
    maxCreatedAt?: string;
    sortBy?: SearchApiControllerSearchWithdrawTransactionsSortByEnum;
}

export interface SearchApiControllerSearchWithdrawTransactionsBySellerRequest {
    sellerId: string;
    pageNo: number;
    pageSize: number;
    order?: SearchApiControllerSearchWithdrawTransactionsBySellerOrderEnum;
    id?: Array<string>;
    query?: string;
    status?: Array<SearchApiControllerSearchWithdrawTransactionsBySellerStatusEnum>;
    userId?: string;
    minCreatedAt?: string;
    maxCreatedAt?: string;
    sortBy?: SearchApiControllerSearchWithdrawTransactionsBySellerSortByEnum;
}

/**
 * 
 */
export class SearchApi extends runtime.BaseAPI {

    /**
     */
    async searchApiControllerAdminSearchThemeTemplatesRaw(requestParameters: SearchApiControllerAdminSearchThemeTemplatesRequest): Promise<runtime.ApiResponse<ThemeTemplatesSearchResponse>> {
        if (requestParameters.pageNo === null || requestParameters.pageNo === undefined) {
            throw new runtime.RequiredError('pageNo','Required parameter requestParameters.pageNo was null or undefined when calling searchApiControllerAdminSearchThemeTemplates.');
        }

        if (requestParameters.pageSize === null || requestParameters.pageSize === undefined) {
            throw new runtime.RequiredError('pageSize','Required parameter requestParameters.pageSize was null or undefined when calling searchApiControllerAdminSearchThemeTemplates.');
        }

        const queryParameters: any = {};

        if (requestParameters.pageNo !== undefined) {
            queryParameters['pageNo'] = requestParameters.pageNo;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['pageSize'] = requestParameters.pageSize;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.id) {
            queryParameters['id'] = requestParameters.id;
        }

        if (requestParameters.name !== undefined) {
            queryParameters['name'] = requestParameters.name;
        }

        if (requestParameters.sortBy !== undefined) {
            queryParameters['sortBy'] = requestParameters.sortBy;
        }

        if (requestParameters.createdByUserId !== undefined) {
            queryParameters['createdByUserId'] = requestParameters.createdByUserId;
        }

        if (requestParameters.moderationStatus !== undefined) {
            queryParameters['moderationStatus'] = requestParameters.moderationStatus;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/themes-templates:search`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async searchApiControllerAdminSearchThemeTemplates(requestParameters: SearchApiControllerAdminSearchThemeTemplatesRequest): Promise<ThemeTemplatesSearchResponse> {
        const response = await this.searchApiControllerAdminSearchThemeTemplatesRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async searchApiControllerAggregateOrdersByPickupStatusRaw(requestParameters: SearchApiControllerAggregateOrdersByPickupStatusRequest): Promise<runtime.ApiResponse<OrdersAggregateByPickupStatusResponse>> {
        if (requestParameters.sellerId === null || requestParameters.sellerId === undefined) {
            throw new runtime.RequiredError('sellerId','Required parameter requestParameters.sellerId was null or undefined when calling searchApiControllerAggregateOrdersByPickupStatus.');
        }

        const queryParameters: any = {};

        if (requestParameters.sellerId !== undefined) {
            queryParameters['sellerId'] = requestParameters.sellerId;
        }

        if (requestParameters.liveStreamId !== undefined) {
            queryParameters['liveStreamId'] = requestParameters.liveStreamId;
        }

        if (requestParameters.query !== undefined) {
            queryParameters['query'] = requestParameters.query;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/orders:aggregate-by-pickup-status`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async searchApiControllerAggregateOrdersByPickupStatus(requestParameters: SearchApiControllerAggregateOrdersByPickupStatusRequest): Promise<OrdersAggregateByPickupStatusResponse> {
        const response = await this.searchApiControllerAggregateOrdersByPickupStatusRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async searchApiControllerAggregateSellerLiveStreamsStatsRaw(requestParameters: SearchApiControllerAggregateSellerLiveStreamsStatsRequest): Promise<runtime.ApiResponse<AggregateSellerLiveStreamsStatsResponse>> {
        if (requestParameters.sellerId === null || requestParameters.sellerId === undefined) {
            throw new runtime.RequiredError('sellerId','Required parameter requestParameters.sellerId was null or undefined when calling searchApiControllerAggregateSellerLiveStreamsStats.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/stores/{sellerId}/live-stream-stats:aggregate`.replace(`{${"sellerId"}}`, encodeURIComponent(String(requestParameters.sellerId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async searchApiControllerAggregateSellerLiveStreamsStats(requestParameters: SearchApiControllerAggregateSellerLiveStreamsStatsRequest): Promise<AggregateSellerLiveStreamsStatsResponse> {
        const response = await this.searchApiControllerAggregateSellerLiveStreamsStatsRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async searchApiControllerAggregateSellerPeriodStatsRaw(requestParameters: SearchApiControllerAggregateSellerPeriodStatsRequest): Promise<runtime.ApiResponse<AggregateSellerPeriodStatsResponse>> {
        if (requestParameters.sellerId === null || requestParameters.sellerId === undefined) {
            throw new runtime.RequiredError('sellerId','Required parameter requestParameters.sellerId was null or undefined when calling searchApiControllerAggregateSellerPeriodStats.');
        }

        if (requestParameters.period === null || requestParameters.period === undefined) {
            throw new runtime.RequiredError('period','Required parameter requestParameters.period was null or undefined when calling searchApiControllerAggregateSellerPeriodStats.');
        }

        const queryParameters: any = {};

        if (requestParameters.period !== undefined) {
            queryParameters['period'] = requestParameters.period;
        }

        if (requestParameters.periodStartDate !== undefined) {
            queryParameters['periodStartDate'] = requestParameters.periodStartDate;
        }

        if (requestParameters.periodEndDate !== undefined) {
            queryParameters['periodEndDate'] = requestParameters.periodEndDate;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/stores/{sellerId}/period-stats:aggregate`.replace(`{${"sellerId"}}`, encodeURIComponent(String(requestParameters.sellerId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async searchApiControllerAggregateSellerPeriodStats(requestParameters: SearchApiControllerAggregateSellerPeriodStatsRequest): Promise<AggregateSellerPeriodStatsResponse> {
        const response = await this.searchApiControllerAggregateSellerPeriodStatsRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async searchApiControllerAggregateSellerUnshippedOrdersRaw(): Promise<runtime.ApiResponse<AggregateSellerUnshippedOrdersResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/sellers/unshipped-orders:aggregate`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async searchApiControllerAggregateSellerUnshippedOrders(): Promise<AggregateSellerUnshippedOrdersResponse> {
        const response = await this.searchApiControllerAggregateSellerUnshippedOrdersRaw();
        return await response.value();
    }

    /**
     */
    async searchApiControllerAggregateShowListingRaw(requestParameters: SearchApiControllerAggregateShowListingRequest): Promise<runtime.ApiResponse<Array<ListingsAggregatePerShowItem>>> {
        if (requestParameters.liveStreamId === null || requestParameters.liveStreamId === undefined) {
            throw new runtime.RequiredError('liveStreamId','Required parameter requestParameters.liveStreamId was null or undefined when calling searchApiControllerAggregateShowListing.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/liveStreams/{liveStreamId}:aggregate-listing`.replace(`{${"liveStreamId"}}`, encodeURIComponent(String(requestParameters.liveStreamId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async searchApiControllerAggregateShowListing(requestParameters: SearchApiControllerAggregateShowListingRequest): Promise<Array<ListingsAggregatePerShowItem>> {
        const response = await this.searchApiControllerAggregateShowListingRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async searchApiControllerExportLiveStreamUserStatsRaw(requestParameters: SearchApiControllerExportLiveStreamUserStatsRequest): Promise<runtime.ApiResponse<string>> {
        if (requestParameters.liveStreamId === null || requestParameters.liveStreamId === undefined) {
            throw new runtime.RequiredError('liveStreamId','Required parameter requestParameters.liveStreamId was null or undefined when calling searchApiControllerExportLiveStreamUserStats.');
        }

        if (requestParameters.exportLiveStreamUserStatsParams === null || requestParameters.exportLiveStreamUserStatsParams === undefined) {
            throw new runtime.RequiredError('exportLiveStreamUserStatsParams','Required parameter requestParameters.exportLiveStreamUserStatsParams was null or undefined when calling searchApiControllerExportLiveStreamUserStats.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/live-streams/{liveStreamId}/user-stats:export-csv`.replace(`{${"liveStreamId"}}`, encodeURIComponent(String(requestParameters.liveStreamId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.exportLiveStreamUserStatsParams,
        });

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     */
    async searchApiControllerExportLiveStreamUserStats(requestParameters: SearchApiControllerExportLiveStreamUserStatsRequest): Promise<string> {
        const response = await this.searchApiControllerExportLiveStreamUserStatsRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async searchApiControllerExportMyStoreListingsRaw(requestParameters: SearchApiControllerExportMyStoreListingsRequest): Promise<runtime.ApiResponse<string>> {
        if (requestParameters.sellerId === null || requestParameters.sellerId === undefined) {
            throw new runtime.RequiredError('sellerId','Required parameter requestParameters.sellerId was null or undefined when calling searchApiControllerExportMyStoreListings.');
        }

        if (requestParameters.pageNo === null || requestParameters.pageNo === undefined) {
            throw new runtime.RequiredError('pageNo','Required parameter requestParameters.pageNo was null or undefined when calling searchApiControllerExportMyStoreListings.');
        }

        if (requestParameters.pageSize === null || requestParameters.pageSize === undefined) {
            throw new runtime.RequiredError('pageSize','Required parameter requestParameters.pageSize was null or undefined when calling searchApiControllerExportMyStoreListings.');
        }

        const queryParameters: any = {};

        if (requestParameters.pageNo !== undefined) {
            queryParameters['pageNo'] = requestParameters.pageNo;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['pageSize'] = requestParameters.pageSize;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.id) {
            queryParameters['id'] = requestParameters.id;
        }

        if (requestParameters.type) {
            queryParameters['type'] = requestParameters.type;
        }

        if (requestParameters.excludeType) {
            queryParameters['excludeType'] = requestParameters.excludeType;
        }

        if (requestParameters.query !== undefined) {
            queryParameters['query'] = requestParameters.query;
        }

        if (requestParameters.status !== undefined) {
            queryParameters['status'] = requestParameters.status;
        }

        if (requestParameters.filterOutLiveListings !== undefined) {
            queryParameters['filterOutLiveListings'] = requestParameters.filterOutLiveListings;
        }

        if (requestParameters.loadLiveStatus !== undefined) {
            queryParameters['loadLiveStatus'] = requestParameters.loadLiveStatus;
        }

        if (requestParameters.tags) {
            queryParameters['tags'] = requestParameters.tags;
        }

        if (requestParameters.soldOut !== undefined) {
            queryParameters['soldOut'] = requestParameters.soldOut;
        }

        if (requestParameters.minPrice !== undefined) {
            queryParameters['minPrice'] = requestParameters.minPrice;
        }

        if (requestParameters.maxPrice !== undefined) {
            queryParameters['maxPrice'] = requestParameters.maxPrice;
        }

        if (requestParameters.shopifyStoreIds) {
            queryParameters['shopifyStoreIds'] = requestParameters.shopifyStoreIds;
        }

        if (requestParameters.sortBy !== undefined) {
            queryParameters['sortBy'] = requestParameters.sortBy;
        }

        if (requestParameters.tagsFilterOperator !== undefined) {
            queryParameters['tagsFilterOperator'] = requestParameters.tagsFilterOperator;
        }

        if (requestParameters.supplierId !== undefined) {
            queryParameters['supplierId'] = requestParameters.supplierId;
        }

        if (requestParameters.partnerId !== undefined) {
            queryParameters['partnerId'] = requestParameters.partnerId;
        }

        if (requestParameters.collectionId !== undefined) {
            queryParameters['collectionId'] = requestParameters.collectionId;
        }

        if (requestParameters.productCategoryId) {
            queryParameters['productCategoryId'] = requestParameters.productCategoryId;
        }

        if (requestParameters.includeChildCategories !== undefined) {
            queryParameters['includeChildCategories'] = requestParameters.includeChildCategories;
        }

        if (requestParameters.isDropship !== undefined) {
            queryParameters['isDropship'] = requestParameters.isDropship;
        }

        if (requestParameters.isShopify !== undefined) {
            queryParameters['isShopify'] = requestParameters.isShopify;
        }

        if (requestParameters.minMeetingStartDate !== undefined) {
            queryParameters['minMeetingStartDate'] = requestParameters.minMeetingStartDate;
        }

        if (requestParameters.maxMeetingStartDate !== undefined) {
            queryParameters['maxMeetingStartDate'] = requestParameters.maxMeetingStartDate;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/stores/{sellerId}/listings:export`.replace(`{${"sellerId"}}`, encodeURIComponent(String(requestParameters.sellerId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     */
    async searchApiControllerExportMyStoreListings(requestParameters: SearchApiControllerExportMyStoreListingsRequest): Promise<string> {
        const response = await this.searchApiControllerExportMyStoreListingsRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async searchApiControllerExportSellerLiveStreamsStatsRaw(requestParameters: SearchApiControllerExportSellerLiveStreamsStatsRequest): Promise<runtime.ApiResponse<string>> {
        if (requestParameters.sellerId === null || requestParameters.sellerId === undefined) {
            throw new runtime.RequiredError('sellerId','Required parameter requestParameters.sellerId was null or undefined when calling searchApiControllerExportSellerLiveStreamsStats.');
        }

        if (requestParameters.searchSellerLiveStreamsStatsRequest === null || requestParameters.searchSellerLiveStreamsStatsRequest === undefined) {
            throw new runtime.RequiredError('searchSellerLiveStreamsStatsRequest','Required parameter requestParameters.searchSellerLiveStreamsStatsRequest was null or undefined when calling searchApiControllerExportSellerLiveStreamsStats.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/stores/{sellerId}/live-stream-stats:export-csv`.replace(`{${"sellerId"}}`, encodeURIComponent(String(requestParameters.sellerId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.searchSellerLiveStreamsStatsRequest,
        });

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     */
    async searchApiControllerExportSellerLiveStreamsStats(requestParameters: SearchApiControllerExportSellerLiveStreamsStatsRequest): Promise<string> {
        const response = await this.searchApiControllerExportSellerLiveStreamsStatsRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async searchApiControllerExportSellerMainOrderStatsCSVRaw(requestParameters: SearchApiControllerExportSellerMainOrderStatsCSVRequest): Promise<runtime.ApiResponse<string>> {
        if (requestParameters.sellerId === null || requestParameters.sellerId === undefined) {
            throw new runtime.RequiredError('sellerId','Required parameter requestParameters.sellerId was null or undefined when calling searchApiControllerExportSellerMainOrderStatsCSV.');
        }

        if (requestParameters.searchSellerMainOrderStatsRequest === null || requestParameters.searchSellerMainOrderStatsRequest === undefined) {
            throw new runtime.RequiredError('searchSellerMainOrderStatsRequest','Required parameter requestParameters.searchSellerMainOrderStatsRequest was null or undefined when calling searchApiControllerExportSellerMainOrderStatsCSV.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/stores/{sellerId}/main-order-stats:export-csv`.replace(`{${"sellerId"}}`, encodeURIComponent(String(requestParameters.sellerId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.searchSellerMainOrderStatsRequest,
        });

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     */
    async searchApiControllerExportSellerMainOrderStatsCSV(requestParameters: SearchApiControllerExportSellerMainOrderStatsCSVRequest): Promise<string> {
        const response = await this.searchApiControllerExportSellerMainOrderStatsCSVRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async searchApiControllerExportSellerOrderDetailsRaw(requestParameters: SearchApiControllerExportSellerOrderDetailsRequest): Promise<runtime.ApiResponse<string>> {
        if (requestParameters.sellerId === null || requestParameters.sellerId === undefined) {
            throw new runtime.RequiredError('sellerId','Required parameter requestParameters.sellerId was null or undefined when calling searchApiControllerExportSellerOrderDetails.');
        }

        if (requestParameters.pageNo === null || requestParameters.pageNo === undefined) {
            throw new runtime.RequiredError('pageNo','Required parameter requestParameters.pageNo was null or undefined when calling searchApiControllerExportSellerOrderDetails.');
        }

        if (requestParameters.pageSize === null || requestParameters.pageSize === undefined) {
            throw new runtime.RequiredError('pageSize','Required parameter requestParameters.pageSize was null or undefined when calling searchApiControllerExportSellerOrderDetails.');
        }

        const queryParameters: any = {};

        if (requestParameters.pageNo !== undefined) {
            queryParameters['pageNo'] = requestParameters.pageNo;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['pageSize'] = requestParameters.pageSize;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.ids) {
            queryParameters['ids'] = requestParameters.ids;
        }

        if (requestParameters.query !== undefined) {
            queryParameters['query'] = requestParameters.query;
        }

        if (requestParameters.masterOrderId) {
            queryParameters['masterOrderId'] = requestParameters.masterOrderId;
        }

        if (requestParameters.orderNumber !== undefined) {
            queryParameters['orderNumber'] = requestParameters.orderNumber;
        }

        if (requestParameters.liveStreamId !== undefined) {
            queryParameters['liveStreamId'] = requestParameters.liveStreamId;
        }

        if (requestParameters.status) {
            queryParameters['status'] = requestParameters.status;
        }

        if (requestParameters.orderGroupStatus) {
            queryParameters['orderGroupStatus'] = requestParameters.orderGroupStatus;
        }

        if (requestParameters.pickupStatus) {
            queryParameters['pickupStatus'] = requestParameters.pickupStatus;
        }

        if (requestParameters.groupStatusMaster !== undefined) {
            queryParameters['groupStatusMaster'] = requestParameters.groupStatusMaster;
        }

        if (requestParameters.groupStatus) {
            queryParameters['groupStatus'] = requestParameters.groupStatus;
        }

        if (requestParameters.packed !== undefined) {
            queryParameters['packed'] = requestParameters.packed;
        }

        if (requestParameters.allOrders !== undefined) {
            queryParameters['allOrders'] = requestParameters.allOrders;
        }

        if (requestParameters.shippingMethod) {
            queryParameters['shippingMethod'] = requestParameters.shippingMethod;
        }

        if (requestParameters.createdBefore !== undefined) {
            queryParameters['createdBefore'] = requestParameters.createdBefore;
        }

        if (requestParameters.createdAfter !== undefined) {
            queryParameters['createdAfter'] = requestParameters.createdAfter;
        }

        if (requestParameters.couponCode !== undefined) {
            queryParameters['couponCode'] = requestParameters.couponCode;
        }

        if (requestParameters.aggregateTax !== undefined) {
            queryParameters['aggregateTax'] = requestParameters.aggregateTax;
        }

        if (requestParameters.buyerUserType !== undefined) {
            queryParameters['buyerUserType'] = requestParameters.buyerUserType;
        }

        if (requestParameters.platform !== undefined) {
            queryParameters['platform'] = requestParameters.platform;
        }

        if (requestParameters.listingType !== undefined) {
            queryParameters['listingType'] = requestParameters.listingType;
        }

        if (requestParameters.showTitle !== undefined) {
            queryParameters['showTitle'] = requestParameters.showTitle;
        }

        if (requestParameters.noLiveStreamId !== undefined) {
            queryParameters['noLiveStreamId'] = requestParameters.noLiveStreamId;
        }

        if (requestParameters.mainOrderNumber !== undefined) {
            queryParameters['mainOrderNumber'] = requestParameters.mainOrderNumber;
        }

        if (requestParameters.mainStatus) {
            queryParameters['mainStatus'] = requestParameters.mainStatus;
        }

        if (requestParameters.mainPacked !== undefined) {
            queryParameters['mainPacked'] = requestParameters.mainPacked;
        }

        if (requestParameters.showCreatedBefore !== undefined) {
            queryParameters['showCreatedBefore'] = requestParameters.showCreatedBefore;
        }

        if (requestParameters.showCreatedAfter !== undefined) {
            queryParameters['showCreatedAfter'] = requestParameters.showCreatedAfter;
        }

        if (requestParameters.shippingLabelStatus) {
            queryParameters['shippingLabelStatus'] = requestParameters.shippingLabelStatus;
        }

        if (requestParameters.mainShippingLabelStatus) {
            queryParameters['mainShippingLabelStatus'] = requestParameters.mainShippingLabelStatus;
        }

        if (requestParameters.shippingStatus !== undefined) {
            queryParameters['shippingStatus'] = requestParameters.shippingStatus;
        }

        if (requestParameters.rateStatus !== undefined) {
            queryParameters['rateStatus'] = requestParameters.rateStatus;
        }

        if (requestParameters.mainShippingStatus !== undefined) {
            queryParameters['mainShippingStatus'] = requestParameters.mainShippingStatus;
        }

        if (requestParameters.filterLabelStatus !== undefined) {
            queryParameters['filterLabelStatus'] = requestParameters.filterLabelStatus;
        }

        if (requestParameters.sortBy !== undefined) {
            queryParameters['sortBy'] = requestParameters.sortBy;
        }

        if (requestParameters.paymentType) {
            queryParameters['paymentType'] = requestParameters.paymentType;
        }

        if (requestParameters.transactionDateBefore !== undefined) {
            queryParameters['transactionDateBefore'] = requestParameters.transactionDateBefore;
        }

        if (requestParameters.transactionDateAfter !== undefined) {
            queryParameters['transactionDateAfter'] = requestParameters.transactionDateAfter;
        }

        if (requestParameters.isUsingShippoPlatform !== undefined) {
            queryParameters['isUsingShippoPlatform'] = requestParameters.isUsingShippoPlatform;
        }

        if (requestParameters.loadShippingCosts !== undefined) {
            queryParameters['loadShippingCosts'] = requestParameters.loadShippingCosts;
        }

        if (requestParameters.minWeight !== undefined) {
            queryParameters['minWeight'] = requestParameters.minWeight;
        }

        if (requestParameters.maxWeight !== undefined) {
            queryParameters['maxWeight'] = requestParameters.maxWeight;
        }

        if (requestParameters.minQuantity !== undefined) {
            queryParameters['minQuantity'] = requestParameters.minQuantity;
        }

        if (requestParameters.maxQuantity !== undefined) {
            queryParameters['maxQuantity'] = requestParameters.maxQuantity;
        }

        if (requestParameters.sourceType !== undefined) {
            queryParameters['sourceType'] = requestParameters.sourceType;
        }

        if (requestParameters.sourceId !== undefined) {
            queryParameters['sourceId'] = requestParameters.sourceId;
        }

        if (requestParameters.timezone !== undefined) {
            queryParameters['timezone'] = requestParameters.timezone;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/stores/{sellerId}/order-details:export`.replace(`{${"sellerId"}}`, encodeURIComponent(String(requestParameters.sellerId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     */
    async searchApiControllerExportSellerOrderDetails(requestParameters: SearchApiControllerExportSellerOrderDetailsRequest): Promise<string> {
        const response = await this.searchApiControllerExportSellerOrderDetailsRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async searchApiControllerExportWithdrawTransactionsBySellerRaw(requestParameters: SearchApiControllerExportWithdrawTransactionsBySellerRequest): Promise<runtime.ApiResponse<string>> {
        if (requestParameters.sellerId === null || requestParameters.sellerId === undefined) {
            throw new runtime.RequiredError('sellerId','Required parameter requestParameters.sellerId was null or undefined when calling searchApiControllerExportWithdrawTransactionsBySeller.');
        }

        if (requestParameters.pageNo === null || requestParameters.pageNo === undefined) {
            throw new runtime.RequiredError('pageNo','Required parameter requestParameters.pageNo was null or undefined when calling searchApiControllerExportWithdrawTransactionsBySeller.');
        }

        if (requestParameters.pageSize === null || requestParameters.pageSize === undefined) {
            throw new runtime.RequiredError('pageSize','Required parameter requestParameters.pageSize was null or undefined when calling searchApiControllerExportWithdrawTransactionsBySeller.');
        }

        const queryParameters: any = {};

        if (requestParameters.pageNo !== undefined) {
            queryParameters['pageNo'] = requestParameters.pageNo;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['pageSize'] = requestParameters.pageSize;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.id) {
            queryParameters['id'] = requestParameters.id;
        }

        if (requestParameters.query !== undefined) {
            queryParameters['query'] = requestParameters.query;
        }

        if (requestParameters.status) {
            queryParameters['status'] = requestParameters.status;
        }

        if (requestParameters.userId !== undefined) {
            queryParameters['userId'] = requestParameters.userId;
        }

        if (requestParameters.minCreatedAt !== undefined) {
            queryParameters['minCreatedAt'] = requestParameters.minCreatedAt;
        }

        if (requestParameters.maxCreatedAt !== undefined) {
            queryParameters['maxCreatedAt'] = requestParameters.maxCreatedAt;
        }

        if (requestParameters.sortBy !== undefined) {
            queryParameters['sortBy'] = requestParameters.sortBy;
        }

        if (requestParameters.timezone !== undefined) {
            queryParameters['timezone'] = requestParameters.timezone;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/stores/{sellerId}/withdraw-transactions:export`.replace(`{${"sellerId"}}`, encodeURIComponent(String(requestParameters.sellerId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     */
    async searchApiControllerExportWithdrawTransactionsBySeller(requestParameters: SearchApiControllerExportWithdrawTransactionsBySellerRequest): Promise<string> {
        const response = await this.searchApiControllerExportWithdrawTransactionsBySellerRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async searchApiControllerGetBlockedAccessSourcesRaw(requestParameters: SearchApiControllerGetBlockedAccessSourcesRequest): Promise<runtime.ApiResponse<AccessSourceSearchResponse>> {
        if (requestParameters.pageNo === null || requestParameters.pageNo === undefined) {
            throw new runtime.RequiredError('pageNo','Required parameter requestParameters.pageNo was null or undefined when calling searchApiControllerGetBlockedAccessSources.');
        }

        if (requestParameters.pageSize === null || requestParameters.pageSize === undefined) {
            throw new runtime.RequiredError('pageSize','Required parameter requestParameters.pageSize was null or undefined when calling searchApiControllerGetBlockedAccessSources.');
        }

        const queryParameters: any = {};

        if (requestParameters.pageNo !== undefined) {
            queryParameters['pageNo'] = requestParameters.pageNo;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['pageSize'] = requestParameters.pageSize;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.type !== undefined) {
            queryParameters['type'] = requestParameters.type;
        }

        if (requestParameters.source !== undefined) {
            queryParameters['source'] = requestParameters.source;
        }

        if (requestParameters.userId !== undefined) {
            queryParameters['userId'] = requestParameters.userId;
        }

        if (requestParameters.sortBy !== undefined) {
            queryParameters['sortBy'] = requestParameters.sortBy;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/block-access-sources:search`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async searchApiControllerGetBlockedAccessSources(requestParameters: SearchApiControllerGetBlockedAccessSourcesRequest): Promise<AccessSourceSearchResponse> {
        const response = await this.searchApiControllerGetBlockedAccessSourcesRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async searchApiControllerGetBuyerStatsForGivenStoreRaw(requestParameters: SearchApiControllerGetBuyerStatsForGivenStoreRequest): Promise<runtime.ApiResponse<BuyerStats>> {
        if (requestParameters.storeId === null || requestParameters.storeId === undefined) {
            throw new runtime.RequiredError('storeId','Required parameter requestParameters.storeId was null or undefined when calling searchApiControllerGetBuyerStatsForGivenStore.');
        }

        if (requestParameters.buyerId === null || requestParameters.buyerId === undefined) {
            throw new runtime.RequiredError('buyerId','Required parameter requestParameters.buyerId was null or undefined when calling searchApiControllerGetBuyerStatsForGivenStore.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/stores/{storeId}/buyers/{buyerId}:stats`.replace(`{${"storeId"}}`, encodeURIComponent(String(requestParameters.storeId))).replace(`{${"buyerId"}}`, encodeURIComponent(String(requestParameters.buyerId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async searchApiControllerGetBuyerStatsForGivenStore(requestParameters: SearchApiControllerGetBuyerStatsForGivenStoreRequest): Promise<BuyerStats> {
        const response = await this.searchApiControllerGetBuyerStatsForGivenStoreRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async searchApiControllerGetMyStoreListingTagsRaw(requestParameters: SearchApiControllerGetMyStoreListingTagsRequest): Promise<runtime.ApiResponse<Array<string>>> {
        if (requestParameters.sellerId === null || requestParameters.sellerId === undefined) {
            throw new runtime.RequiredError('sellerId','Required parameter requestParameters.sellerId was null or undefined when calling searchApiControllerGetMyStoreListingTags.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/stores/{sellerId}/listing-tags`.replace(`{${"sellerId"}}`, encodeURIComponent(String(requestParameters.sellerId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     */
    async searchApiControllerGetMyStoreListingTags(requestParameters: SearchApiControllerGetMyStoreListingTagsRequest): Promise<Array<string>> {
        const response = await this.searchApiControllerGetMyStoreListingTagsRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async searchApiControllerGetOnboardingPushRecipientsRaw(requestParameters: SearchApiControllerGetOnboardingPushRecipientsRequest): Promise<runtime.ApiResponse<StoreOnboardingPushSearchResponse>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling searchApiControllerGetOnboardingPushRecipients.');
        }

        if (requestParameters.pageNo === null || requestParameters.pageNo === undefined) {
            throw new runtime.RequiredError('pageNo','Required parameter requestParameters.pageNo was null or undefined when calling searchApiControllerGetOnboardingPushRecipients.');
        }

        if (requestParameters.pageSize === null || requestParameters.pageSize === undefined) {
            throw new runtime.RequiredError('pageSize','Required parameter requestParameters.pageSize was null or undefined when calling searchApiControllerGetOnboardingPushRecipients.');
        }

        const queryParameters: any = {};

        if (requestParameters.pageNo !== undefined) {
            queryParameters['pageNo'] = requestParameters.pageNo;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['pageSize'] = requestParameters.pageSize;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.query !== undefined) {
            queryParameters['query'] = requestParameters.query;
        }

        if (requestParameters.viewed !== undefined) {
            queryParameters['viewed'] = requestParameters.viewed;
        }

        if (requestParameters.sortBy !== undefined) {
            queryParameters['sortBy'] = requestParameters.sortBy;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/onboarding-pushes/{id}/recipients:search`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async searchApiControllerGetOnboardingPushRecipients(requestParameters: SearchApiControllerGetOnboardingPushRecipientsRequest): Promise<StoreOnboardingPushSearchResponse> {
        const response = await this.searchApiControllerGetOnboardingPushRecipientsRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async searchApiControllerGetOnboardingPushesRaw(requestParameters: SearchApiControllerGetOnboardingPushesRequest): Promise<runtime.ApiResponse<OnboardingPushSearchResponse>> {
        if (requestParameters.pageNo === null || requestParameters.pageNo === undefined) {
            throw new runtime.RequiredError('pageNo','Required parameter requestParameters.pageNo was null or undefined when calling searchApiControllerGetOnboardingPushes.');
        }

        if (requestParameters.pageSize === null || requestParameters.pageSize === undefined) {
            throw new runtime.RequiredError('pageSize','Required parameter requestParameters.pageSize was null or undefined when calling searchApiControllerGetOnboardingPushes.');
        }

        const queryParameters: any = {};

        if (requestParameters.pageNo !== undefined) {
            queryParameters['pageNo'] = requestParameters.pageNo;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['pageSize'] = requestParameters.pageSize;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.query !== undefined) {
            queryParameters['query'] = requestParameters.query;
        }

        if (requestParameters.id) {
            queryParameters['id'] = requestParameters.id;
        }

        if (requestParameters.sortBy !== undefined) {
            queryParameters['sortBy'] = requestParameters.sortBy;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/onboarding-pushes:search`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async searchApiControllerGetOnboardingPushes(requestParameters: SearchApiControllerGetOnboardingPushesRequest): Promise<OnboardingPushSearchResponse> {
        const response = await this.searchApiControllerGetOnboardingPushesRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async searchApiControllerRandomPickLiveStreamsViewersRaw(requestParameters: SearchApiControllerRandomPickLiveStreamsViewersRequest): Promise<runtime.ApiResponse<SearchLiveStreamUserStatsResponse>> {
        if (requestParameters.liveStreamId === null || requestParameters.liveStreamId === undefined) {
            throw new runtime.RequiredError('liveStreamId','Required parameter requestParameters.liveStreamId was null or undefined when calling searchApiControllerRandomPickLiveStreamsViewers.');
        }

        const queryParameters: any = {};

        if (requestParameters.name !== undefined) {
            queryParameters['name'] = requestParameters.name;
        }

        if (requestParameters.size !== undefined) {
            queryParameters['size'] = requestParameters.size;
        }

        if (requestParameters.userGroupId !== undefined) {
            queryParameters['userGroupId'] = requestParameters.userGroupId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/live-streams/{liveStreamId}/viewers:randomPick`.replace(`{${"liveStreamId"}}`, encodeURIComponent(String(requestParameters.liveStreamId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async searchApiControllerRandomPickLiveStreamsViewers(requestParameters: SearchApiControllerRandomPickLiveStreamsViewersRequest): Promise<SearchLiveStreamUserStatsResponse> {
        const response = await this.searchApiControllerRandomPickLiveStreamsViewersRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async searchApiControllerSearchRaw(requestParameters: SearchApiControllerSearchRequest): Promise<runtime.ApiResponse<StorePackageTemplatesSearchResponse>> {
        if (requestParameters.pageNo === null || requestParameters.pageNo === undefined) {
            throw new runtime.RequiredError('pageNo','Required parameter requestParameters.pageNo was null or undefined when calling searchApiControllerSearch.');
        }

        if (requestParameters.pageSize === null || requestParameters.pageSize === undefined) {
            throw new runtime.RequiredError('pageSize','Required parameter requestParameters.pageSize was null or undefined when calling searchApiControllerSearch.');
        }

        const queryParameters: any = {};

        if (requestParameters.pageNo !== undefined) {
            queryParameters['pageNo'] = requestParameters.pageNo;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['pageSize'] = requestParameters.pageSize;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.sortBy !== undefined) {
            queryParameters['sortBy'] = requestParameters.sortBy;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/store-package-templates:search`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async searchApiControllerSearch(requestParameters: SearchApiControllerSearchRequest): Promise<StorePackageTemplatesSearchResponse> {
        const response = await this.searchApiControllerSearchRaw(requestParameters);
        return await response.value();
    }

    /**
     * Public API
     */
    async searchApiControllerSearchAccountsRaw(requestParameters: SearchApiControllerSearchAccountsRequest): Promise<runtime.ApiResponse<SearchAccountsResponse>> {
        if (requestParameters.pageNo === null || requestParameters.pageNo === undefined) {
            throw new runtime.RequiredError('pageNo','Required parameter requestParameters.pageNo was null or undefined when calling searchApiControllerSearchAccounts.');
        }

        if (requestParameters.pageSize === null || requestParameters.pageSize === undefined) {
            throw new runtime.RequiredError('pageSize','Required parameter requestParameters.pageSize was null or undefined when calling searchApiControllerSearchAccounts.');
        }

        const queryParameters: any = {};

        if (requestParameters.pageNo !== undefined) {
            queryParameters['pageNo'] = requestParameters.pageNo;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['pageSize'] = requestParameters.pageSize;
        }

        if (requestParameters.query !== undefined) {
            queryParameters['query'] = requestParameters.query;
        }

        if (requestParameters.isSeller !== undefined) {
            queryParameters['isSeller'] = requestParameters.isSeller;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xPopPlatform !== undefined && requestParameters.xPopPlatform !== null) {
            headerParameters['x-pop-platform'] = String(requestParameters.xPopPlatform);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/accounts:search`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Public API
     */
    async searchApiControllerSearchAccounts(requestParameters: SearchApiControllerSearchAccountsRequest): Promise<SearchAccountsResponse> {
        const response = await this.searchApiControllerSearchAccountsRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async searchApiControllerSearchAgenciesRaw(requestParameters: SearchApiControllerSearchAgenciesRequest): Promise<runtime.ApiResponse<AgenciesSearchResponse>> {
        if (requestParameters.pageNo === null || requestParameters.pageNo === undefined) {
            throw new runtime.RequiredError('pageNo','Required parameter requestParameters.pageNo was null or undefined when calling searchApiControllerSearchAgencies.');
        }

        if (requestParameters.pageSize === null || requestParameters.pageSize === undefined) {
            throw new runtime.RequiredError('pageSize','Required parameter requestParameters.pageSize was null or undefined when calling searchApiControllerSearchAgencies.');
        }

        const queryParameters: any = {};

        if (requestParameters.pageNo !== undefined) {
            queryParameters['pageNo'] = requestParameters.pageNo;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['pageSize'] = requestParameters.pageSize;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.query !== undefined) {
            queryParameters['query'] = requestParameters.query;
        }

        if (requestParameters.id) {
            queryParameters['id'] = requestParameters.id;
        }

        if (requestParameters.status !== undefined) {
            queryParameters['status'] = requestParameters.status;
        }

        if (requestParameters.sortBy !== undefined) {
            queryParameters['sortBy'] = requestParameters.sortBy;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/agencies:search`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async searchApiControllerSearchAgencies(requestParameters: SearchApiControllerSearchAgenciesRequest): Promise<AgenciesSearchResponse> {
        const response = await this.searchApiControllerSearchAgenciesRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async searchApiControllerSearchAgencyUsersRaw(requestParameters: SearchApiControllerSearchAgencyUsersRequest): Promise<runtime.ApiResponse<AgencyUsersSearchResponse>> {
        if (requestParameters.agencyId === null || requestParameters.agencyId === undefined) {
            throw new runtime.RequiredError('agencyId','Required parameter requestParameters.agencyId was null or undefined when calling searchApiControllerSearchAgencyUsers.');
        }

        if (requestParameters.pageNo === null || requestParameters.pageNo === undefined) {
            throw new runtime.RequiredError('pageNo','Required parameter requestParameters.pageNo was null or undefined when calling searchApiControllerSearchAgencyUsers.');
        }

        if (requestParameters.pageSize === null || requestParameters.pageSize === undefined) {
            throw new runtime.RequiredError('pageSize','Required parameter requestParameters.pageSize was null or undefined when calling searchApiControllerSearchAgencyUsers.');
        }

        const queryParameters: any = {};

        if (requestParameters.pageNo !== undefined) {
            queryParameters['pageNo'] = requestParameters.pageNo;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['pageSize'] = requestParameters.pageSize;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.query !== undefined) {
            queryParameters['query'] = requestParameters.query;
        }

        if (requestParameters.id) {
            queryParameters['id'] = requestParameters.id;
        }

        if (requestParameters.agencyId2 !== undefined) {
            queryParameters['agencyId'] = requestParameters.agencyId2;
        }

        if (requestParameters.sortBy !== undefined) {
            queryParameters['sortBy'] = requestParameters.sortBy;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/agencies/{agencyId}/users:search`.replace(`{${"agencyId"}}`, encodeURIComponent(String(requestParameters.agencyId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async searchApiControllerSearchAgencyUsers(requestParameters: SearchApiControllerSearchAgencyUsersRequest): Promise<AgencyUsersSearchResponse> {
        const response = await this.searchApiControllerSearchAgencyUsersRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async searchApiControllerSearchAggregateLiveStreamUserStatsRaw(requestParameters: SearchApiControllerSearchAggregateLiveStreamUserStatsRequest): Promise<runtime.ApiResponse<SearchAggregateLiveStreamUserStatsResponse>> {
        if (requestParameters.liveStreamId === null || requestParameters.liveStreamId === undefined) {
            throw new runtime.RequiredError('liveStreamId','Required parameter requestParameters.liveStreamId was null or undefined when calling searchApiControllerSearchAggregateLiveStreamUserStats.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/live-streams/{liveStreamId}/user-stats:aggregate`.replace(`{${"liveStreamId"}}`, encodeURIComponent(String(requestParameters.liveStreamId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async searchApiControllerSearchAggregateLiveStreamUserStats(requestParameters: SearchApiControllerSearchAggregateLiveStreamUserStatsRequest): Promise<SearchAggregateLiveStreamUserStatsResponse> {
        const response = await this.searchApiControllerSearchAggregateLiveStreamUserStatsRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async searchApiControllerSearchAllStoresListingsRaw(requestParameters: SearchApiControllerSearchAllStoresListingsRequest): Promise<runtime.ApiResponse<MyStoreListingSearchResponse>> {
        if (requestParameters.pageNo === null || requestParameters.pageNo === undefined) {
            throw new runtime.RequiredError('pageNo','Required parameter requestParameters.pageNo was null or undefined when calling searchApiControllerSearchAllStoresListings.');
        }

        if (requestParameters.pageSize === null || requestParameters.pageSize === undefined) {
            throw new runtime.RequiredError('pageSize','Required parameter requestParameters.pageSize was null or undefined when calling searchApiControllerSearchAllStoresListings.');
        }

        const queryParameters: any = {};

        if (requestParameters.pageNo !== undefined) {
            queryParameters['pageNo'] = requestParameters.pageNo;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['pageSize'] = requestParameters.pageSize;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.id) {
            queryParameters['id'] = requestParameters.id;
        }

        if (requestParameters.type) {
            queryParameters['type'] = requestParameters.type;
        }

        if (requestParameters.excludeType) {
            queryParameters['excludeType'] = requestParameters.excludeType;
        }

        if (requestParameters.query !== undefined) {
            queryParameters['query'] = requestParameters.query;
        }

        if (requestParameters.status !== undefined) {
            queryParameters['status'] = requestParameters.status;
        }

        if (requestParameters.sellerId !== undefined) {
            queryParameters['sellerId'] = requestParameters.sellerId;
        }

        if (requestParameters.approverEmail !== undefined) {
            queryParameters['approverEmail'] = requestParameters.approverEmail;
        }

        if (requestParameters.approverName !== undefined) {
            queryParameters['approverName'] = requestParameters.approverName;
        }

        if (requestParameters.minCreatedAt !== undefined) {
            queryParameters['minCreatedAt'] = requestParameters.minCreatedAt;
        }

        if (requestParameters.maxCreatedAt !== undefined) {
            queryParameters['maxCreatedAt'] = requestParameters.maxCreatedAt;
        }

        if (requestParameters.moderationStatus !== undefined) {
            queryParameters['moderationStatus'] = requestParameters.moderationStatus;
        }

        if (requestParameters.sortBy !== undefined) {
            queryParameters['sortBy'] = requestParameters.sortBy;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/listings:search`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async searchApiControllerSearchAllStoresListings(requestParameters: SearchApiControllerSearchAllStoresListingsRequest): Promise<MyStoreListingSearchResponse> {
        const response = await this.searchApiControllerSearchAllStoresListingsRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async searchApiControllerSearchAnlsUsersStatsRaw(requestParameters: SearchApiControllerSearchAnlsUsersStatsRequest): Promise<runtime.ApiResponse<SearchAnlsUsersStatsResponse>> {
        if (requestParameters.pageNo === null || requestParameters.pageNo === undefined) {
            throw new runtime.RequiredError('pageNo','Required parameter requestParameters.pageNo was null or undefined when calling searchApiControllerSearchAnlsUsersStats.');
        }

        if (requestParameters.pageSize === null || requestParameters.pageSize === undefined) {
            throw new runtime.RequiredError('pageSize','Required parameter requestParameters.pageSize was null or undefined when calling searchApiControllerSearchAnlsUsersStats.');
        }

        const queryParameters: any = {};

        if (requestParameters.pageNo !== undefined) {
            queryParameters['pageNo'] = requestParameters.pageNo;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['pageSize'] = requestParameters.pageSize;
        }

        if (requestParameters.userIds) {
            queryParameters['userIds'] = requestParameters.userIds;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/user-stats:search`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async searchApiControllerSearchAnlsUsersStats(requestParameters: SearchApiControllerSearchAnlsUsersStatsRequest): Promise<SearchAnlsUsersStatsResponse> {
        const response = await this.searchApiControllerSearchAnlsUsersStatsRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async searchApiControllerSearchAppSellerApplicationsRaw(requestParameters: SearchApiControllerSearchAppSellerApplicationsRequest): Promise<runtime.ApiResponse<AppSellerApplicationsSearchResponse>> {
        if (requestParameters.pageNo === null || requestParameters.pageNo === undefined) {
            throw new runtime.RequiredError('pageNo','Required parameter requestParameters.pageNo was null or undefined when calling searchApiControllerSearchAppSellerApplications.');
        }

        if (requestParameters.pageSize === null || requestParameters.pageSize === undefined) {
            throw new runtime.RequiredError('pageSize','Required parameter requestParameters.pageSize was null or undefined when calling searchApiControllerSearchAppSellerApplications.');
        }

        const queryParameters: any = {};

        if (requestParameters.pageNo !== undefined) {
            queryParameters['pageNo'] = requestParameters.pageNo;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['pageSize'] = requestParameters.pageSize;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.sortBy !== undefined) {
            queryParameters['sortBy'] = requestParameters.sortBy;
        }

        if (requestParameters.storeType !== undefined) {
            queryParameters['storeType'] = requestParameters.storeType;
        }

        if (requestParameters.status !== undefined) {
            queryParameters['status'] = requestParameters.status;
        }

        if (requestParameters.phone !== undefined) {
            queryParameters['phone'] = requestParameters.phone;
        }

        if (requestParameters.query !== undefined) {
            queryParameters['query'] = requestParameters.query;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/app-seller-applications:search`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async searchApiControllerSearchAppSellerApplications(requestParameters: SearchApiControllerSearchAppSellerApplicationsRequest): Promise<AppSellerApplicationsSearchResponse> {
        const response = await this.searchApiControllerSearchAppSellerApplicationsRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async searchApiControllerSearchAvailableBillingCountryCodesRaw(): Promise<runtime.ApiResponse<SearchAvailableBillingCountryCodesResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/available-billing-country-codes:search`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async searchApiControllerSearchAvailableBillingCountryCodes(): Promise<SearchAvailableBillingCountryCodesResponse> {
        const response = await this.searchApiControllerSearchAvailableBillingCountryCodesRaw();
        return await response.value();
    }

    /**
     */
    async searchApiControllerSearchBadgeUsersRaw(requestParameters: SearchApiControllerSearchBadgeUsersRequest): Promise<runtime.ApiResponse<SearchBadgeUsersResponse>> {
        if (requestParameters.badgeId === null || requestParameters.badgeId === undefined) {
            throw new runtime.RequiredError('badgeId','Required parameter requestParameters.badgeId was null or undefined when calling searchApiControllerSearchBadgeUsers.');
        }

        if (requestParameters.pageNo === null || requestParameters.pageNo === undefined) {
            throw new runtime.RequiredError('pageNo','Required parameter requestParameters.pageNo was null or undefined when calling searchApiControllerSearchBadgeUsers.');
        }

        if (requestParameters.pageSize === null || requestParameters.pageSize === undefined) {
            throw new runtime.RequiredError('pageSize','Required parameter requestParameters.pageSize was null or undefined when calling searchApiControllerSearchBadgeUsers.');
        }

        const queryParameters: any = {};

        if (requestParameters.pageNo !== undefined) {
            queryParameters['pageNo'] = requestParameters.pageNo;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['pageSize'] = requestParameters.pageSize;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.id) {
            queryParameters['id'] = requestParameters.id;
        }

        if (requestParameters.query !== undefined) {
            queryParameters['query'] = requestParameters.query;
        }

        if (requestParameters.sortBy !== undefined) {
            queryParameters['sortBy'] = requestParameters.sortBy;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/badges/{badgeId}/users:search`.replace(`{${"badgeId"}}`, encodeURIComponent(String(requestParameters.badgeId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async searchApiControllerSearchBadgeUsers(requestParameters: SearchApiControllerSearchBadgeUsersRequest): Promise<SearchBadgeUsersResponse> {
        const response = await this.searchApiControllerSearchBadgeUsersRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async searchApiControllerSearchBadgesRaw(requestParameters: SearchApiControllerSearchBadgesRequest): Promise<runtime.ApiResponse<SearchBadgesResponse>> {
        if (requestParameters.pageNo === null || requestParameters.pageNo === undefined) {
            throw new runtime.RequiredError('pageNo','Required parameter requestParameters.pageNo was null or undefined when calling searchApiControllerSearchBadges.');
        }

        if (requestParameters.pageSize === null || requestParameters.pageSize === undefined) {
            throw new runtime.RequiredError('pageSize','Required parameter requestParameters.pageSize was null or undefined when calling searchApiControllerSearchBadges.');
        }

        const queryParameters: any = {};

        if (requestParameters.pageNo !== undefined) {
            queryParameters['pageNo'] = requestParameters.pageNo;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['pageSize'] = requestParameters.pageSize;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.id) {
            queryParameters['id'] = requestParameters.id;
        }

        if (requestParameters.storeIds) {
            queryParameters['storeIds'] = requestParameters.storeIds;
        }

        if (requestParameters.query !== undefined) {
            queryParameters['query'] = requestParameters.query;
        }

        if (requestParameters.status) {
            queryParameters['status'] = requestParameters.status;
        }

        if (requestParameters.sortBy !== undefined) {
            queryParameters['sortBy'] = requestParameters.sortBy;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/badges:search`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async searchApiControllerSearchBadges(requestParameters: SearchApiControllerSearchBadgesRequest): Promise<SearchBadgesResponse> {
        const response = await this.searchApiControllerSearchBadgesRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async searchApiControllerSearchBadgesByUserIdRaw(requestParameters: SearchApiControllerSearchBadgesByUserIdRequest): Promise<runtime.ApiResponse<SearchBadgeUsersResponse>> {
        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling searchApiControllerSearchBadgesByUserId.');
        }

        if (requestParameters.pageNo === null || requestParameters.pageNo === undefined) {
            throw new runtime.RequiredError('pageNo','Required parameter requestParameters.pageNo was null or undefined when calling searchApiControllerSearchBadgesByUserId.');
        }

        if (requestParameters.pageSize === null || requestParameters.pageSize === undefined) {
            throw new runtime.RequiredError('pageSize','Required parameter requestParameters.pageSize was null or undefined when calling searchApiControllerSearchBadgesByUserId.');
        }

        const queryParameters: any = {};

        if (requestParameters.pageNo !== undefined) {
            queryParameters['pageNo'] = requestParameters.pageNo;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['pageSize'] = requestParameters.pageSize;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.id) {
            queryParameters['id'] = requestParameters.id;
        }

        if (requestParameters.query !== undefined) {
            queryParameters['query'] = requestParameters.query;
        }

        if (requestParameters.sortBy !== undefined) {
            queryParameters['sortBy'] = requestParameters.sortBy;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/users/{userId}/badges:search`.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async searchApiControllerSearchBadgesByUserId(requestParameters: SearchApiControllerSearchBadgesByUserIdRequest): Promise<SearchBadgeUsersResponse> {
        const response = await this.searchApiControllerSearchBadgesByUserIdRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async searchApiControllerSearchCampaignsRaw(requestParameters: SearchApiControllerSearchCampaignsRequest): Promise<runtime.ApiResponse<CampaignsSearchResponse>> {
        if (requestParameters.pageNo === null || requestParameters.pageNo === undefined) {
            throw new runtime.RequiredError('pageNo','Required parameter requestParameters.pageNo was null or undefined when calling searchApiControllerSearchCampaigns.');
        }

        if (requestParameters.pageSize === null || requestParameters.pageSize === undefined) {
            throw new runtime.RequiredError('pageSize','Required parameter requestParameters.pageSize was null or undefined when calling searchApiControllerSearchCampaigns.');
        }

        const queryParameters: any = {};

        if (requestParameters.pageNo !== undefined) {
            queryParameters['pageNo'] = requestParameters.pageNo;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['pageSize'] = requestParameters.pageSize;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.isActive !== undefined) {
            queryParameters['isActive'] = requestParameters.isActive;
        }

        if (requestParameters.sortBy !== undefined) {
            queryParameters['sortBy'] = requestParameters.sortBy;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/campaigns:search`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async searchApiControllerSearchCampaigns(requestParameters: SearchApiControllerSearchCampaignsRequest): Promise<CampaignsSearchResponse> {
        const response = await this.searchApiControllerSearchCampaignsRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async searchApiControllerSearchCategoriesRaw(requestParameters: SearchApiControllerSearchCategoriesRequest): Promise<runtime.ApiResponse<CategoriesSearchResponse>> {
        if (requestParameters.pageNo === null || requestParameters.pageNo === undefined) {
            throw new runtime.RequiredError('pageNo','Required parameter requestParameters.pageNo was null or undefined when calling searchApiControllerSearchCategories.');
        }

        if (requestParameters.pageSize === null || requestParameters.pageSize === undefined) {
            throw new runtime.RequiredError('pageSize','Required parameter requestParameters.pageSize was null or undefined when calling searchApiControllerSearchCategories.');
        }

        const queryParameters: any = {};

        if (requestParameters.pageNo !== undefined) {
            queryParameters['pageNo'] = requestParameters.pageNo;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['pageSize'] = requestParameters.pageSize;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.id) {
            queryParameters['id'] = requestParameters.id;
        }

        if (requestParameters.enabled !== undefined) {
            queryParameters['enabled'] = requestParameters.enabled;
        }

        if (requestParameters.query !== undefined) {
            queryParameters['query'] = requestParameters.query;
        }

        if (requestParameters.rootCategory !== undefined) {
            queryParameters['rootCategory'] = requestParameters.rootCategory;
        }

        if (requestParameters.sortBy !== undefined) {
            queryParameters['sortBy'] = requestParameters.sortBy;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/categories:search`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async searchApiControllerSearchCategories(requestParameters: SearchApiControllerSearchCategoriesRequest): Promise<CategoriesSearchResponse> {
        const response = await this.searchApiControllerSearchCategoriesRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async searchApiControllerSearchCategorizedResourcesRaw(requestParameters: SearchApiControllerSearchCategorizedResourcesRequest): Promise<runtime.ApiResponse<CategorizedResourcesSearchResponse>> {
        if (requestParameters.pageNo === null || requestParameters.pageNo === undefined) {
            throw new runtime.RequiredError('pageNo','Required parameter requestParameters.pageNo was null or undefined when calling searchApiControllerSearchCategorizedResources.');
        }

        if (requestParameters.pageSize === null || requestParameters.pageSize === undefined) {
            throw new runtime.RequiredError('pageSize','Required parameter requestParameters.pageSize was null or undefined when calling searchApiControllerSearchCategorizedResources.');
        }

        const queryParameters: any = {};

        if (requestParameters.pageNo !== undefined) {
            queryParameters['pageNo'] = requestParameters.pageNo;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['pageSize'] = requestParameters.pageSize;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.query !== undefined) {
            queryParameters['query'] = requestParameters.query;
        }

        if (requestParameters.categoryId !== undefined) {
            queryParameters['categoryId'] = requestParameters.categoryId;
        }

        if (requestParameters.storeId !== undefined) {
            queryParameters['storeId'] = requestParameters.storeId;
        }

        if (requestParameters.userId !== undefined) {
            queryParameters['userId'] = requestParameters.userId;
        }

        if (requestParameters.liveStreamId !== undefined) {
            queryParameters['liveStreamId'] = requestParameters.liveStreamId;
        }

        if (requestParameters.upcomingShowId !== undefined) {
            queryParameters['upcomingShowId'] = requestParameters.upcomingShowId;
        }

        if (requestParameters.resourceType !== undefined) {
            queryParameters['resourceType'] = requestParameters.resourceType;
        }

        if (requestParameters.sortBy !== undefined) {
            queryParameters['sortBy'] = requestParameters.sortBy;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/categorized-resources:search`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async searchApiControllerSearchCategorizedResources(requestParameters: SearchApiControllerSearchCategorizedResourcesRequest): Promise<CategorizedResourcesSearchResponse> {
        const response = await this.searchApiControllerSearchCategorizedResourcesRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async searchApiControllerSearchCategoryDiscoveryRowCategorizedResourcesRaw(requestParameters: SearchApiControllerSearchCategoryDiscoveryRowCategorizedResourcesRequest): Promise<runtime.ApiResponse<CategorizedResourcesSearchResponse>> {
        if (requestParameters.categoryRowId === null || requestParameters.categoryRowId === undefined) {
            throw new runtime.RequiredError('categoryRowId','Required parameter requestParameters.categoryRowId was null or undefined when calling searchApiControllerSearchCategoryDiscoveryRowCategorizedResources.');
        }

        if (requestParameters.pageNo === null || requestParameters.pageNo === undefined) {
            throw new runtime.RequiredError('pageNo','Required parameter requestParameters.pageNo was null or undefined when calling searchApiControllerSearchCategoryDiscoveryRowCategorizedResources.');
        }

        if (requestParameters.pageSize === null || requestParameters.pageSize === undefined) {
            throw new runtime.RequiredError('pageSize','Required parameter requestParameters.pageSize was null or undefined when calling searchApiControllerSearchCategoryDiscoveryRowCategorizedResources.');
        }

        const queryParameters: any = {};

        if (requestParameters.pageNo !== undefined) {
            queryParameters['pageNo'] = requestParameters.pageNo;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['pageSize'] = requestParameters.pageSize;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.query !== undefined) {
            queryParameters['query'] = requestParameters.query;
        }

        if (requestParameters.categoryId !== undefined) {
            queryParameters['categoryId'] = requestParameters.categoryId;
        }

        if (requestParameters.storeId !== undefined) {
            queryParameters['storeId'] = requestParameters.storeId;
        }

        if (requestParameters.userId !== undefined) {
            queryParameters['userId'] = requestParameters.userId;
        }

        if (requestParameters.liveStreamId !== undefined) {
            queryParameters['liveStreamId'] = requestParameters.liveStreamId;
        }

        if (requestParameters.upcomingShowId !== undefined) {
            queryParameters['upcomingShowId'] = requestParameters.upcomingShowId;
        }

        if (requestParameters.resourceType !== undefined) {
            queryParameters['resourceType'] = requestParameters.resourceType;
        }

        if (requestParameters.sortBy !== undefined) {
            queryParameters['sortBy'] = requestParameters.sortBy;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/category-discovery-rows/{categoryRowId}/categorized-resources:search`.replace(`{${"categoryRowId"}}`, encodeURIComponent(String(requestParameters.categoryRowId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async searchApiControllerSearchCategoryDiscoveryRowCategorizedResources(requestParameters: SearchApiControllerSearchCategoryDiscoveryRowCategorizedResourcesRequest): Promise<CategorizedResourcesSearchResponse> {
        const response = await this.searchApiControllerSearchCategoryDiscoveryRowCategorizedResourcesRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async searchApiControllerSearchCategoryDiscoveryRowsRaw(requestParameters: SearchApiControllerSearchCategoryDiscoveryRowsRequest): Promise<runtime.ApiResponse<SearchCategoryDiscoveryRowsResponse>> {
        if (requestParameters.pageNo === null || requestParameters.pageNo === undefined) {
            throw new runtime.RequiredError('pageNo','Required parameter requestParameters.pageNo was null or undefined when calling searchApiControllerSearchCategoryDiscoveryRows.');
        }

        if (requestParameters.pageSize === null || requestParameters.pageSize === undefined) {
            throw new runtime.RequiredError('pageSize','Required parameter requestParameters.pageSize was null or undefined when calling searchApiControllerSearchCategoryDiscoveryRows.');
        }

        const queryParameters: any = {};

        if (requestParameters.pageNo !== undefined) {
            queryParameters['pageNo'] = requestParameters.pageNo;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['pageSize'] = requestParameters.pageSize;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.id) {
            queryParameters['id'] = requestParameters.id;
        }

        if (requestParameters.categoryIds) {
            queryParameters['categoryIds'] = requestParameters.categoryIds;
        }

        if (requestParameters.query !== undefined) {
            queryParameters['query'] = requestParameters.query;
        }

        if (requestParameters.enabled !== undefined) {
            queryParameters['enabled'] = requestParameters.enabled;
        }

        if (requestParameters.sortBy !== undefined) {
            queryParameters['sortBy'] = requestParameters.sortBy;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/category-discovery-rows:search`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async searchApiControllerSearchCategoryDiscoveryRows(requestParameters: SearchApiControllerSearchCategoryDiscoveryRowsRequest): Promise<SearchCategoryDiscoveryRowsResponse> {
        const response = await this.searchApiControllerSearchCategoryDiscoveryRowsRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async searchApiControllerSearchCategoryRowFeaturedStoresRaw(requestParameters: SearchApiControllerSearchCategoryRowFeaturedStoresRequest): Promise<runtime.ApiResponse<FeaturedStoresSearchResponse>> {
        if (requestParameters.categoryRowId === null || requestParameters.categoryRowId === undefined) {
            throw new runtime.RequiredError('categoryRowId','Required parameter requestParameters.categoryRowId was null or undefined when calling searchApiControllerSearchCategoryRowFeaturedStores.');
        }

        if (requestParameters.pageNo === null || requestParameters.pageNo === undefined) {
            throw new runtime.RequiredError('pageNo','Required parameter requestParameters.pageNo was null or undefined when calling searchApiControllerSearchCategoryRowFeaturedStores.');
        }

        if (requestParameters.pageSize === null || requestParameters.pageSize === undefined) {
            throw new runtime.RequiredError('pageSize','Required parameter requestParameters.pageSize was null or undefined when calling searchApiControllerSearchCategoryRowFeaturedStores.');
        }

        const queryParameters: any = {};

        if (requestParameters.pageNo !== undefined) {
            queryParameters['pageNo'] = requestParameters.pageNo;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['pageSize'] = requestParameters.pageSize;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.sortBy !== undefined) {
            queryParameters['sortBy'] = requestParameters.sortBy;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/category-rows/{categoryRowId}/featured-stores:search`.replace(`{${"categoryRowId"}}`, encodeURIComponent(String(requestParameters.categoryRowId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async searchApiControllerSearchCategoryRowFeaturedStores(requestParameters: SearchApiControllerSearchCategoryRowFeaturedStoresRequest): Promise<FeaturedStoresSearchResponse> {
        const response = await this.searchApiControllerSearchCategoryRowFeaturedStoresRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async searchApiControllerSearchCommunityWaitlistUsersRaw(requestParameters: SearchApiControllerSearchCommunityWaitlistUsersRequest): Promise<runtime.ApiResponse<SearchCommunityWaitlistUsersResponse>> {
        if (requestParameters.pageNo === null || requestParameters.pageNo === undefined) {
            throw new runtime.RequiredError('pageNo','Required parameter requestParameters.pageNo was null or undefined when calling searchApiControllerSearchCommunityWaitlistUsers.');
        }

        if (requestParameters.pageSize === null || requestParameters.pageSize === undefined) {
            throw new runtime.RequiredError('pageSize','Required parameter requestParameters.pageSize was null or undefined when calling searchApiControllerSearchCommunityWaitlistUsers.');
        }

        const queryParameters: any = {};

        if (requestParameters.pageNo !== undefined) {
            queryParameters['pageNo'] = requestParameters.pageNo;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['pageSize'] = requestParameters.pageSize;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.sortBy !== undefined) {
            queryParameters['sortBy'] = requestParameters.sortBy;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/community-waitlist-users:search`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async searchApiControllerSearchCommunityWaitlistUsers(requestParameters: SearchApiControllerSearchCommunityWaitlistUsersRequest): Promise<SearchCommunityWaitlistUsersResponse> {
        const response = await this.searchApiControllerSearchCommunityWaitlistUsersRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async searchApiControllerSearchCouponsRaw(requestParameters: SearchApiControllerSearchCouponsRequest): Promise<runtime.ApiResponse<CouponsSearchResponse>> {
        if (requestParameters.pageNo === null || requestParameters.pageNo === undefined) {
            throw new runtime.RequiredError('pageNo','Required parameter requestParameters.pageNo was null or undefined when calling searchApiControllerSearchCoupons.');
        }

        if (requestParameters.pageSize === null || requestParameters.pageSize === undefined) {
            throw new runtime.RequiredError('pageSize','Required parameter requestParameters.pageSize was null or undefined when calling searchApiControllerSearchCoupons.');
        }

        const queryParameters: any = {};

        if (requestParameters.pageNo !== undefined) {
            queryParameters['pageNo'] = requestParameters.pageNo;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['pageSize'] = requestParameters.pageSize;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.query !== undefined) {
            queryParameters['query'] = requestParameters.query;
        }

        if (requestParameters.storeName !== undefined) {
            queryParameters['storeName'] = requestParameters.storeName;
        }

        if (requestParameters.active !== undefined) {
            queryParameters['active'] = requestParameters.active;
        }

        if (requestParameters.couponCreateMethod !== undefined) {
            queryParameters['couponCreateMethod'] = requestParameters.couponCreateMethod;
        }

        if (requestParameters.sortBy !== undefined) {
            queryParameters['sortBy'] = requestParameters.sortBy;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/coupons:search`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async searchApiControllerSearchCoupons(requestParameters: SearchApiControllerSearchCouponsRequest): Promise<CouponsSearchResponse> {
        const response = await this.searchApiControllerSearchCouponsRaw(requestParameters);
        return await response.value();
    }

    /**
     * Public API
     */
    async searchApiControllerSearchCreatedGiveawaysRaw(requestParameters: SearchApiControllerSearchCreatedGiveawaysRequest): Promise<runtime.ApiResponse<SearchCreatedGiveawaysResponse>> {
        const queryParameters: any = {};

        if (requestParameters.userId !== undefined) {
            queryParameters['userId'] = requestParameters.userId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/giveaways/created:search`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Public API
     */
    async searchApiControllerSearchCreatedGiveaways(requestParameters: SearchApiControllerSearchCreatedGiveawaysRequest): Promise<SearchCreatedGiveawaysResponse> {
        const response = await this.searchApiControllerSearchCreatedGiveawaysRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async searchApiControllerSearchFeaturedShowsRaw(requestParameters: SearchApiControllerSearchFeaturedShowsRequest): Promise<runtime.ApiResponse<FeaturedShowSearchResponse>> {
        if (requestParameters.pageNo === null || requestParameters.pageNo === undefined) {
            throw new runtime.RequiredError('pageNo','Required parameter requestParameters.pageNo was null or undefined when calling searchApiControllerSearchFeaturedShows.');
        }

        if (requestParameters.pageSize === null || requestParameters.pageSize === undefined) {
            throw new runtime.RequiredError('pageSize','Required parameter requestParameters.pageSize was null or undefined when calling searchApiControllerSearchFeaturedShows.');
        }

        const queryParameters: any = {};

        if (requestParameters.pageNo !== undefined) {
            queryParameters['pageNo'] = requestParameters.pageNo;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['pageSize'] = requestParameters.pageSize;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.id) {
            queryParameters['id'] = requestParameters.id;
        }

        if (requestParameters.query !== undefined) {
            queryParameters['query'] = requestParameters.query;
        }

        if (requestParameters.active !== undefined) {
            queryParameters['active'] = requestParameters.active;
        }

        if (requestParameters.autoFeaturedStoreShow !== undefined) {
            queryParameters['autoFeaturedStoreShow'] = requestParameters.autoFeaturedStoreShow;
        }

        if (requestParameters.filterOutExpiredUpcomingShows !== undefined) {
            queryParameters['filterOutExpiredUpcomingShows'] = requestParameters.filterOutExpiredUpcomingShows;
        }

        if (requestParameters.filterOutLiveLiveStreams !== undefined) {
            queryParameters['filterOutLiveLiveStreams'] = requestParameters.filterOutLiveLiveStreams;
        }

        if (requestParameters.minSortedAt !== undefined) {
            queryParameters['minSortedAt'] = requestParameters.minSortedAt;
        }

        if (requestParameters.type) {
            queryParameters['type'] = requestParameters.type;
        }

        if (requestParameters.sortBy !== undefined) {
            queryParameters['sortBy'] = requestParameters.sortBy;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/featured-shows:search`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async searchApiControllerSearchFeaturedShows(requestParameters: SearchApiControllerSearchFeaturedShowsRequest): Promise<FeaturedShowSearchResponse> {
        const response = await this.searchApiControllerSearchFeaturedShowsRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async searchApiControllerSearchFeaturedStoresRaw(requestParameters: SearchApiControllerSearchFeaturedStoresRequest): Promise<runtime.ApiResponse<FeaturedStoresSearchResponse>> {
        if (requestParameters.pageNo === null || requestParameters.pageNo === undefined) {
            throw new runtime.RequiredError('pageNo','Required parameter requestParameters.pageNo was null or undefined when calling searchApiControllerSearchFeaturedStores.');
        }

        if (requestParameters.pageSize === null || requestParameters.pageSize === undefined) {
            throw new runtime.RequiredError('pageSize','Required parameter requestParameters.pageSize was null or undefined when calling searchApiControllerSearchFeaturedStores.');
        }

        const queryParameters: any = {};

        if (requestParameters.pageNo !== undefined) {
            queryParameters['pageNo'] = requestParameters.pageNo;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['pageSize'] = requestParameters.pageSize;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.sortBy !== undefined) {
            queryParameters['sortBy'] = requestParameters.sortBy;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/featured-stores:search`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async searchApiControllerSearchFeaturedStores(requestParameters: SearchApiControllerSearchFeaturedStoresRequest): Promise<FeaturedStoresSearchResponse> {
        const response = await this.searchApiControllerSearchFeaturedStoresRaw(requestParameters);
        return await response.value();
    }

    /**
     * Use /v2/public-listings[:]search instead
     * Public API
     */
    async searchApiControllerSearchFeaturedStoresPublicListingsRaw(requestParameters: SearchApiControllerSearchFeaturedStoresPublicListingsRequest): Promise<runtime.ApiResponse<FeaturedStorePublicListingSearchResponse>> {
        if (requestParameters.pageNo === null || requestParameters.pageNo === undefined) {
            throw new runtime.RequiredError('pageNo','Required parameter requestParameters.pageNo was null or undefined when calling searchApiControllerSearchFeaturedStoresPublicListings.');
        }

        if (requestParameters.pageSize === null || requestParameters.pageSize === undefined) {
            throw new runtime.RequiredError('pageSize','Required parameter requestParameters.pageSize was null or undefined when calling searchApiControllerSearchFeaturedStoresPublicListings.');
        }

        const queryParameters: any = {};

        if (requestParameters.pageNo !== undefined) {
            queryParameters['pageNo'] = requestParameters.pageNo;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['pageSize'] = requestParameters.pageSize;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.id) {
            queryParameters['id'] = requestParameters.id;
        }

        if (requestParameters.query !== undefined) {
            queryParameters['query'] = requestParameters.query;
        }

        if (requestParameters.minQuantity !== undefined) {
            queryParameters['minQuantity'] = requestParameters.minQuantity;
        }

        if (requestParameters.featured !== undefined) {
            queryParameters['featured'] = requestParameters.featured;
        }

        if (requestParameters.sortBy !== undefined) {
            queryParameters['sortBy'] = requestParameters.sortBy;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/featured-stores/public-listings:search`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Use /v2/public-listings[:]search instead
     * Public API
     */
    async searchApiControllerSearchFeaturedStoresPublicListings(requestParameters: SearchApiControllerSearchFeaturedStoresPublicListingsRequest): Promise<FeaturedStorePublicListingSearchResponse> {
        const response = await this.searchApiControllerSearchFeaturedStoresPublicListingsRaw(requestParameters);
        return await response.value();
    }

    /**
     * Public API
     */
    async searchApiControllerSearchFeaturedTagsRaw(requestParameters: SearchApiControllerSearchFeaturedTagsRequest): Promise<runtime.ApiResponse<SearchFeaturedTagsResponse>> {
        if (requestParameters.pageNo === null || requestParameters.pageNo === undefined) {
            throw new runtime.RequiredError('pageNo','Required parameter requestParameters.pageNo was null or undefined when calling searchApiControllerSearchFeaturedTags.');
        }

        if (requestParameters.pageSize === null || requestParameters.pageSize === undefined) {
            throw new runtime.RequiredError('pageSize','Required parameter requestParameters.pageSize was null or undefined when calling searchApiControllerSearchFeaturedTags.');
        }

        const queryParameters: any = {};

        if (requestParameters.pageNo !== undefined) {
            queryParameters['pageNo'] = requestParameters.pageNo;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['pageSize'] = requestParameters.pageSize;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.sortBy !== undefined) {
            queryParameters['sortBy'] = requestParameters.sortBy;
        }

        if (requestParameters.query !== undefined) {
            queryParameters['query'] = requestParameters.query;
        }

        if (requestParameters.ids) {
            queryParameters['ids'] = requestParameters.ids;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/featured-tags:search`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Public API
     */
    async searchApiControllerSearchFeaturedTags(requestParameters: SearchApiControllerSearchFeaturedTagsRequest): Promise<SearchFeaturedTagsResponse> {
        const response = await this.searchApiControllerSearchFeaturedTagsRaw(requestParameters);
        return await response.value();
    }

    /**
     * Public API
     */
    async searchApiControllerSearchFinishedGiveawaysRaw(requestParameters: SearchApiControllerSearchFinishedGiveawaysRequest): Promise<runtime.ApiResponse<SearchPastFinishedGiveawaysResponse>> {
        if (requestParameters.size === null || requestParameters.size === undefined) {
            throw new runtime.RequiredError('size','Required parameter requestParameters.size was null or undefined when calling searchApiControllerSearchFinishedGiveaways.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/giveaways/finished:search`.replace(`{${"size"}}`, encodeURIComponent(String(requestParameters.size))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Public API
     */
    async searchApiControllerSearchFinishedGiveaways(requestParameters: SearchApiControllerSearchFinishedGiveawaysRequest): Promise<SearchPastFinishedGiveawaysResponse> {
        const response = await this.searchApiControllerSearchFinishedGiveawaysRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async searchApiControllerSearchGiveawaysBySellerRaw(requestParameters: SearchApiControllerSearchGiveawaysBySellerRequest): Promise<runtime.ApiResponse<SearchSellerGiveawayResponse>> {
        if (requestParameters.sellerId === null || requestParameters.sellerId === undefined) {
            throw new runtime.RequiredError('sellerId','Required parameter requestParameters.sellerId was null or undefined when calling searchApiControllerSearchGiveawaysBySeller.');
        }

        if (requestParameters.pageNo === null || requestParameters.pageNo === undefined) {
            throw new runtime.RequiredError('pageNo','Required parameter requestParameters.pageNo was null or undefined when calling searchApiControllerSearchGiveawaysBySeller.');
        }

        if (requestParameters.pageSize === null || requestParameters.pageSize === undefined) {
            throw new runtime.RequiredError('pageSize','Required parameter requestParameters.pageSize was null or undefined when calling searchApiControllerSearchGiveawaysBySeller.');
        }

        const queryParameters: any = {};

        if (requestParameters.pageNo !== undefined) {
            queryParameters['pageNo'] = requestParameters.pageNo;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['pageSize'] = requestParameters.pageSize;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.source !== undefined) {
            queryParameters['source'] = requestParameters.source;
        }

        if (requestParameters.showId !== undefined) {
            queryParameters['showId'] = requestParameters.showId;
        }

        if (requestParameters.sortBy !== undefined) {
            queryParameters['sortBy'] = requestParameters.sortBy;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/stores/{sellerId}/giveaways:search`.replace(`{${"sellerId"}}`, encodeURIComponent(String(requestParameters.sellerId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async searchApiControllerSearchGiveawaysBySeller(requestParameters: SearchApiControllerSearchGiveawaysBySellerRequest): Promise<SearchSellerGiveawayResponse> {
        const response = await this.searchApiControllerSearchGiveawaysBySellerRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async searchApiControllerSearchGiveawaysByUserRaw(requestParameters: SearchApiControllerSearchGiveawaysByUserRequest): Promise<runtime.ApiResponse<SearchUserGiveawayResponse>> {
        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling searchApiControllerSearchGiveawaysByUser.');
        }

        if (requestParameters.pageNo === null || requestParameters.pageNo === undefined) {
            throw new runtime.RequiredError('pageNo','Required parameter requestParameters.pageNo was null or undefined when calling searchApiControllerSearchGiveawaysByUser.');
        }

        if (requestParameters.pageSize === null || requestParameters.pageSize === undefined) {
            throw new runtime.RequiredError('pageSize','Required parameter requestParameters.pageSize was null or undefined when calling searchApiControllerSearchGiveawaysByUser.');
        }

        const queryParameters: any = {};

        if (requestParameters.pageNo !== undefined) {
            queryParameters['pageNo'] = requestParameters.pageNo;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['pageSize'] = requestParameters.pageSize;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/users/{userId}/giveaways:search`.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async searchApiControllerSearchGiveawaysByUser(requestParameters: SearchApiControllerSearchGiveawaysByUserRequest): Promise<SearchUserGiveawayResponse> {
        const response = await this.searchApiControllerSearchGiveawaysByUserRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async searchApiControllerSearchGoogleProductCategoriesRaw(requestParameters: SearchApiControllerSearchGoogleProductCategoriesRequest): Promise<runtime.ApiResponse<GoogleProductCategoriesSearchResponse>> {
        if (requestParameters.pageNo === null || requestParameters.pageNo === undefined) {
            throw new runtime.RequiredError('pageNo','Required parameter requestParameters.pageNo was null or undefined when calling searchApiControllerSearchGoogleProductCategories.');
        }

        if (requestParameters.pageSize === null || requestParameters.pageSize === undefined) {
            throw new runtime.RequiredError('pageSize','Required parameter requestParameters.pageSize was null or undefined when calling searchApiControllerSearchGoogleProductCategories.');
        }

        const queryParameters: any = {};

        if (requestParameters.pageNo !== undefined) {
            queryParameters['pageNo'] = requestParameters.pageNo;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['pageSize'] = requestParameters.pageSize;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.query !== undefined) {
            queryParameters['query'] = requestParameters.query;
        }

        if (requestParameters.id) {
            queryParameters['id'] = requestParameters.id;
        }

        if (requestParameters.parentId !== undefined) {
            queryParameters['parentId'] = requestParameters.parentId;
        }

        if (requestParameters.isRoot !== undefined) {
            queryParameters['isRoot'] = requestParameters.isRoot;
        }

        if (requestParameters.enabled !== undefined) {
            queryParameters['enabled'] = requestParameters.enabled;
        }

        if (requestParameters.sortBy !== undefined) {
            queryParameters['sortBy'] = requestParameters.sortBy;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/google-product-categories:search`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async searchApiControllerSearchGoogleProductCategories(requestParameters: SearchApiControllerSearchGoogleProductCategoriesRequest): Promise<GoogleProductCategoriesSearchResponse> {
        const response = await this.searchApiControllerSearchGoogleProductCategoriesRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async searchApiControllerSearchIncentivePayoutsRaw(requestParameters: SearchApiControllerSearchIncentivePayoutsRequest): Promise<runtime.ApiResponse<StoreIncentivePayoutSearchResponse>> {
        if (requestParameters.pageNo === null || requestParameters.pageNo === undefined) {
            throw new runtime.RequiredError('pageNo','Required parameter requestParameters.pageNo was null or undefined when calling searchApiControllerSearchIncentivePayouts.');
        }

        if (requestParameters.pageSize === null || requestParameters.pageSize === undefined) {
            throw new runtime.RequiredError('pageSize','Required parameter requestParameters.pageSize was null or undefined when calling searchApiControllerSearchIncentivePayouts.');
        }

        const queryParameters: any = {};

        if (requestParameters.pageNo !== undefined) {
            queryParameters['pageNo'] = requestParameters.pageNo;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['pageSize'] = requestParameters.pageSize;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.id) {
            queryParameters['id'] = requestParameters.id;
        }

        if (requestParameters.query !== undefined) {
            queryParameters['query'] = requestParameters.query;
        }

        if (requestParameters.status !== undefined) {
            queryParameters['status'] = requestParameters.status;
        }

        if (requestParameters.minCreatedAt !== undefined) {
            queryParameters['minCreatedAt'] = requestParameters.minCreatedAt;
        }

        if (requestParameters.maxCreatedAt !== undefined) {
            queryParameters['maxCreatedAt'] = requestParameters.maxCreatedAt;
        }

        if (requestParameters.sortBy !== undefined) {
            queryParameters['sortBy'] = requestParameters.sortBy;
        }

        if (requestParameters.sellerId !== undefined) {
            queryParameters['sellerId'] = requestParameters.sellerId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/incentive-payouts:search`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async searchApiControllerSearchIncentivePayouts(requestParameters: SearchApiControllerSearchIncentivePayoutsRequest): Promise<StoreIncentivePayoutSearchResponse> {
        const response = await this.searchApiControllerSearchIncentivePayoutsRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async searchApiControllerSearchLinksRaw(requestParameters: SearchApiControllerSearchLinksRequest): Promise<runtime.ApiResponse<LinksSearchResponse>> {
        if (requestParameters.pageNo === null || requestParameters.pageNo === undefined) {
            throw new runtime.RequiredError('pageNo','Required parameter requestParameters.pageNo was null or undefined when calling searchApiControllerSearchLinks.');
        }

        if (requestParameters.pageSize === null || requestParameters.pageSize === undefined) {
            throw new runtime.RequiredError('pageSize','Required parameter requestParameters.pageSize was null or undefined when calling searchApiControllerSearchLinks.');
        }

        const queryParameters: any = {};

        if (requestParameters.pageNo !== undefined) {
            queryParameters['pageNo'] = requestParameters.pageNo;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['pageSize'] = requestParameters.pageSize;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.isActive !== undefined) {
            queryParameters['isActive'] = requestParameters.isActive;
        }

        if (requestParameters.type !== undefined) {
            queryParameters['type'] = requestParameters.type;
        }

        if (requestParameters.shareTargetType) {
            queryParameters['shareTargetType'] = requestParameters.shareTargetType;
        }

        if (requestParameters.query !== undefined) {
            queryParameters['query'] = requestParameters.query;
        }

        if (requestParameters.sortBy !== undefined) {
            queryParameters['sortBy'] = requestParameters.sortBy;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/links:search`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async searchApiControllerSearchLinks(requestParameters: SearchApiControllerSearchLinksRequest): Promise<LinksSearchResponse> {
        const response = await this.searchApiControllerSearchLinksRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async searchApiControllerSearchLiveStreamAudiencesRaw(requestParameters: SearchApiControllerSearchLiveStreamAudiencesRequest): Promise<runtime.ApiResponse<LiveStreamAudiencesSearchResponse>> {
        if (requestParameters.liveStreamId === null || requestParameters.liveStreamId === undefined) {
            throw new runtime.RequiredError('liveStreamId','Required parameter requestParameters.liveStreamId was null or undefined when calling searchApiControllerSearchLiveStreamAudiences.');
        }

        if (requestParameters.pageNo === null || requestParameters.pageNo === undefined) {
            throw new runtime.RequiredError('pageNo','Required parameter requestParameters.pageNo was null or undefined when calling searchApiControllerSearchLiveStreamAudiences.');
        }

        if (requestParameters.pageSize === null || requestParameters.pageSize === undefined) {
            throw new runtime.RequiredError('pageSize','Required parameter requestParameters.pageSize was null or undefined when calling searchApiControllerSearchLiveStreamAudiences.');
        }

        const queryParameters: any = {};

        if (requestParameters.pageNo !== undefined) {
            queryParameters['pageNo'] = requestParameters.pageNo;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['pageSize'] = requestParameters.pageSize;
        }

        if (requestParameters.fetchDefault !== undefined) {
            queryParameters['fetchDefault'] = requestParameters.fetchDefault;
        }

        if (requestParameters.query !== undefined) {
            queryParameters['query'] = requestParameters.query;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/live-streams/{liveStreamId}/audiences:search`.replace(`{${"liveStreamId"}}`, encodeURIComponent(String(requestParameters.liveStreamId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async searchApiControllerSearchLiveStreamAudiences(requestParameters: SearchApiControllerSearchLiveStreamAudiencesRequest): Promise<LiveStreamAudiencesSearchResponse> {
        const response = await this.searchApiControllerSearchLiveStreamAudiencesRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async searchApiControllerSearchLiveStreamBuyerAddressesRaw(requestParameters: SearchApiControllerSearchLiveStreamBuyerAddressesRequest): Promise<runtime.ApiResponse<LiveStreamBuyerAddressSearchResponse>> {
        if (requestParameters.liveStreamId === null || requestParameters.liveStreamId === undefined) {
            throw new runtime.RequiredError('liveStreamId','Required parameter requestParameters.liveStreamId was null or undefined when calling searchApiControllerSearchLiveStreamBuyerAddresses.');
        }

        if (requestParameters.pageNo === null || requestParameters.pageNo === undefined) {
            throw new runtime.RequiredError('pageNo','Required parameter requestParameters.pageNo was null or undefined when calling searchApiControllerSearchLiveStreamBuyerAddresses.');
        }

        if (requestParameters.pageSize === null || requestParameters.pageSize === undefined) {
            throw new runtime.RequiredError('pageSize','Required parameter requestParameters.pageSize was null or undefined when calling searchApiControllerSearchLiveStreamBuyerAddresses.');
        }

        const queryParameters: any = {};

        if (requestParameters.pageNo !== undefined) {
            queryParameters['pageNo'] = requestParameters.pageNo;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['pageSize'] = requestParameters.pageSize;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.id) {
            queryParameters['id'] = requestParameters.id;
        }

        if (requestParameters.sortBy !== undefined) {
            queryParameters['sortBy'] = requestParameters.sortBy;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/live-streams/{liveStreamId}/buyer-addresses:search`.replace(`{${"liveStreamId"}}`, encodeURIComponent(String(requestParameters.liveStreamId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async searchApiControllerSearchLiveStreamBuyerAddresses(requestParameters: SearchApiControllerSearchLiveStreamBuyerAddressesRequest): Promise<LiveStreamBuyerAddressSearchResponse> {
        const response = await this.searchApiControllerSearchLiveStreamBuyerAddressesRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async searchApiControllerSearchLiveStreamCommentsRaw(requestParameters: SearchApiControllerSearchLiveStreamCommentsRequest): Promise<runtime.ApiResponse<SearchLiveStreamCommentsResponse>> {
        if (requestParameters.liveStreamId === null || requestParameters.liveStreamId === undefined) {
            throw new runtime.RequiredError('liveStreamId','Required parameter requestParameters.liveStreamId was null or undefined when calling searchApiControllerSearchLiveStreamComments.');
        }

        if (requestParameters.pageNo === null || requestParameters.pageNo === undefined) {
            throw new runtime.RequiredError('pageNo','Required parameter requestParameters.pageNo was null or undefined when calling searchApiControllerSearchLiveStreamComments.');
        }

        if (requestParameters.pageSize === null || requestParameters.pageSize === undefined) {
            throw new runtime.RequiredError('pageSize','Required parameter requestParameters.pageSize was null or undefined when calling searchApiControllerSearchLiveStreamComments.');
        }

        const queryParameters: any = {};

        if (requestParameters.pageNo !== undefined) {
            queryParameters['pageNo'] = requestParameters.pageNo;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['pageSize'] = requestParameters.pageSize;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.query !== undefined) {
            queryParameters['query'] = requestParameters.query;
        }

        if (requestParameters.type !== undefined) {
            queryParameters['type'] = requestParameters.type;
        }

        if (requestParameters.sortBy !== undefined) {
            queryParameters['sortBy'] = requestParameters.sortBy;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/live-streams/{liveStreamId}/comments:search`.replace(`{${"liveStreamId"}}`, encodeURIComponent(String(requestParameters.liveStreamId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async searchApiControllerSearchLiveStreamComments(requestParameters: SearchApiControllerSearchLiveStreamCommentsRequest): Promise<SearchLiveStreamCommentsResponse> {
        const response = await this.searchApiControllerSearchLiveStreamCommentsRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async searchApiControllerSearchLiveStreamUserStatsRaw(requestParameters: SearchApiControllerSearchLiveStreamUserStatsRequest): Promise<runtime.ApiResponse<SearchLiveStreamUserStatsResponse>> {
        if (requestParameters.liveStreamId === null || requestParameters.liveStreamId === undefined) {
            throw new runtime.RequiredError('liveStreamId','Required parameter requestParameters.liveStreamId was null or undefined when calling searchApiControllerSearchLiveStreamUserStats.');
        }

        if (requestParameters.searchLiveStreamUserStatsParams === null || requestParameters.searchLiveStreamUserStatsParams === undefined) {
            throw new runtime.RequiredError('searchLiveStreamUserStatsParams','Required parameter requestParameters.searchLiveStreamUserStatsParams was null or undefined when calling searchApiControllerSearchLiveStreamUserStats.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/live-streams/{liveStreamId}/user-stats:search`.replace(`{${"liveStreamId"}}`, encodeURIComponent(String(requestParameters.liveStreamId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.searchLiveStreamUserStatsParams,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async searchApiControllerSearchLiveStreamUserStats(requestParameters: SearchApiControllerSearchLiveStreamUserStatsRequest): Promise<SearchLiveStreamUserStatsResponse> {
        const response = await this.searchApiControllerSearchLiveStreamUserStatsRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async searchApiControllerSearchLiveStreamsRaw(requestParameters: SearchApiControllerSearchLiveStreamsRequest): Promise<runtime.ApiResponse<LiveStreamsSearchResponse>> {
        if (requestParameters.pageNo === null || requestParameters.pageNo === undefined) {
            throw new runtime.RequiredError('pageNo','Required parameter requestParameters.pageNo was null or undefined when calling searchApiControllerSearchLiveStreams.');
        }

        if (requestParameters.pageSize === null || requestParameters.pageSize === undefined) {
            throw new runtime.RequiredError('pageSize','Required parameter requestParameters.pageSize was null or undefined when calling searchApiControllerSearchLiveStreams.');
        }

        const queryParameters: any = {};

        if (requestParameters.pageNo !== undefined) {
            queryParameters['pageNo'] = requestParameters.pageNo;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['pageSize'] = requestParameters.pageSize;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.id) {
            queryParameters['id'] = requestParameters.id;
        }

        if (requestParameters.eventId !== undefined) {
            queryParameters['eventId'] = requestParameters.eventId;
        }

        if (requestParameters.title !== undefined) {
            queryParameters['title'] = requestParameters.title;
        }

        if (requestParameters.query !== undefined) {
            queryParameters['query'] = requestParameters.query;
        }

        if (requestParameters.storeName !== undefined) {
            queryParameters['storeName'] = requestParameters.storeName;
        }

        if (requestParameters.status !== undefined) {
            queryParameters['status'] = requestParameters.status;
        }

        if (requestParameters.isReplayable !== undefined) {
            queryParameters['isReplayable'] = requestParameters.isReplayable;
        }

        if (requestParameters.permission) {
            queryParameters['permission'] = requestParameters.permission;
        }

        if (requestParameters.sortBy !== undefined) {
            queryParameters['sortBy'] = requestParameters.sortBy;
        }

        if (requestParameters.userId !== undefined) {
            queryParameters['userId'] = requestParameters.userId;
        }

        if (requestParameters.loadStats !== undefined) {
            queryParameters['loadStats'] = requestParameters.loadStats;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/live-streams:search`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async searchApiControllerSearchLiveStreams(requestParameters: SearchApiControllerSearchLiveStreamsRequest): Promise<LiveStreamsSearchResponse> {
        const response = await this.searchApiControllerSearchLiveStreamsRaw(requestParameters);
        return await response.value();
    }

    /**
     * Public API
     */
    async searchApiControllerSearchLiveStreamsListingsRaw(requestParameters: SearchApiControllerSearchLiveStreamsListingsRequest): Promise<runtime.ApiResponse<StoreListingSearchResponse>> {
        if (requestParameters.liveStreamId === null || requestParameters.liveStreamId === undefined) {
            throw new runtime.RequiredError('liveStreamId','Required parameter requestParameters.liveStreamId was null or undefined when calling searchApiControllerSearchLiveStreamsListings.');
        }

        if (requestParameters.pageNo === null || requestParameters.pageNo === undefined) {
            throw new runtime.RequiredError('pageNo','Required parameter requestParameters.pageNo was null or undefined when calling searchApiControllerSearchLiveStreamsListings.');
        }

        if (requestParameters.pageSize === null || requestParameters.pageSize === undefined) {
            throw new runtime.RequiredError('pageSize','Required parameter requestParameters.pageSize was null or undefined when calling searchApiControllerSearchLiveStreamsListings.');
        }

        const queryParameters: any = {};

        if (requestParameters.pageNo !== undefined) {
            queryParameters['pageNo'] = requestParameters.pageNo;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['pageSize'] = requestParameters.pageSize;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.id) {
            queryParameters['id'] = requestParameters.id;
        }

        if (requestParameters.query !== undefined) {
            queryParameters['query'] = requestParameters.query;
        }

        if (requestParameters.status !== undefined) {
            queryParameters['status'] = requestParameters.status;
        }

        if (requestParameters.sortBy !== undefined) {
            queryParameters['sortBy'] = requestParameters.sortBy;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/live-streams/{liveStreamId}/listings:search`.replace(`{${"liveStreamId"}}`, encodeURIComponent(String(requestParameters.liveStreamId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Public API
     */
    async searchApiControllerSearchLiveStreamsListings(requestParameters: SearchApiControllerSearchLiveStreamsListingsRequest): Promise<StoreListingSearchResponse> {
        const response = await this.searchApiControllerSearchLiveStreamsListingsRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async searchApiControllerSearchMailsRaw(requestParameters: SearchApiControllerSearchMailsRequest): Promise<runtime.ApiResponse<MailsSearchResponse>> {
        if (requestParameters.pageNo === null || requestParameters.pageNo === undefined) {
            throw new runtime.RequiredError('pageNo','Required parameter requestParameters.pageNo was null or undefined when calling searchApiControllerSearchMails.');
        }

        if (requestParameters.pageSize === null || requestParameters.pageSize === undefined) {
            throw new runtime.RequiredError('pageSize','Required parameter requestParameters.pageSize was null or undefined when calling searchApiControllerSearchMails.');
        }

        const queryParameters: any = {};

        if (requestParameters.pageNo !== undefined) {
            queryParameters['pageNo'] = requestParameters.pageNo;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['pageSize'] = requestParameters.pageSize;
        }

        if (requestParameters.query !== undefined) {
            queryParameters['query'] = requestParameters.query;
        }

        if (requestParameters.filterBy !== undefined) {
            queryParameters['filterBy'] = requestParameters.filterBy;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.sortBy !== undefined) {
            queryParameters['sortBy'] = requestParameters.sortBy;
        }

        if (requestParameters.state !== undefined) {
            queryParameters['state'] = requestParameters.state;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/mails:search`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async searchApiControllerSearchMails(requestParameters: SearchApiControllerSearchMailsRequest): Promise<MailsSearchResponse> {
        const response = await this.searchApiControllerSearchMailsRaw(requestParameters);
        return await response.value();
    }

    /**
     * for admin page
     */
    async searchApiControllerSearchMessagesRaw(requestParameters: SearchApiControllerSearchMessagesRequest): Promise<runtime.ApiResponse<MessagesSearchResponse>> {
        if (requestParameters.pageNo === null || requestParameters.pageNo === undefined) {
            throw new runtime.RequiredError('pageNo','Required parameter requestParameters.pageNo was null or undefined when calling searchApiControllerSearchMessages.');
        }

        if (requestParameters.pageSize === null || requestParameters.pageSize === undefined) {
            throw new runtime.RequiredError('pageSize','Required parameter requestParameters.pageSize was null or undefined when calling searchApiControllerSearchMessages.');
        }

        if (requestParameters.filterBy === null || requestParameters.filterBy === undefined) {
            throw new runtime.RequiredError('filterBy','Required parameter requestParameters.filterBy was null or undefined when calling searchApiControllerSearchMessages.');
        }

        const queryParameters: any = {};

        if (requestParameters.pageNo !== undefined) {
            queryParameters['pageNo'] = requestParameters.pageNo;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['pageSize'] = requestParameters.pageSize;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.id) {
            queryParameters['id'] = requestParameters.id;
        }

        if (requestParameters.orderIds) {
            queryParameters['orderIds'] = requestParameters.orderIds;
        }

        if (requestParameters.available !== undefined) {
            queryParameters['available'] = requestParameters.available;
        }

        if (requestParameters.featured !== undefined) {
            queryParameters['featured'] = requestParameters.featured;
        }

        if (requestParameters.userIdTo !== undefined) {
            queryParameters['userIdTo'] = requestParameters.userIdTo;
        }

        if (requestParameters.userIdFrom !== undefined) {
            queryParameters['userIdFrom'] = requestParameters.userIdFrom;
        }

        if (requestParameters.sellerId !== undefined) {
            queryParameters['sellerId'] = requestParameters.sellerId;
        }

        if (requestParameters.buyerId !== undefined) {
            queryParameters['buyerId'] = requestParameters.buyerId;
        }

        if (requestParameters.listingId !== undefined) {
            queryParameters['listingId'] = requestParameters.listingId;
        }

        if (requestParameters.orderId !== undefined) {
            queryParameters['orderId'] = requestParameters.orderId;
        }

        if (requestParameters.query !== undefined) {
            queryParameters['query'] = requestParameters.query;
        }

        if (requestParameters.filterBy !== undefined) {
            queryParameters['filterBy'] = requestParameters.filterBy;
        }

        if (requestParameters.reportFilterBy !== undefined) {
            queryParameters['reportFilterBy'] = requestParameters.reportFilterBy;
        }

        if (requestParameters.purpose !== undefined) {
            queryParameters['purpose'] = requestParameters.purpose;
        }

        if (requestParameters.thankYouType) {
            queryParameters['thankYouType'] = requestParameters.thankYouType;
        }

        if (requestParameters.sortBy !== undefined) {
            queryParameters['sortBy'] = requestParameters.sortBy;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/messages:search`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     * for admin page
     */
    async searchApiControllerSearchMessages(requestParameters: SearchApiControllerSearchMessagesRequest): Promise<MessagesSearchResponse> {
        const response = await this.searchApiControllerSearchMessagesRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async searchApiControllerSearchMessagesReportsRaw(requestParameters: SearchApiControllerSearchMessagesReportsRequest): Promise<runtime.ApiResponse<MessageReportSearchResponse>> {
        if (requestParameters.messageId === null || requestParameters.messageId === undefined) {
            throw new runtime.RequiredError('messageId','Required parameter requestParameters.messageId was null or undefined when calling searchApiControllerSearchMessagesReports.');
        }

        if (requestParameters.pageNo === null || requestParameters.pageNo === undefined) {
            throw new runtime.RequiredError('pageNo','Required parameter requestParameters.pageNo was null or undefined when calling searchApiControllerSearchMessagesReports.');
        }

        if (requestParameters.pageSize === null || requestParameters.pageSize === undefined) {
            throw new runtime.RequiredError('pageSize','Required parameter requestParameters.pageSize was null or undefined when calling searchApiControllerSearchMessagesReports.');
        }

        const queryParameters: any = {};

        if (requestParameters.pageNo !== undefined) {
            queryParameters['pageNo'] = requestParameters.pageNo;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['pageSize'] = requestParameters.pageSize;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.id) {
            queryParameters['id'] = requestParameters.id;
        }

        if (requestParameters.reason) {
            queryParameters['reason'] = requestParameters.reason;
        }

        if (requestParameters.resolveStatus) {
            queryParameters['resolveStatus'] = requestParameters.resolveStatus;
        }

        if (requestParameters.reporterId !== undefined) {
            queryParameters['reporterId'] = requestParameters.reporterId;
        }

        if (requestParameters.sortBy !== undefined) {
            queryParameters['sortBy'] = requestParameters.sortBy;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/messages/{messageId}/reports:search`.replace(`{${"messageId"}}`, encodeURIComponent(String(requestParameters.messageId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async searchApiControllerSearchMessagesReports(requestParameters: SearchApiControllerSearchMessagesReportsRequest): Promise<MessageReportSearchResponse> {
        const response = await this.searchApiControllerSearchMessagesReportsRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async searchApiControllerSearchMyStoreListingsRaw(requestParameters: SearchApiControllerSearchMyStoreListingsRequest): Promise<runtime.ApiResponse<MyStoreListingSearchResponse>> {
        if (requestParameters.sellerId === null || requestParameters.sellerId === undefined) {
            throw new runtime.RequiredError('sellerId','Required parameter requestParameters.sellerId was null or undefined when calling searchApiControllerSearchMyStoreListings.');
        }

        if (requestParameters.pageNo === null || requestParameters.pageNo === undefined) {
            throw new runtime.RequiredError('pageNo','Required parameter requestParameters.pageNo was null or undefined when calling searchApiControllerSearchMyStoreListings.');
        }

        if (requestParameters.pageSize === null || requestParameters.pageSize === undefined) {
            throw new runtime.RequiredError('pageSize','Required parameter requestParameters.pageSize was null or undefined when calling searchApiControllerSearchMyStoreListings.');
        }

        const queryParameters: any = {};

        if (requestParameters.pageNo !== undefined) {
            queryParameters['pageNo'] = requestParameters.pageNo;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['pageSize'] = requestParameters.pageSize;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.id) {
            queryParameters['id'] = requestParameters.id;
        }

        if (requestParameters.type) {
            queryParameters['type'] = requestParameters.type;
        }

        if (requestParameters.excludeType) {
            queryParameters['excludeType'] = requestParameters.excludeType;
        }

        if (requestParameters.query !== undefined) {
            queryParameters['query'] = requestParameters.query;
        }

        if (requestParameters.status !== undefined) {
            queryParameters['status'] = requestParameters.status;
        }

        if (requestParameters.filterOutLiveListings !== undefined) {
            queryParameters['filterOutLiveListings'] = requestParameters.filterOutLiveListings;
        }

        if (requestParameters.loadLiveStatus !== undefined) {
            queryParameters['loadLiveStatus'] = requestParameters.loadLiveStatus;
        }

        if (requestParameters.tags) {
            queryParameters['tags'] = requestParameters.tags;
        }

        if (requestParameters.soldOut !== undefined) {
            queryParameters['soldOut'] = requestParameters.soldOut;
        }

        if (requestParameters.minPrice !== undefined) {
            queryParameters['minPrice'] = requestParameters.minPrice;
        }

        if (requestParameters.maxPrice !== undefined) {
            queryParameters['maxPrice'] = requestParameters.maxPrice;
        }

        if (requestParameters.shopifyStoreIds) {
            queryParameters['shopifyStoreIds'] = requestParameters.shopifyStoreIds;
        }

        if (requestParameters.sortBy !== undefined) {
            queryParameters['sortBy'] = requestParameters.sortBy;
        }

        if (requestParameters.tagsFilterOperator !== undefined) {
            queryParameters['tagsFilterOperator'] = requestParameters.tagsFilterOperator;
        }

        if (requestParameters.supplierId !== undefined) {
            queryParameters['supplierId'] = requestParameters.supplierId;
        }

        if (requestParameters.partnerId !== undefined) {
            queryParameters['partnerId'] = requestParameters.partnerId;
        }

        if (requestParameters.collectionId !== undefined) {
            queryParameters['collectionId'] = requestParameters.collectionId;
        }

        if (requestParameters.productCategoryId) {
            queryParameters['productCategoryId'] = requestParameters.productCategoryId;
        }

        if (requestParameters.includeChildCategories !== undefined) {
            queryParameters['includeChildCategories'] = requestParameters.includeChildCategories;
        }

        if (requestParameters.isDropship !== undefined) {
            queryParameters['isDropship'] = requestParameters.isDropship;
        }

        if (requestParameters.isShopify !== undefined) {
            queryParameters['isShopify'] = requestParameters.isShopify;
        }

        if (requestParameters.minMeetingStartDate !== undefined) {
            queryParameters['minMeetingStartDate'] = requestParameters.minMeetingStartDate;
        }

        if (requestParameters.maxMeetingStartDate !== undefined) {
            queryParameters['maxMeetingStartDate'] = requestParameters.maxMeetingStartDate;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/stores/{sellerId}/listings:search`.replace(`{${"sellerId"}}`, encodeURIComponent(String(requestParameters.sellerId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async searchApiControllerSearchMyStoreListings(requestParameters: SearchApiControllerSearchMyStoreListingsRequest): Promise<MyStoreListingSearchResponse> {
        const response = await this.searchApiControllerSearchMyStoreListingsRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async searchApiControllerSearchMyStorePublicListingsRaw(requestParameters: SearchApiControllerSearchMyStorePublicListingsRequest): Promise<runtime.ApiResponse<StoreListingSearchResponse>> {
        if (requestParameters.sellerId === null || requestParameters.sellerId === undefined) {
            throw new runtime.RequiredError('sellerId','Required parameter requestParameters.sellerId was null or undefined when calling searchApiControllerSearchMyStorePublicListings.');
        }

        if (requestParameters.pageNo === null || requestParameters.pageNo === undefined) {
            throw new runtime.RequiredError('pageNo','Required parameter requestParameters.pageNo was null or undefined when calling searchApiControllerSearchMyStorePublicListings.');
        }

        if (requestParameters.pageSize === null || requestParameters.pageSize === undefined) {
            throw new runtime.RequiredError('pageSize','Required parameter requestParameters.pageSize was null or undefined when calling searchApiControllerSearchMyStorePublicListings.');
        }

        const queryParameters: any = {};

        if (requestParameters.pageNo !== undefined) {
            queryParameters['pageNo'] = requestParameters.pageNo;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['pageSize'] = requestParameters.pageSize;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.id) {
            queryParameters['id'] = requestParameters.id;
        }

        if (requestParameters.query !== undefined) {
            queryParameters['query'] = requestParameters.query;
        }

        if (requestParameters.categoryRowId !== undefined) {
            queryParameters['categoryRowId'] = requestParameters.categoryRowId;
        }

        if (requestParameters.categoryId !== undefined) {
            queryParameters['categoryId'] = requestParameters.categoryId;
        }

        if (requestParameters.productCategoryId) {
            queryParameters['productCategoryId'] = requestParameters.productCategoryId;
        }

        if (requestParameters.includeChildCategories !== undefined) {
            queryParameters['includeChildCategories'] = requestParameters.includeChildCategories;
        }

        if (requestParameters.collectionId !== undefined) {
            queryParameters['collectionId'] = requestParameters.collectionId;
        }

        if (requestParameters.tags) {
            queryParameters['tags'] = requestParameters.tags;
        }

        if (requestParameters.sellerTags) {
            queryParameters['sellerTags'] = requestParameters.sellerTags;
        }

        if (requestParameters.status !== undefined) {
            queryParameters['status'] = requestParameters.status;
        }

        if (requestParameters.minQuantity !== undefined) {
            queryParameters['minQuantity'] = requestParameters.minQuantity;
        }

        if (requestParameters.sortBy !== undefined) {
            queryParameters['sortBy'] = requestParameters.sortBy;
        }

        if (requestParameters.tagsFilterOperator !== undefined) {
            queryParameters['tagsFilterOperator'] = requestParameters.tagsFilterOperator;
        }

        if (requestParameters.sellerIds) {
            queryParameters['sellerIds'] = requestParameters.sellerIds;
        }

        if (requestParameters.featured !== undefined) {
            queryParameters['featured'] = requestParameters.featured;
        }

        if (requestParameters.prefetchFeaturedStatus !== undefined) {
            queryParameters['prefetchFeaturedStatus'] = requestParameters.prefetchFeaturedStatus;
        }

        if (requestParameters.listingType) {
            queryParameters['listingType'] = requestParameters.listingType;
        }

        if (requestParameters.excludeListingType) {
            queryParameters['excludeListingType'] = requestParameters.excludeListingType;
        }

        if (requestParameters.minMeetingStartDate !== undefined) {
            queryParameters['minMeetingStartDate'] = requestParameters.minMeetingStartDate;
        }

        if (requestParameters.maxMeetingStartDate !== undefined) {
            queryParameters['maxMeetingStartDate'] = requestParameters.maxMeetingStartDate;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/stores/{sellerId}/public-listings:search`.replace(`{${"sellerId"}}`, encodeURIComponent(String(requestParameters.sellerId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async searchApiControllerSearchMyStorePublicListings(requestParameters: SearchApiControllerSearchMyStorePublicListingsRequest): Promise<StoreListingSearchResponse> {
        const response = await this.searchApiControllerSearchMyStorePublicListingsRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async searchApiControllerSearchOrderTransactionsRaw(requestParameters: SearchApiControllerSearchOrderTransactionsRequest): Promise<runtime.ApiResponse<OrderTransactionSearchResponse>> {
        if (requestParameters.pageNo === null || requestParameters.pageNo === undefined) {
            throw new runtime.RequiredError('pageNo','Required parameter requestParameters.pageNo was null or undefined when calling searchApiControllerSearchOrderTransactions.');
        }

        if (requestParameters.pageSize === null || requestParameters.pageSize === undefined) {
            throw new runtime.RequiredError('pageSize','Required parameter requestParameters.pageSize was null or undefined when calling searchApiControllerSearchOrderTransactions.');
        }

        const queryParameters: any = {};

        if (requestParameters.pageNo !== undefined) {
            queryParameters['pageNo'] = requestParameters.pageNo;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['pageSize'] = requestParameters.pageSize;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.orderId !== undefined) {
            queryParameters['orderId'] = requestParameters.orderId;
        }

        if (requestParameters.orderNumber !== undefined) {
            queryParameters['orderNumber'] = requestParameters.orderNumber;
        }

        if (requestParameters.sellerId !== undefined) {
            queryParameters['sellerId'] = requestParameters.sellerId;
        }

        if (requestParameters.buyerId !== undefined) {
            queryParameters['buyerId'] = requestParameters.buyerId;
        }

        if (requestParameters.type !== undefined) {
            queryParameters['type'] = requestParameters.type;
        }

        if (requestParameters.status !== undefined) {
            queryParameters['status'] = requestParameters.status;
        }

        if (requestParameters.sortBy !== undefined) {
            queryParameters['sortBy'] = requestParameters.sortBy;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/order-transactions:search`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async searchApiControllerSearchOrderTransactions(requestParameters: SearchApiControllerSearchOrderTransactionsRequest): Promise<OrderTransactionSearchResponse> {
        const response = await this.searchApiControllerSearchOrderTransactionsRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async searchApiControllerSearchOrdersRaw(requestParameters: SearchApiControllerSearchOrdersRequest): Promise<runtime.ApiResponse<OrdersSearchResponse>> {
        if (requestParameters.pageNo === null || requestParameters.pageNo === undefined) {
            throw new runtime.RequiredError('pageNo','Required parameter requestParameters.pageNo was null or undefined when calling searchApiControllerSearchOrders.');
        }

        if (requestParameters.pageSize === null || requestParameters.pageSize === undefined) {
            throw new runtime.RequiredError('pageSize','Required parameter requestParameters.pageSize was null or undefined when calling searchApiControllerSearchOrders.');
        }

        const queryParameters: any = {};

        if (requestParameters.pageNo !== undefined) {
            queryParameters['pageNo'] = requestParameters.pageNo;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['pageSize'] = requestParameters.pageSize;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.ids) {
            queryParameters['ids'] = requestParameters.ids;
        }

        if (requestParameters.query !== undefined) {
            queryParameters['query'] = requestParameters.query;
        }

        if (requestParameters.masterOrderId) {
            queryParameters['masterOrderId'] = requestParameters.masterOrderId;
        }

        if (requestParameters.orderNumber !== undefined) {
            queryParameters['orderNumber'] = requestParameters.orderNumber;
        }

        if (requestParameters.liveStreamId !== undefined) {
            queryParameters['liveStreamId'] = requestParameters.liveStreamId;
        }

        if (requestParameters.status) {
            queryParameters['status'] = requestParameters.status;
        }

        if (requestParameters.orderGroupStatus) {
            queryParameters['orderGroupStatus'] = requestParameters.orderGroupStatus;
        }

        if (requestParameters.pickupStatus) {
            queryParameters['pickupStatus'] = requestParameters.pickupStatus;
        }

        if (requestParameters.groupStatusMaster !== undefined) {
            queryParameters['groupStatusMaster'] = requestParameters.groupStatusMaster;
        }

        if (requestParameters.groupStatus) {
            queryParameters['groupStatus'] = requestParameters.groupStatus;
        }

        if (requestParameters.packed !== undefined) {
            queryParameters['packed'] = requestParameters.packed;
        }

        if (requestParameters.allOrders !== undefined) {
            queryParameters['allOrders'] = requestParameters.allOrders;
        }

        if (requestParameters.shippingMethod) {
            queryParameters['shippingMethod'] = requestParameters.shippingMethod;
        }

        if (requestParameters.createdBefore !== undefined) {
            queryParameters['createdBefore'] = requestParameters.createdBefore;
        }

        if (requestParameters.createdAfter !== undefined) {
            queryParameters['createdAfter'] = requestParameters.createdAfter;
        }

        if (requestParameters.couponCode !== undefined) {
            queryParameters['couponCode'] = requestParameters.couponCode;
        }

        if (requestParameters.aggregateTax !== undefined) {
            queryParameters['aggregateTax'] = requestParameters.aggregateTax;
        }

        if (requestParameters.buyerUserType !== undefined) {
            queryParameters['buyerUserType'] = requestParameters.buyerUserType;
        }

        if (requestParameters.platform !== undefined) {
            queryParameters['platform'] = requestParameters.platform;
        }

        if (requestParameters.listingType !== undefined) {
            queryParameters['listingType'] = requestParameters.listingType;
        }

        if (requestParameters.eventId !== undefined) {
            queryParameters['eventId'] = requestParameters.eventId;
        }

        if (requestParameters.listingId !== undefined) {
            queryParameters['listingId'] = requestParameters.listingId;
        }

        if (requestParameters.sellerId !== undefined) {
            queryParameters['sellerId'] = requestParameters.sellerId;
        }

        if (requestParameters.buyerId !== undefined) {
            queryParameters['buyerId'] = requestParameters.buyerId;
        }

        if (requestParameters.shippingLabelFailed !== undefined) {
            queryParameters['shippingLabelFailed'] = requestParameters.shippingLabelFailed;
        }

        if (requestParameters.filterBy !== undefined) {
            queryParameters['filterBy'] = requestParameters.filterBy;
        }

        if (requestParameters.giftingStatus) {
            queryParameters['giftingStatus'] = requestParameters.giftingStatus;
        }

        if (requestParameters.isGiftPackage !== undefined) {
            queryParameters['isGiftPackage'] = requestParameters.isGiftPackage;
        }

        if (requestParameters.sourceType !== undefined) {
            queryParameters['sourceType'] = requestParameters.sourceType;
        }

        if (requestParameters.hasShipmentParcel !== undefined) {
            queryParameters['hasShipmentParcel'] = requestParameters.hasShipmentParcel;
        }

        if (requestParameters.shipmentOriginalParcelSource) {
            queryParameters['shipmentOriginalParcelSource'] = requestParameters.shipmentOriginalParcelSource;
        }

        if (requestParameters.sourceId !== undefined) {
            queryParameters['sourceId'] = requestParameters.sourceId;
        }

        if (requestParameters.refundWholeness) {
            queryParameters['refundWholeness'] = requestParameters.refundWholeness;
        }

        if (requestParameters.isUsingShippoPlatform !== undefined) {
            queryParameters['isUsingShippoPlatform'] = requestParameters.isUsingShippoPlatform;
        }

        if (requestParameters.sortBy !== undefined) {
            queryParameters['sortBy'] = requestParameters.sortBy;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/orders:search`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async searchApiControllerSearchOrders(requestParameters: SearchApiControllerSearchOrdersRequest): Promise<OrdersSearchResponse> {
        const response = await this.searchApiControllerSearchOrdersRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async searchApiControllerSearchPopStoreDropshipApplicationsRaw(requestParameters: SearchApiControllerSearchPopStoreDropshipApplicationsRequest): Promise<runtime.ApiResponse<SearchPopStoreDropshipApplicationsResponse>> {
        if (requestParameters.pageNo === null || requestParameters.pageNo === undefined) {
            throw new runtime.RequiredError('pageNo','Required parameter requestParameters.pageNo was null or undefined when calling searchApiControllerSearchPopStoreDropshipApplications.');
        }

        if (requestParameters.pageSize === null || requestParameters.pageSize === undefined) {
            throw new runtime.RequiredError('pageSize','Required parameter requestParameters.pageSize was null or undefined when calling searchApiControllerSearchPopStoreDropshipApplications.');
        }

        const queryParameters: any = {};

        if (requestParameters.pageNo !== undefined) {
            queryParameters['pageNo'] = requestParameters.pageNo;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['pageSize'] = requestParameters.pageSize;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.id) {
            queryParameters['id'] = requestParameters.id;
        }

        if (requestParameters.minCreatedAt !== undefined) {
            queryParameters['minCreatedAt'] = requestParameters.minCreatedAt;
        }

        if (requestParameters.maxCreatedAt !== undefined) {
            queryParameters['maxCreatedAt'] = requestParameters.maxCreatedAt;
        }

        if (requestParameters.minUpdatedAt !== undefined) {
            queryParameters['minUpdatedAt'] = requestParameters.minUpdatedAt;
        }

        if (requestParameters.maxUpdatedAt !== undefined) {
            queryParameters['maxUpdatedAt'] = requestParameters.maxUpdatedAt;
        }

        if (requestParameters.creatorId) {
            queryParameters['creatorId'] = requestParameters.creatorId;
        }

        if (requestParameters.state) {
            queryParameters['state'] = requestParameters.state;
        }

        if (requestParameters.instagramId) {
            queryParameters['instagramId'] = requestParameters.instagramId;
        }

        if (requestParameters.auditorId) {
            queryParameters['auditorId'] = requestParameters.auditorId;
        }

        if (requestParameters.sortBy !== undefined) {
            queryParameters['sortBy'] = requestParameters.sortBy;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/popstore-dropship-applications:search`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async searchApiControllerSearchPopStoreDropshipApplications(requestParameters: SearchApiControllerSearchPopStoreDropshipApplicationsRequest): Promise<SearchPopStoreDropshipApplicationsResponse> {
        const response = await this.searchApiControllerSearchPopStoreDropshipApplicationsRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async searchApiControllerSearchPopStoreOnboardingContestSubmissionsRaw(requestParameters: SearchApiControllerSearchPopStoreOnboardingContestSubmissionsRequest): Promise<runtime.ApiResponse<SearchPopStoreOnboardingContestSubmissionsResponse>> {
        if (requestParameters.pageNo === null || requestParameters.pageNo === undefined) {
            throw new runtime.RequiredError('pageNo','Required parameter requestParameters.pageNo was null or undefined when calling searchApiControllerSearchPopStoreOnboardingContestSubmissions.');
        }

        if (requestParameters.pageSize === null || requestParameters.pageSize === undefined) {
            throw new runtime.RequiredError('pageSize','Required parameter requestParameters.pageSize was null or undefined when calling searchApiControllerSearchPopStoreOnboardingContestSubmissions.');
        }

        const queryParameters: any = {};

        if (requestParameters.pageNo !== undefined) {
            queryParameters['pageNo'] = requestParameters.pageNo;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['pageSize'] = requestParameters.pageSize;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.id) {
            queryParameters['id'] = requestParameters.id;
        }

        if (requestParameters.creatorId) {
            queryParameters['creatorId'] = requestParameters.creatorId;
        }

        if (requestParameters.minWeek !== undefined) {
            queryParameters['minWeek'] = requestParameters.minWeek;
        }

        if (requestParameters.maxWeek !== undefined) {
            queryParameters['maxWeek'] = requestParameters.maxWeek;
        }

        if (requestParameters.isWinner !== undefined) {
            queryParameters['isWinner'] = requestParameters.isWinner;
        }

        if (requestParameters.sortBy !== undefined) {
            queryParameters['sortBy'] = requestParameters.sortBy;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/popstore-onboarding-contest-submissions:search`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async searchApiControllerSearchPopStoreOnboardingContestSubmissions(requestParameters: SearchApiControllerSearchPopStoreOnboardingContestSubmissionsRequest): Promise<SearchPopStoreOnboardingContestSubmissionsResponse> {
        const response = await this.searchApiControllerSearchPopStoreOnboardingContestSubmissionsRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async searchApiControllerSearchPopStoreOnboardingSessionsRaw(requestParameters: SearchApiControllerSearchPopStoreOnboardingSessionsRequest): Promise<runtime.ApiResponse<SearchPopStoreOnboardingSessionsResponse>> {
        if (requestParameters.pageNo === null || requestParameters.pageNo === undefined) {
            throw new runtime.RequiredError('pageNo','Required parameter requestParameters.pageNo was null or undefined when calling searchApiControllerSearchPopStoreOnboardingSessions.');
        }

        if (requestParameters.pageSize === null || requestParameters.pageSize === undefined) {
            throw new runtime.RequiredError('pageSize','Required parameter requestParameters.pageSize was null or undefined when calling searchApiControllerSearchPopStoreOnboardingSessions.');
        }

        const queryParameters: any = {};

        if (requestParameters.pageNo !== undefined) {
            queryParameters['pageNo'] = requestParameters.pageNo;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['pageSize'] = requestParameters.pageSize;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.id) {
            queryParameters['id'] = requestParameters.id;
        }

        if (requestParameters.minCreatedAt !== undefined) {
            queryParameters['minCreatedAt'] = requestParameters.minCreatedAt;
        }

        if (requestParameters.maxCreatedAt !== undefined) {
            queryParameters['maxCreatedAt'] = requestParameters.maxCreatedAt;
        }

        if (requestParameters.reg) {
            queryParameters['reg'] = requestParameters.reg;
        }

        if (requestParameters.userId) {
            queryParameters['userId'] = requestParameters.userId;
        }

        if (requestParameters.loginPhoneNumber) {
            queryParameters['loginPhoneNumber'] = requestParameters.loginPhoneNumber;
        }

        if (requestParameters.loginEmail) {
            queryParameters['loginEmail'] = requestParameters.loginEmail;
        }

        if (requestParameters.sortBy !== undefined) {
            queryParameters['sortBy'] = requestParameters.sortBy;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/popstore-onboarding-sessions:search`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async searchApiControllerSearchPopStoreOnboardingSessions(requestParameters: SearchApiControllerSearchPopStoreOnboardingSessionsRequest): Promise<SearchPopStoreOnboardingSessionsResponse> {
        const response = await this.searchApiControllerSearchPopStoreOnboardingSessionsRaw(requestParameters);
        return await response.value();
    }

    /**
     * Public API
     */
    async searchApiControllerSearchPopStoreReplayLiveStreamsRaw(requestParameters: SearchApiControllerSearchPopStoreReplayLiveStreamsRequest): Promise<runtime.ApiResponse<LiveStreamsSearchResponse>> {
        if (requestParameters.pageNo === null || requestParameters.pageNo === undefined) {
            throw new runtime.RequiredError('pageNo','Required parameter requestParameters.pageNo was null or undefined when calling searchApiControllerSearchPopStoreReplayLiveStreams.');
        }

        if (requestParameters.pageSize === null || requestParameters.pageSize === undefined) {
            throw new runtime.RequiredError('pageSize','Required parameter requestParameters.pageSize was null or undefined when calling searchApiControllerSearchPopStoreReplayLiveStreams.');
        }

        const queryParameters: any = {};

        if (requestParameters.pageNo !== undefined) {
            queryParameters['pageNo'] = requestParameters.pageNo;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['pageSize'] = requestParameters.pageSize;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.userId !== undefined) {
            queryParameters['userId'] = requestParameters.userId;
        }

        if (requestParameters.storeName !== undefined) {
            queryParameters['storeName'] = requestParameters.storeName;
        }

        if (requestParameters.hasListing !== undefined) {
            queryParameters['hasListing'] = requestParameters.hasListing;
        }

        if (requestParameters.hasOrder !== undefined) {
            queryParameters['hasOrder'] = requestParameters.hasOrder;
        }

        if (requestParameters.moderationStatus !== undefined) {
            queryParameters['moderationStatus'] = requestParameters.moderationStatus;
        }

        if (requestParameters.sortBy !== undefined) {
            queryParameters['sortBy'] = requestParameters.sortBy;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/pop-store-replay-live-streams:search`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Public API
     */
    async searchApiControllerSearchPopStoreReplayLiveStreams(requestParameters: SearchApiControllerSearchPopStoreReplayLiveStreamsRequest): Promise<LiveStreamsSearchResponse> {
        const response = await this.searchApiControllerSearchPopStoreReplayLiveStreamsRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async searchApiControllerSearchPostsRaw(requestParameters: SearchApiControllerSearchPostsRequest): Promise<runtime.ApiResponse<PostSearchResponse>> {
        if (requestParameters.storeId === null || requestParameters.storeId === undefined) {
            throw new runtime.RequiredError('storeId','Required parameter requestParameters.storeId was null or undefined when calling searchApiControllerSearchPosts.');
        }

        if (requestParameters.pageNo === null || requestParameters.pageNo === undefined) {
            throw new runtime.RequiredError('pageNo','Required parameter requestParameters.pageNo was null or undefined when calling searchApiControllerSearchPosts.');
        }

        if (requestParameters.pageSize === null || requestParameters.pageSize === undefined) {
            throw new runtime.RequiredError('pageSize','Required parameter requestParameters.pageSize was null or undefined when calling searchApiControllerSearchPosts.');
        }

        const queryParameters: any = {};

        if (requestParameters.pageNo !== undefined) {
            queryParameters['pageNo'] = requestParameters.pageNo;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['pageSize'] = requestParameters.pageSize;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.query !== undefined) {
            queryParameters['query'] = requestParameters.query;
        }

        if (requestParameters.id) {
            queryParameters['id'] = requestParameters.id;
        }

        if (requestParameters.permaLink !== undefined) {
            queryParameters['permaLink'] = requestParameters.permaLink;
        }

        if (requestParameters.moderationStatus) {
            queryParameters['moderationStatus'] = requestParameters.moderationStatus;
        }

        if (requestParameters.status) {
            queryParameters['status'] = requestParameters.status;
        }

        if (requestParameters.sortBy !== undefined) {
            queryParameters['sortBy'] = requestParameters.sortBy;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xPopPlatform !== undefined && requestParameters.xPopPlatform !== null) {
            headerParameters['x-pop-platform'] = String(requestParameters.xPopPlatform);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/stores/{storeId}/posts:search`.replace(`{${"storeId"}}`, encodeURIComponent(String(requestParameters.storeId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async searchApiControllerSearchPosts(requestParameters: SearchApiControllerSearchPostsRequest): Promise<PostSearchResponse> {
        const response = await this.searchApiControllerSearchPostsRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async searchApiControllerSearchPostsCommentsRaw(requestParameters: SearchApiControllerSearchPostsCommentsRequest): Promise<runtime.ApiResponse<PostCommentSearchResponse>> {
        if (requestParameters.storeId === null || requestParameters.storeId === undefined) {
            throw new runtime.RequiredError('storeId','Required parameter requestParameters.storeId was null or undefined when calling searchApiControllerSearchPostsComments.');
        }

        if (requestParameters.postId === null || requestParameters.postId === undefined) {
            throw new runtime.RequiredError('postId','Required parameter requestParameters.postId was null or undefined when calling searchApiControllerSearchPostsComments.');
        }

        if (requestParameters.pageNo === null || requestParameters.pageNo === undefined) {
            throw new runtime.RequiredError('pageNo','Required parameter requestParameters.pageNo was null or undefined when calling searchApiControllerSearchPostsComments.');
        }

        if (requestParameters.pageSize === null || requestParameters.pageSize === undefined) {
            throw new runtime.RequiredError('pageSize','Required parameter requestParameters.pageSize was null or undefined when calling searchApiControllerSearchPostsComments.');
        }

        const queryParameters: any = {};

        if (requestParameters.pageNo !== undefined) {
            queryParameters['pageNo'] = requestParameters.pageNo;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['pageSize'] = requestParameters.pageSize;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.query !== undefined) {
            queryParameters['query'] = requestParameters.query;
        }

        if (requestParameters.rootComment !== undefined) {
            queryParameters['rootComment'] = requestParameters.rootComment;
        }

        if (requestParameters.id) {
            queryParameters['id'] = requestParameters.id;
        }

        if (requestParameters.parentId !== undefined) {
            queryParameters['parentId'] = requestParameters.parentId;
        }

        if (requestParameters.sortBy !== undefined) {
            queryParameters['sortBy'] = requestParameters.sortBy;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/stores/{storeId}/posts/{postId}/comments:search`.replace(`{${"storeId"}}`, encodeURIComponent(String(requestParameters.storeId))).replace(`{${"postId"}}`, encodeURIComponent(String(requestParameters.postId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async searchApiControllerSearchPostsComments(requestParameters: SearchApiControllerSearchPostsCommentsRequest): Promise<PostCommentSearchResponse> {
        const response = await this.searchApiControllerSearchPostsCommentsRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async searchApiControllerSearchPostsGloballyRaw(requestParameters: SearchApiControllerSearchPostsGloballyRequest): Promise<runtime.ApiResponse<PostSearchResponse>> {
        if (requestParameters.pageNo === null || requestParameters.pageNo === undefined) {
            throw new runtime.RequiredError('pageNo','Required parameter requestParameters.pageNo was null or undefined when calling searchApiControllerSearchPostsGlobally.');
        }

        if (requestParameters.pageSize === null || requestParameters.pageSize === undefined) {
            throw new runtime.RequiredError('pageSize','Required parameter requestParameters.pageSize was null or undefined when calling searchApiControllerSearchPostsGlobally.');
        }

        const queryParameters: any = {};

        if (requestParameters.pageNo !== undefined) {
            queryParameters['pageNo'] = requestParameters.pageNo;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['pageSize'] = requestParameters.pageSize;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.query !== undefined) {
            queryParameters['query'] = requestParameters.query;
        }

        if (requestParameters.id) {
            queryParameters['id'] = requestParameters.id;
        }

        if (requestParameters.permaLink !== undefined) {
            queryParameters['permaLink'] = requestParameters.permaLink;
        }

        if (requestParameters.storeId !== undefined) {
            queryParameters['storeId'] = requestParameters.storeId;
        }

        if (requestParameters.moderationStatus) {
            queryParameters['moderationStatus'] = requestParameters.moderationStatus;
        }

        if (requestParameters.approverEmail !== undefined) {
            queryParameters['approverEmail'] = requestParameters.approverEmail;
        }

        if (requestParameters.approverName !== undefined) {
            queryParameters['approverName'] = requestParameters.approverName;
        }

        if (requestParameters.minCreatedAt !== undefined) {
            queryParameters['minCreatedAt'] = requestParameters.minCreatedAt;
        }

        if (requestParameters.maxCreatedAt !== undefined) {
            queryParameters['maxCreatedAt'] = requestParameters.maxCreatedAt;
        }

        if (requestParameters.minPublishedAt !== undefined) {
            queryParameters['minPublishedAt'] = requestParameters.minPublishedAt;
        }

        if (requestParameters.maxPublishedAt !== undefined) {
            queryParameters['maxPublishedAt'] = requestParameters.maxPublishedAt;
        }

        if (requestParameters.sortBy !== undefined) {
            queryParameters['sortBy'] = requestParameters.sortBy;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/posts:search`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async searchApiControllerSearchPostsGlobally(requestParameters: SearchApiControllerSearchPostsGloballyRequest): Promise<PostSearchResponse> {
        const response = await this.searchApiControllerSearchPostsGloballyRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async searchApiControllerSearchPrivateProfilesPayoutHistoryRaw(requestParameters: SearchApiControllerSearchPrivateProfilesPayoutHistoryRequest): Promise<runtime.ApiResponse<PrivateProfilesPayoutHistorySearchResponse>> {
        if (requestParameters.sellerId === null || requestParameters.sellerId === undefined) {
            throw new runtime.RequiredError('sellerId','Required parameter requestParameters.sellerId was null or undefined when calling searchApiControllerSearchPrivateProfilesPayoutHistory.');
        }

        if (requestParameters.pageNo === null || requestParameters.pageNo === undefined) {
            throw new runtime.RequiredError('pageNo','Required parameter requestParameters.pageNo was null or undefined when calling searchApiControllerSearchPrivateProfilesPayoutHistory.');
        }

        if (requestParameters.pageSize === null || requestParameters.pageSize === undefined) {
            throw new runtime.RequiredError('pageSize','Required parameter requestParameters.pageSize was null or undefined when calling searchApiControllerSearchPrivateProfilesPayoutHistory.');
        }

        const queryParameters: any = {};

        if (requestParameters.pageNo !== undefined) {
            queryParameters['pageNo'] = requestParameters.pageNo;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['pageSize'] = requestParameters.pageSize;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.id) {
            queryParameters['id'] = requestParameters.id;
        }

        if (requestParameters.status) {
            queryParameters['status'] = requestParameters.status;
        }

        if (requestParameters.sourceType) {
            queryParameters['sourceType'] = requestParameters.sourceType;
        }

        if (requestParameters.userId !== undefined) {
            queryParameters['userId'] = requestParameters.userId;
        }

        if (requestParameters.operatorId !== undefined) {
            queryParameters['operatorId'] = requestParameters.operatorId;
        }

        if (requestParameters.sortBy !== undefined) {
            queryParameters['sortBy'] = requestParameters.sortBy;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/users/{sellerId}/payout-history:search`.replace(`{${"sellerId"}}`, encodeURIComponent(String(requestParameters.sellerId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async searchApiControllerSearchPrivateProfilesPayoutHistory(requestParameters: SearchApiControllerSearchPrivateProfilesPayoutHistoryRequest): Promise<PrivateProfilesPayoutHistorySearchResponse> {
        const response = await this.searchApiControllerSearchPrivateProfilesPayoutHistoryRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async searchApiControllerSearchProductCollectionsRaw(requestParameters: SearchApiControllerSearchProductCollectionsRequest): Promise<runtime.ApiResponse<ProductCollectionsSearchResponse>> {
        if (requestParameters.storeId === null || requestParameters.storeId === undefined) {
            throw new runtime.RequiredError('storeId','Required parameter requestParameters.storeId was null or undefined when calling searchApiControllerSearchProductCollections.');
        }

        if (requestParameters.pageNo === null || requestParameters.pageNo === undefined) {
            throw new runtime.RequiredError('pageNo','Required parameter requestParameters.pageNo was null or undefined when calling searchApiControllerSearchProductCollections.');
        }

        if (requestParameters.pageSize === null || requestParameters.pageSize === undefined) {
            throw new runtime.RequiredError('pageSize','Required parameter requestParameters.pageSize was null or undefined when calling searchApiControllerSearchProductCollections.');
        }

        const queryParameters: any = {};

        if (requestParameters.pageNo !== undefined) {
            queryParameters['pageNo'] = requestParameters.pageNo;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['pageSize'] = requestParameters.pageSize;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.query !== undefined) {
            queryParameters['query'] = requestParameters.query;
        }

        if (requestParameters.id) {
            queryParameters['id'] = requestParameters.id;
        }

        if (requestParameters.archived !== undefined) {
            queryParameters['archived'] = requestParameters.archived;
        }

        if (requestParameters.loadLinkedProductCategories !== undefined) {
            queryParameters['loadLinkedProductCategories'] = requestParameters.loadLinkedProductCategories;
        }

        if (requestParameters.sortBy !== undefined) {
            queryParameters['sortBy'] = requestParameters.sortBy;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/stores/{storeId}/product-collections:search`.replace(`{${"storeId"}}`, encodeURIComponent(String(requestParameters.storeId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async searchApiControllerSearchProductCollections(requestParameters: SearchApiControllerSearchProductCollectionsRequest): Promise<ProductCollectionsSearchResponse> {
        const response = await this.searchApiControllerSearchProductCollectionsRaw(requestParameters);
        return await response.value();
    }

    /**
     * Public API
     */
    async searchApiControllerSearchProductsRaw(requestParameters: SearchApiControllerSearchProductsRequest): Promise<runtime.ApiResponse<SearchProductsResponse>> {
        if (requestParameters.pageNo === null || requestParameters.pageNo === undefined) {
            throw new runtime.RequiredError('pageNo','Required parameter requestParameters.pageNo was null or undefined when calling searchApiControllerSearchProducts.');
        }

        if (requestParameters.pageSize === null || requestParameters.pageSize === undefined) {
            throw new runtime.RequiredError('pageSize','Required parameter requestParameters.pageSize was null or undefined when calling searchApiControllerSearchProducts.');
        }

        const queryParameters: any = {};

        if (requestParameters.pageNo !== undefined) {
            queryParameters['pageNo'] = requestParameters.pageNo;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['pageSize'] = requestParameters.pageSize;
        }

        if (requestParameters.query !== undefined) {
            queryParameters['query'] = requestParameters.query;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xPopPlatform !== undefined && requestParameters.xPopPlatform !== null) {
            headerParameters['x-pop-platform'] = String(requestParameters.xPopPlatform);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/products:search`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Public API
     */
    async searchApiControllerSearchProducts(requestParameters: SearchApiControllerSearchProductsRequest): Promise<SearchProductsResponse> {
        const response = await this.searchApiControllerSearchProductsRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async searchApiControllerSearchProfilesRaw(requestParameters: SearchApiControllerSearchProfilesRequest): Promise<runtime.ApiResponse<ProfileSearchResponse>> {
        if (requestParameters.pageNo === null || requestParameters.pageNo === undefined) {
            throw new runtime.RequiredError('pageNo','Required parameter requestParameters.pageNo was null or undefined when calling searchApiControllerSearchProfiles.');
        }

        if (requestParameters.pageSize === null || requestParameters.pageSize === undefined) {
            throw new runtime.RequiredError('pageSize','Required parameter requestParameters.pageSize was null or undefined when calling searchApiControllerSearchProfiles.');
        }

        const queryParameters: any = {};

        if (requestParameters.pageNo !== undefined) {
            queryParameters['pageNo'] = requestParameters.pageNo;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['pageSize'] = requestParameters.pageSize;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.id) {
            queryParameters['id'] = requestParameters.id;
        }

        if (requestParameters.filterBy !== undefined) {
            queryParameters['filterBy'] = requestParameters.filterBy;
        }

        if (requestParameters.query !== undefined) {
            queryParameters['query'] = requestParameters.query;
        }

        if (requestParameters.userType) {
            queryParameters['userType'] = requestParameters.userType;
        }

        if (requestParameters.sortBy !== undefined) {
            queryParameters['sortBy'] = requestParameters.sortBy;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/profiles:search`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async searchApiControllerSearchProfiles(requestParameters: SearchApiControllerSearchProfilesRequest): Promise<ProfileSearchResponse> {
        const response = await this.searchApiControllerSearchProfilesRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async searchApiControllerSearchProfilesFollowersRaw(requestParameters: SearchApiControllerSearchProfilesFollowersRequest): Promise<runtime.ApiResponse<ProfilesFollowersSearchResponse>> {
        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling searchApiControllerSearchProfilesFollowers.');
        }

        if (requestParameters.pageNo === null || requestParameters.pageNo === undefined) {
            throw new runtime.RequiredError('pageNo','Required parameter requestParameters.pageNo was null or undefined when calling searchApiControllerSearchProfilesFollowers.');
        }

        if (requestParameters.pageSize === null || requestParameters.pageSize === undefined) {
            throw new runtime.RequiredError('pageSize','Required parameter requestParameters.pageSize was null or undefined when calling searchApiControllerSearchProfilesFollowers.');
        }

        const queryParameters: any = {};

        if (requestParameters.pageNo !== undefined) {
            queryParameters['pageNo'] = requestParameters.pageNo;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['pageSize'] = requestParameters.pageSize;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.query !== undefined) {
            queryParameters['query'] = requestParameters.query;
        }

        if (requestParameters.expand !== undefined) {
            queryParameters['expand'] = requestParameters.expand;
        }

        if (requestParameters.sortBy !== undefined) {
            queryParameters['sortBy'] = requestParameters.sortBy;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/profiles/{userId}/followers:search`.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async searchApiControllerSearchProfilesFollowers(requestParameters: SearchApiControllerSearchProfilesFollowersRequest): Promise<ProfilesFollowersSearchResponse> {
        const response = await this.searchApiControllerSearchProfilesFollowersRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async searchApiControllerSearchProfilesFollowingsRaw(requestParameters: SearchApiControllerSearchProfilesFollowingsRequest): Promise<runtime.ApiResponse<ProfilesFollowingsSearchResponse>> {
        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling searchApiControllerSearchProfilesFollowings.');
        }

        if (requestParameters.pageNo === null || requestParameters.pageNo === undefined) {
            throw new runtime.RequiredError('pageNo','Required parameter requestParameters.pageNo was null or undefined when calling searchApiControllerSearchProfilesFollowings.');
        }

        if (requestParameters.pageSize === null || requestParameters.pageSize === undefined) {
            throw new runtime.RequiredError('pageSize','Required parameter requestParameters.pageSize was null or undefined when calling searchApiControllerSearchProfilesFollowings.');
        }

        const queryParameters: any = {};

        if (requestParameters.pageNo !== undefined) {
            queryParameters['pageNo'] = requestParameters.pageNo;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['pageSize'] = requestParameters.pageSize;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.query !== undefined) {
            queryParameters['query'] = requestParameters.query;
        }

        if (requestParameters.sortBy !== undefined) {
            queryParameters['sortBy'] = requestParameters.sortBy;
        }

        if (requestParameters.userType) {
            queryParameters['userType'] = requestParameters.userType;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/profiles/{userId}/followings:search`.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async searchApiControllerSearchProfilesFollowings(requestParameters: SearchApiControllerSearchProfilesFollowingsRequest): Promise<ProfilesFollowingsSearchResponse> {
        const response = await this.searchApiControllerSearchProfilesFollowingsRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async searchApiControllerSearchPslCategoriesRaw(requestParameters: SearchApiControllerSearchPslCategoriesRequest): Promise<runtime.ApiResponse<ProductCategoriesSearchResponse>> {
        if (requestParameters.pageNo === null || requestParameters.pageNo === undefined) {
            throw new runtime.RequiredError('pageNo','Required parameter requestParameters.pageNo was null or undefined when calling searchApiControllerSearchPslCategories.');
        }

        if (requestParameters.pageSize === null || requestParameters.pageSize === undefined) {
            throw new runtime.RequiredError('pageSize','Required parameter requestParameters.pageSize was null or undefined when calling searchApiControllerSearchPslCategories.');
        }

        const queryParameters: any = {};

        if (requestParameters.pageNo !== undefined) {
            queryParameters['pageNo'] = requestParameters.pageNo;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['pageSize'] = requestParameters.pageSize;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.query !== undefined) {
            queryParameters['query'] = requestParameters.query;
        }

        if (requestParameters.id) {
            queryParameters['id'] = requestParameters.id;
        }

        if (requestParameters.parentId !== undefined) {
            queryParameters['parentId'] = requestParameters.parentId;
        }

        if (requestParameters.isRoot !== undefined) {
            queryParameters['isRoot'] = requestParameters.isRoot;
        }

        if (requestParameters.enabled !== undefined) {
            queryParameters['enabled'] = requestParameters.enabled;
        }

        if (requestParameters.custom !== undefined) {
            queryParameters['custom'] = requestParameters.custom;
        }

        if (requestParameters.digital !== undefined) {
            queryParameters['digital'] = requestParameters.digital;
        }

        if (requestParameters.loadLinkedGoogleCategories !== undefined) {
            queryParameters['loadLinkedGoogleCategories'] = requestParameters.loadLinkedGoogleCategories;
        }

        if (requestParameters.sortBy !== undefined) {
            queryParameters['sortBy'] = requestParameters.sortBy;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/product-categories:search`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async searchApiControllerSearchPslCategories(requestParameters: SearchApiControllerSearchPslCategoriesRequest): Promise<ProductCategoriesSearchResponse> {
        const response = await this.searchApiControllerSearchPslCategoriesRaw(requestParameters);
        return await response.value();
    }

    /**
     * Public API
     */
    async searchApiControllerSearchPublicListingsRaw(requestParameters: SearchApiControllerSearchPublicListingsRequest): Promise<runtime.ApiResponse<StoreListingSearchResponse>> {
        if (requestParameters.pageNo === null || requestParameters.pageNo === undefined) {
            throw new runtime.RequiredError('pageNo','Required parameter requestParameters.pageNo was null or undefined when calling searchApiControllerSearchPublicListings.');
        }

        if (requestParameters.pageSize === null || requestParameters.pageSize === undefined) {
            throw new runtime.RequiredError('pageSize','Required parameter requestParameters.pageSize was null or undefined when calling searchApiControllerSearchPublicListings.');
        }

        const queryParameters: any = {};

        if (requestParameters.pageNo !== undefined) {
            queryParameters['pageNo'] = requestParameters.pageNo;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['pageSize'] = requestParameters.pageSize;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.id) {
            queryParameters['id'] = requestParameters.id;
        }

        if (requestParameters.query !== undefined) {
            queryParameters['query'] = requestParameters.query;
        }

        if (requestParameters.categoryRowId !== undefined) {
            queryParameters['categoryRowId'] = requestParameters.categoryRowId;
        }

        if (requestParameters.categoryId !== undefined) {
            queryParameters['categoryId'] = requestParameters.categoryId;
        }

        if (requestParameters.productCategoryId) {
            queryParameters['productCategoryId'] = requestParameters.productCategoryId;
        }

        if (requestParameters.includeChildCategories !== undefined) {
            queryParameters['includeChildCategories'] = requestParameters.includeChildCategories;
        }

        if (requestParameters.collectionId !== undefined) {
            queryParameters['collectionId'] = requestParameters.collectionId;
        }

        if (requestParameters.tags) {
            queryParameters['tags'] = requestParameters.tags;
        }

        if (requestParameters.sellerTags) {
            queryParameters['sellerTags'] = requestParameters.sellerTags;
        }

        if (requestParameters.status !== undefined) {
            queryParameters['status'] = requestParameters.status;
        }

        if (requestParameters.minQuantity !== undefined) {
            queryParameters['minQuantity'] = requestParameters.minQuantity;
        }

        if (requestParameters.sortBy !== undefined) {
            queryParameters['sortBy'] = requestParameters.sortBy;
        }

        if (requestParameters.tagsFilterOperator !== undefined) {
            queryParameters['tagsFilterOperator'] = requestParameters.tagsFilterOperator;
        }

        if (requestParameters.sellerIds) {
            queryParameters['sellerIds'] = requestParameters.sellerIds;
        }

        if (requestParameters.featured !== undefined) {
            queryParameters['featured'] = requestParameters.featured;
        }

        if (requestParameters.prefetchFeaturedStatus !== undefined) {
            queryParameters['prefetchFeaturedStatus'] = requestParameters.prefetchFeaturedStatus;
        }

        if (requestParameters.listingType) {
            queryParameters['listingType'] = requestParameters.listingType;
        }

        if (requestParameters.excludeListingType) {
            queryParameters['excludeListingType'] = requestParameters.excludeListingType;
        }

        if (requestParameters.minMeetingStartDate !== undefined) {
            queryParameters['minMeetingStartDate'] = requestParameters.minMeetingStartDate;
        }

        if (requestParameters.maxMeetingStartDate !== undefined) {
            queryParameters['maxMeetingStartDate'] = requestParameters.maxMeetingStartDate;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/public-listings:search`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Public API
     */
    async searchApiControllerSearchPublicListings(requestParameters: SearchApiControllerSearchPublicListingsRequest): Promise<StoreListingSearchResponse> {
        const response = await this.searchApiControllerSearchPublicListingsRaw(requestParameters);
        return await response.value();
    }

    /**
     * Public API
     */
    async searchApiControllerSearchPublicListingsV2Raw(requestParameters: SearchApiControllerSearchPublicListingsV2Request): Promise<runtime.ApiResponse<StoreListingSearchResponse>> {
        if (requestParameters.pageNo === null || requestParameters.pageNo === undefined) {
            throw new runtime.RequiredError('pageNo','Required parameter requestParameters.pageNo was null or undefined when calling searchApiControllerSearchPublicListingsV2.');
        }

        if (requestParameters.pageSize === null || requestParameters.pageSize === undefined) {
            throw new runtime.RequiredError('pageSize','Required parameter requestParameters.pageSize was null or undefined when calling searchApiControllerSearchPublicListingsV2.');
        }

        const queryParameters: any = {};

        if (requestParameters.pageNo !== undefined) {
            queryParameters['pageNo'] = requestParameters.pageNo;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['pageSize'] = requestParameters.pageSize;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.id) {
            queryParameters['id'] = requestParameters.id;
        }

        if (requestParameters.query !== undefined) {
            queryParameters['query'] = requestParameters.query;
        }

        if (requestParameters.categoryRowId !== undefined) {
            queryParameters['categoryRowId'] = requestParameters.categoryRowId;
        }

        if (requestParameters.categoryId !== undefined) {
            queryParameters['categoryId'] = requestParameters.categoryId;
        }

        if (requestParameters.productCategoryId) {
            queryParameters['productCategoryId'] = requestParameters.productCategoryId;
        }

        if (requestParameters.includeChildCategories !== undefined) {
            queryParameters['includeChildCategories'] = requestParameters.includeChildCategories;
        }

        if (requestParameters.collectionId !== undefined) {
            queryParameters['collectionId'] = requestParameters.collectionId;
        }

        if (requestParameters.tags) {
            queryParameters['tags'] = requestParameters.tags;
        }

        if (requestParameters.sellerTags) {
            queryParameters['sellerTags'] = requestParameters.sellerTags;
        }

        if (requestParameters.status !== undefined) {
            queryParameters['status'] = requestParameters.status;
        }

        if (requestParameters.minQuantity !== undefined) {
            queryParameters['minQuantity'] = requestParameters.minQuantity;
        }

        if (requestParameters.sortBy !== undefined) {
            queryParameters['sortBy'] = requestParameters.sortBy;
        }

        if (requestParameters.tagsFilterOperator !== undefined) {
            queryParameters['tagsFilterOperator'] = requestParameters.tagsFilterOperator;
        }

        if (requestParameters.sellerIds) {
            queryParameters['sellerIds'] = requestParameters.sellerIds;
        }

        if (requestParameters.featured !== undefined) {
            queryParameters['featured'] = requestParameters.featured;
        }

        if (requestParameters.prefetchFeaturedStatus !== undefined) {
            queryParameters['prefetchFeaturedStatus'] = requestParameters.prefetchFeaturedStatus;
        }

        if (requestParameters.listingType) {
            queryParameters['listingType'] = requestParameters.listingType;
        }

        if (requestParameters.excludeListingType) {
            queryParameters['excludeListingType'] = requestParameters.excludeListingType;
        }

        if (requestParameters.minMeetingStartDate !== undefined) {
            queryParameters['minMeetingStartDate'] = requestParameters.minMeetingStartDate;
        }

        if (requestParameters.maxMeetingStartDate !== undefined) {
            queryParameters['maxMeetingStartDate'] = requestParameters.maxMeetingStartDate;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xPopPlatform !== undefined && requestParameters.xPopPlatform !== null) {
            headerParameters['x-pop-platform'] = String(requestParameters.xPopPlatform);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v2/public-listings:search`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Public API
     */
    async searchApiControllerSearchPublicListingsV2(requestParameters: SearchApiControllerSearchPublicListingsV2Request): Promise<StoreListingSearchResponse> {
        const response = await this.searchApiControllerSearchPublicListingsV2Raw(requestParameters);
        return await response.value();
    }

    /**
     * Public API
     */
    async searchApiControllerSearchPurchasedStoresRaw(requestParameters: SearchApiControllerSearchPurchasedStoresRequest): Promise<runtime.ApiResponse<PurchasedStoresResponse>> {
        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling searchApiControllerSearchPurchasedStores.');
        }

        const queryParameters: any = {};

        if (requestParameters.size !== undefined) {
            queryParameters['size'] = requestParameters.size;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/users/{userId}/purchased-stores:search`.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Public API
     */
    async searchApiControllerSearchPurchasedStores(requestParameters: SearchApiControllerSearchPurchasedStoresRequest): Promise<PurchasedStoresResponse> {
        const response = await this.searchApiControllerSearchPurchasedStoresRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async searchApiControllerSearchRedeemedCouponsRaw(requestParameters: SearchApiControllerSearchRedeemedCouponsRequest): Promise<runtime.ApiResponse<SearchRedeemedCouponsResponse>> {
        if (requestParameters.pageNo === null || requestParameters.pageNo === undefined) {
            throw new runtime.RequiredError('pageNo','Required parameter requestParameters.pageNo was null or undefined when calling searchApiControllerSearchRedeemedCoupons.');
        }

        if (requestParameters.pageSize === null || requestParameters.pageSize === undefined) {
            throw new runtime.RequiredError('pageSize','Required parameter requestParameters.pageSize was null or undefined when calling searchApiControllerSearchRedeemedCoupons.');
        }

        const queryParameters: any = {};

        if (requestParameters.pageNo !== undefined) {
            queryParameters['pageNo'] = requestParameters.pageNo;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['pageSize'] = requestParameters.pageSize;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.id) {
            queryParameters['id'] = requestParameters.id;
        }

        if (requestParameters.filterBy !== undefined) {
            queryParameters['filterBy'] = requestParameters.filterBy;
        }

        if (requestParameters.query !== undefined) {
            queryParameters['query'] = requestParameters.query;
        }

        if (requestParameters.used !== undefined) {
            queryParameters['used'] = requestParameters.used;
        }

        if (requestParameters.sortBy !== undefined) {
            queryParameters['sortBy'] = requestParameters.sortBy;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/redeemed-coupons:search`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async searchApiControllerSearchRedeemedCoupons(requestParameters: SearchApiControllerSearchRedeemedCouponsRequest): Promise<SearchRedeemedCouponsResponse> {
        const response = await this.searchApiControllerSearchRedeemedCouponsRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async searchApiControllerSearchReferralGiftsRaw(requestParameters: SearchApiControllerSearchReferralGiftsRequest): Promise<runtime.ApiResponse<SearchReferralGiftsResponse>> {
        if (requestParameters.pageNo === null || requestParameters.pageNo === undefined) {
            throw new runtime.RequiredError('pageNo','Required parameter requestParameters.pageNo was null or undefined when calling searchApiControllerSearchReferralGifts.');
        }

        if (requestParameters.pageSize === null || requestParameters.pageSize === undefined) {
            throw new runtime.RequiredError('pageSize','Required parameter requestParameters.pageSize was null or undefined when calling searchApiControllerSearchReferralGifts.');
        }

        const queryParameters: any = {};

        if (requestParameters.pageNo !== undefined) {
            queryParameters['pageNo'] = requestParameters.pageNo;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['pageSize'] = requestParameters.pageSize;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.id) {
            queryParameters['id'] = requestParameters.id;
        }

        if (requestParameters.storeId !== undefined) {
            queryParameters['storeId'] = requestParameters.storeId;
        }

        if (requestParameters.query !== undefined) {
            queryParameters['query'] = requestParameters.query;
        }

        if (requestParameters.sortBy !== undefined) {
            queryParameters['sortBy'] = requestParameters.sortBy;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/referral-gifts:search`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async searchApiControllerSearchReferralGifts(requestParameters: SearchApiControllerSearchReferralGiftsRequest): Promise<SearchReferralGiftsResponse> {
        const response = await this.searchApiControllerSearchReferralGiftsRaw(requestParameters);
        return await response.value();
    }

    /**
     * Public API
     */
    async searchApiControllerSearchReplayLiveStreamsRaw(requestParameters: SearchApiControllerSearchReplayLiveStreamsRequest): Promise<runtime.ApiResponse<LiveStreamsSearchResponse>> {
        if (requestParameters.pageNo === null || requestParameters.pageNo === undefined) {
            throw new runtime.RequiredError('pageNo','Required parameter requestParameters.pageNo was null or undefined when calling searchApiControllerSearchReplayLiveStreams.');
        }

        if (requestParameters.pageSize === null || requestParameters.pageSize === undefined) {
            throw new runtime.RequiredError('pageSize','Required parameter requestParameters.pageSize was null or undefined when calling searchApiControllerSearchReplayLiveStreams.');
        }

        const queryParameters: any = {};

        if (requestParameters.pageNo !== undefined) {
            queryParameters['pageNo'] = requestParameters.pageNo;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['pageSize'] = requestParameters.pageSize;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.userId !== undefined) {
            queryParameters['userId'] = requestParameters.userId;
        }

        if (requestParameters.storeName !== undefined) {
            queryParameters['storeName'] = requestParameters.storeName;
        }

        if (requestParameters.approverName !== undefined) {
            queryParameters['approverName'] = requestParameters.approverName;
        }

        if (requestParameters.approverEmail !== undefined) {
            queryParameters['approverEmail'] = requestParameters.approverEmail;
        }

        if (requestParameters.hasListing !== undefined) {
            queryParameters['hasListing'] = requestParameters.hasListing;
        }

        if (requestParameters.hasOrder !== undefined) {
            queryParameters['hasOrder'] = requestParameters.hasOrder;
        }

        if (requestParameters.popStoreOnly !== undefined) {
            queryParameters['popStoreOnly'] = requestParameters.popStoreOnly;
        }

        if (requestParameters.minCreatedAt !== undefined) {
            queryParameters['minCreatedAt'] = requestParameters.minCreatedAt;
        }

        if (requestParameters.maxCreatedAt !== undefined) {
            queryParameters['maxCreatedAt'] = requestParameters.maxCreatedAt;
        }

        if (requestParameters.moderationStatus !== undefined) {
            queryParameters['moderationStatus'] = requestParameters.moderationStatus;
        }

        if (requestParameters.sortBy !== undefined) {
            queryParameters['sortBy'] = requestParameters.sortBy;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/replay-live-streams:search`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Public API
     */
    async searchApiControllerSearchReplayLiveStreams(requestParameters: SearchApiControllerSearchReplayLiveStreamsRequest): Promise<LiveStreamsSearchResponse> {
        const response = await this.searchApiControllerSearchReplayLiveStreamsRaw(requestParameters);
        return await response.value();
    }

    /**
     * search public reviews by user in app
     * Public API
     */
    async searchApiControllerSearchReviewsByUserRaw(requestParameters: SearchApiControllerSearchReviewsByUserRequest): Promise<runtime.ApiResponse<MessagesSearchResponse>> {
        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling searchApiControllerSearchReviewsByUser.');
        }

        if (requestParameters.pageNo === null || requestParameters.pageNo === undefined) {
            throw new runtime.RequiredError('pageNo','Required parameter requestParameters.pageNo was null or undefined when calling searchApiControllerSearchReviewsByUser.');
        }

        if (requestParameters.pageSize === null || requestParameters.pageSize === undefined) {
            throw new runtime.RequiredError('pageSize','Required parameter requestParameters.pageSize was null or undefined when calling searchApiControllerSearchReviewsByUser.');
        }

        const queryParameters: any = {};

        if (requestParameters.pageNo !== undefined) {
            queryParameters['pageNo'] = requestParameters.pageNo;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['pageSize'] = requestParameters.pageSize;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.sortBy !== undefined) {
            queryParameters['sortBy'] = requestParameters.sortBy;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/users/{userId}/reviews:search`.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     * search public reviews by user in app
     * Public API
     */
    async searchApiControllerSearchReviewsByUser(requestParameters: SearchApiControllerSearchReviewsByUserRequest): Promise<MessagesSearchResponse> {
        const response = await this.searchApiControllerSearchReviewsByUserRaw(requestParameters);
        return await response.value();
    }

    /**
     * search public reviews to seller in app
     * Public API
     */
    async searchApiControllerSearchReviewsToSellerRaw(requestParameters: SearchApiControllerSearchReviewsToSellerRequest): Promise<runtime.ApiResponse<MessagesSearchResponse>> {
        if (requestParameters.sellerId === null || requestParameters.sellerId === undefined) {
            throw new runtime.RequiredError('sellerId','Required parameter requestParameters.sellerId was null or undefined when calling searchApiControllerSearchReviewsToSeller.');
        }

        if (requestParameters.pageNo === null || requestParameters.pageNo === undefined) {
            throw new runtime.RequiredError('pageNo','Required parameter requestParameters.pageNo was null or undefined when calling searchApiControllerSearchReviewsToSeller.');
        }

        if (requestParameters.pageSize === null || requestParameters.pageSize === undefined) {
            throw new runtime.RequiredError('pageSize','Required parameter requestParameters.pageSize was null or undefined when calling searchApiControllerSearchReviewsToSeller.');
        }

        const queryParameters: any = {};

        if (requestParameters.pageNo !== undefined) {
            queryParameters['pageNo'] = requestParameters.pageNo;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['pageSize'] = requestParameters.pageSize;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.sortBy !== undefined) {
            queryParameters['sortBy'] = requestParameters.sortBy;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/stores/{sellerId}/reviews:search`.replace(`{${"sellerId"}}`, encodeURIComponent(String(requestParameters.sellerId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     * search public reviews to seller in app
     * Public API
     */
    async searchApiControllerSearchReviewsToSeller(requestParameters: SearchApiControllerSearchReviewsToSellerRequest): Promise<MessagesSearchResponse> {
        const response = await this.searchApiControllerSearchReviewsToSellerRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async searchApiControllerSearchRolesRaw(requestParameters: SearchApiControllerSearchRolesRequest): Promise<runtime.ApiResponse<RolesSearchResponse>> {
        if (requestParameters.pageNo === null || requestParameters.pageNo === undefined) {
            throw new runtime.RequiredError('pageNo','Required parameter requestParameters.pageNo was null or undefined when calling searchApiControllerSearchRoles.');
        }

        if (requestParameters.pageSize === null || requestParameters.pageSize === undefined) {
            throw new runtime.RequiredError('pageSize','Required parameter requestParameters.pageSize was null or undefined when calling searchApiControllerSearchRoles.');
        }

        const queryParameters: any = {};

        if (requestParameters.pageNo !== undefined) {
            queryParameters['pageNo'] = requestParameters.pageNo;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['pageSize'] = requestParameters.pageSize;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.query !== undefined) {
            queryParameters['query'] = requestParameters.query;
        }

        if (requestParameters.uid !== undefined) {
            queryParameters['uid'] = requestParameters.uid;
        }

        if (requestParameters.isAdmin !== undefined) {
            queryParameters['isAdmin'] = requestParameters.isAdmin;
        }

        if (requestParameters.roles) {
            queryParameters['roles'] = requestParameters.roles;
        }

        if (requestParameters.sortBy !== undefined) {
            queryParameters['sortBy'] = requestParameters.sortBy;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/roles:search`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async searchApiControllerSearchRoles(requestParameters: SearchApiControllerSearchRolesRequest): Promise<RolesSearchResponse> {
        const response = await this.searchApiControllerSearchRolesRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async searchApiControllerSearchSellerIncentivePayoutsRaw(requestParameters: SearchApiControllerSearchSellerIncentivePayoutsRequest): Promise<runtime.ApiResponse<StoreIncentivePayoutSearchResponse>> {
        if (requestParameters.sellerId === null || requestParameters.sellerId === undefined) {
            throw new runtime.RequiredError('sellerId','Required parameter requestParameters.sellerId was null or undefined when calling searchApiControllerSearchSellerIncentivePayouts.');
        }

        if (requestParameters.pageNo === null || requestParameters.pageNo === undefined) {
            throw new runtime.RequiredError('pageNo','Required parameter requestParameters.pageNo was null or undefined when calling searchApiControllerSearchSellerIncentivePayouts.');
        }

        if (requestParameters.pageSize === null || requestParameters.pageSize === undefined) {
            throw new runtime.RequiredError('pageSize','Required parameter requestParameters.pageSize was null or undefined when calling searchApiControllerSearchSellerIncentivePayouts.');
        }

        const queryParameters: any = {};

        if (requestParameters.pageNo !== undefined) {
            queryParameters['pageNo'] = requestParameters.pageNo;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['pageSize'] = requestParameters.pageSize;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.id) {
            queryParameters['id'] = requestParameters.id;
        }

        if (requestParameters.query !== undefined) {
            queryParameters['query'] = requestParameters.query;
        }

        if (requestParameters.status !== undefined) {
            queryParameters['status'] = requestParameters.status;
        }

        if (requestParameters.minCreatedAt !== undefined) {
            queryParameters['minCreatedAt'] = requestParameters.minCreatedAt;
        }

        if (requestParameters.maxCreatedAt !== undefined) {
            queryParameters['maxCreatedAt'] = requestParameters.maxCreatedAt;
        }

        if (requestParameters.sortBy !== undefined) {
            queryParameters['sortBy'] = requestParameters.sortBy;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/stores/{sellerId}/incentive-payouts:search`.replace(`{${"sellerId"}}`, encodeURIComponent(String(requestParameters.sellerId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async searchApiControllerSearchSellerIncentivePayouts(requestParameters: SearchApiControllerSearchSellerIncentivePayoutsRequest): Promise<StoreIncentivePayoutSearchResponse> {
        const response = await this.searchApiControllerSearchSellerIncentivePayoutsRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async searchApiControllerSearchSellerLifeTimeStatsRaw(requestParameters: SearchApiControllerSearchSellerLifeTimeStatsRequest): Promise<runtime.ApiResponse<SearchSellerLifeTimeStatsResponse>> {
        if (requestParameters.sellerId === null || requestParameters.sellerId === undefined) {
            throw new runtime.RequiredError('sellerId','Required parameter requestParameters.sellerId was null or undefined when calling searchApiControllerSearchSellerLifeTimeStats.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/stores/{sellerId}/lifetime-stats:search`.replace(`{${"sellerId"}}`, encodeURIComponent(String(requestParameters.sellerId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async searchApiControllerSearchSellerLifeTimeStats(requestParameters: SearchApiControllerSearchSellerLifeTimeStatsRequest): Promise<SearchSellerLifeTimeStatsResponse> {
        const response = await this.searchApiControllerSearchSellerLifeTimeStatsRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async searchApiControllerSearchSellerLiveStreamsStatsRaw(requestParameters: SearchApiControllerSearchSellerLiveStreamsStatsRequest): Promise<runtime.ApiResponse<SearchSellerLiveStreamsStatsResponse>> {
        if (requestParameters.sellerId === null || requestParameters.sellerId === undefined) {
            throw new runtime.RequiredError('sellerId','Required parameter requestParameters.sellerId was null or undefined when calling searchApiControllerSearchSellerLiveStreamsStats.');
        }

        if (requestParameters.searchSellerLiveStreamsStatsRequest === null || requestParameters.searchSellerLiveStreamsStatsRequest === undefined) {
            throw new runtime.RequiredError('searchSellerLiveStreamsStatsRequest','Required parameter requestParameters.searchSellerLiveStreamsStatsRequest was null or undefined when calling searchApiControllerSearchSellerLiveStreamsStats.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/stores/{sellerId}/live-stream-stats:search`.replace(`{${"sellerId"}}`, encodeURIComponent(String(requestParameters.sellerId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.searchSellerLiveStreamsStatsRequest,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async searchApiControllerSearchSellerLiveStreamsStats(requestParameters: SearchApiControllerSearchSellerLiveStreamsStatsRequest): Promise<SearchSellerLiveStreamsStatsResponse> {
        const response = await this.searchApiControllerSearchSellerLiveStreamsStatsRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async searchApiControllerSearchSellerMainOrderStatsRaw(requestParameters: SearchApiControllerSearchSellerMainOrderStatsRequest): Promise<runtime.ApiResponse<SearchSellerMainOrderStatsResponse>> {
        if (requestParameters.sellerId === null || requestParameters.sellerId === undefined) {
            throw new runtime.RequiredError('sellerId','Required parameter requestParameters.sellerId was null or undefined when calling searchApiControllerSearchSellerMainOrderStats.');
        }

        if (requestParameters.searchSellerMainOrderStatsRequest === null || requestParameters.searchSellerMainOrderStatsRequest === undefined) {
            throw new runtime.RequiredError('searchSellerMainOrderStatsRequest','Required parameter requestParameters.searchSellerMainOrderStatsRequest was null or undefined when calling searchApiControllerSearchSellerMainOrderStats.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/stores/{sellerId}/main-order-stats:search`.replace(`{${"sellerId"}}`, encodeURIComponent(String(requestParameters.sellerId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.searchSellerMainOrderStatsRequest,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async searchApiControllerSearchSellerMainOrderStats(requestParameters: SearchApiControllerSearchSellerMainOrderStatsRequest): Promise<SearchSellerMainOrderStatsResponse> {
        const response = await this.searchApiControllerSearchSellerMainOrderStatsRaw(requestParameters);
        return await response.value();
    }

    /**
     * for seller dashboard page or seller in app
     */
    async searchApiControllerSearchSellerMessagesRaw(requestParameters: SearchApiControllerSearchSellerMessagesRequest): Promise<runtime.ApiResponse<MessagesSearchResponse>> {
        if (requestParameters.sellerId === null || requestParameters.sellerId === undefined) {
            throw new runtime.RequiredError('sellerId','Required parameter requestParameters.sellerId was null or undefined when calling searchApiControllerSearchSellerMessages.');
        }

        if (requestParameters.pageNo === null || requestParameters.pageNo === undefined) {
            throw new runtime.RequiredError('pageNo','Required parameter requestParameters.pageNo was null or undefined when calling searchApiControllerSearchSellerMessages.');
        }

        if (requestParameters.pageSize === null || requestParameters.pageSize === undefined) {
            throw new runtime.RequiredError('pageSize','Required parameter requestParameters.pageSize was null or undefined when calling searchApiControllerSearchSellerMessages.');
        }

        if (requestParameters.filterBy === null || requestParameters.filterBy === undefined) {
            throw new runtime.RequiredError('filterBy','Required parameter requestParameters.filterBy was null or undefined when calling searchApiControllerSearchSellerMessages.');
        }

        const queryParameters: any = {};

        if (requestParameters.pageNo !== undefined) {
            queryParameters['pageNo'] = requestParameters.pageNo;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['pageSize'] = requestParameters.pageSize;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.id) {
            queryParameters['id'] = requestParameters.id;
        }

        if (requestParameters.orderIds) {
            queryParameters['orderIds'] = requestParameters.orderIds;
        }

        if (requestParameters.available !== undefined) {
            queryParameters['available'] = requestParameters.available;
        }

        if (requestParameters.featured !== undefined) {
            queryParameters['featured'] = requestParameters.featured;
        }

        if (requestParameters.userIdTo !== undefined) {
            queryParameters['userIdTo'] = requestParameters.userIdTo;
        }

        if (requestParameters.userIdFrom !== undefined) {
            queryParameters['userIdFrom'] = requestParameters.userIdFrom;
        }

        if (requestParameters.sellerId2 !== undefined) {
            queryParameters['sellerId'] = requestParameters.sellerId2;
        }

        if (requestParameters.buyerId !== undefined) {
            queryParameters['buyerId'] = requestParameters.buyerId;
        }

        if (requestParameters.listingId !== undefined) {
            queryParameters['listingId'] = requestParameters.listingId;
        }

        if (requestParameters.orderId !== undefined) {
            queryParameters['orderId'] = requestParameters.orderId;
        }

        if (requestParameters.query !== undefined) {
            queryParameters['query'] = requestParameters.query;
        }

        if (requestParameters.filterBy !== undefined) {
            queryParameters['filterBy'] = requestParameters.filterBy;
        }

        if (requestParameters.reportFilterBy !== undefined) {
            queryParameters['reportFilterBy'] = requestParameters.reportFilterBy;
        }

        if (requestParameters.purpose !== undefined) {
            queryParameters['purpose'] = requestParameters.purpose;
        }

        if (requestParameters.thankYouType) {
            queryParameters['thankYouType'] = requestParameters.thankYouType;
        }

        if (requestParameters.sortBy !== undefined) {
            queryParameters['sortBy'] = requestParameters.sortBy;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/stores/{sellerId}/messages:search`.replace(`{${"sellerId"}}`, encodeURIComponent(String(requestParameters.sellerId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     * for seller dashboard page or seller in app
     */
    async searchApiControllerSearchSellerMessages(requestParameters: SearchApiControllerSearchSellerMessagesRequest): Promise<MessagesSearchResponse> {
        const response = await this.searchApiControllerSearchSellerMessagesRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async searchApiControllerSearchSellerOrderDetailsRaw(requestParameters: SearchApiControllerSearchSellerOrderDetailsRequest): Promise<runtime.ApiResponse<OrderDetailsSearchResponse>> {
        if (requestParameters.sellerId === null || requestParameters.sellerId === undefined) {
            throw new runtime.RequiredError('sellerId','Required parameter requestParameters.sellerId was null or undefined when calling searchApiControllerSearchSellerOrderDetails.');
        }

        if (requestParameters.pageNo === null || requestParameters.pageNo === undefined) {
            throw new runtime.RequiredError('pageNo','Required parameter requestParameters.pageNo was null or undefined when calling searchApiControllerSearchSellerOrderDetails.');
        }

        if (requestParameters.pageSize === null || requestParameters.pageSize === undefined) {
            throw new runtime.RequiredError('pageSize','Required parameter requestParameters.pageSize was null or undefined when calling searchApiControllerSearchSellerOrderDetails.');
        }

        const queryParameters: any = {};

        if (requestParameters.pageNo !== undefined) {
            queryParameters['pageNo'] = requestParameters.pageNo;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['pageSize'] = requestParameters.pageSize;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.ids) {
            queryParameters['ids'] = requestParameters.ids;
        }

        if (requestParameters.query !== undefined) {
            queryParameters['query'] = requestParameters.query;
        }

        if (requestParameters.masterOrderId) {
            queryParameters['masterOrderId'] = requestParameters.masterOrderId;
        }

        if (requestParameters.orderNumber !== undefined) {
            queryParameters['orderNumber'] = requestParameters.orderNumber;
        }

        if (requestParameters.liveStreamId !== undefined) {
            queryParameters['liveStreamId'] = requestParameters.liveStreamId;
        }

        if (requestParameters.status) {
            queryParameters['status'] = requestParameters.status;
        }

        if (requestParameters.orderGroupStatus) {
            queryParameters['orderGroupStatus'] = requestParameters.orderGroupStatus;
        }

        if (requestParameters.pickupStatus) {
            queryParameters['pickupStatus'] = requestParameters.pickupStatus;
        }

        if (requestParameters.groupStatusMaster !== undefined) {
            queryParameters['groupStatusMaster'] = requestParameters.groupStatusMaster;
        }

        if (requestParameters.groupStatus) {
            queryParameters['groupStatus'] = requestParameters.groupStatus;
        }

        if (requestParameters.packed !== undefined) {
            queryParameters['packed'] = requestParameters.packed;
        }

        if (requestParameters.allOrders !== undefined) {
            queryParameters['allOrders'] = requestParameters.allOrders;
        }

        if (requestParameters.shippingMethod) {
            queryParameters['shippingMethod'] = requestParameters.shippingMethod;
        }

        if (requestParameters.createdBefore !== undefined) {
            queryParameters['createdBefore'] = requestParameters.createdBefore;
        }

        if (requestParameters.createdAfter !== undefined) {
            queryParameters['createdAfter'] = requestParameters.createdAfter;
        }

        if (requestParameters.couponCode !== undefined) {
            queryParameters['couponCode'] = requestParameters.couponCode;
        }

        if (requestParameters.aggregateTax !== undefined) {
            queryParameters['aggregateTax'] = requestParameters.aggregateTax;
        }

        if (requestParameters.buyerUserType !== undefined) {
            queryParameters['buyerUserType'] = requestParameters.buyerUserType;
        }

        if (requestParameters.platform !== undefined) {
            queryParameters['platform'] = requestParameters.platform;
        }

        if (requestParameters.listingType !== undefined) {
            queryParameters['listingType'] = requestParameters.listingType;
        }

        if (requestParameters.showTitle !== undefined) {
            queryParameters['showTitle'] = requestParameters.showTitle;
        }

        if (requestParameters.noLiveStreamId !== undefined) {
            queryParameters['noLiveStreamId'] = requestParameters.noLiveStreamId;
        }

        if (requestParameters.mainOrderNumber !== undefined) {
            queryParameters['mainOrderNumber'] = requestParameters.mainOrderNumber;
        }

        if (requestParameters.mainStatus) {
            queryParameters['mainStatus'] = requestParameters.mainStatus;
        }

        if (requestParameters.mainPacked !== undefined) {
            queryParameters['mainPacked'] = requestParameters.mainPacked;
        }

        if (requestParameters.showCreatedBefore !== undefined) {
            queryParameters['showCreatedBefore'] = requestParameters.showCreatedBefore;
        }

        if (requestParameters.showCreatedAfter !== undefined) {
            queryParameters['showCreatedAfter'] = requestParameters.showCreatedAfter;
        }

        if (requestParameters.shippingLabelStatus) {
            queryParameters['shippingLabelStatus'] = requestParameters.shippingLabelStatus;
        }

        if (requestParameters.mainShippingLabelStatus) {
            queryParameters['mainShippingLabelStatus'] = requestParameters.mainShippingLabelStatus;
        }

        if (requestParameters.shippingStatus !== undefined) {
            queryParameters['shippingStatus'] = requestParameters.shippingStatus;
        }

        if (requestParameters.rateStatus !== undefined) {
            queryParameters['rateStatus'] = requestParameters.rateStatus;
        }

        if (requestParameters.mainShippingStatus !== undefined) {
            queryParameters['mainShippingStatus'] = requestParameters.mainShippingStatus;
        }

        if (requestParameters.filterLabelStatus !== undefined) {
            queryParameters['filterLabelStatus'] = requestParameters.filterLabelStatus;
        }

        if (requestParameters.sortBy !== undefined) {
            queryParameters['sortBy'] = requestParameters.sortBy;
        }

        if (requestParameters.paymentType) {
            queryParameters['paymentType'] = requestParameters.paymentType;
        }

        if (requestParameters.transactionDateBefore !== undefined) {
            queryParameters['transactionDateBefore'] = requestParameters.transactionDateBefore;
        }

        if (requestParameters.transactionDateAfter !== undefined) {
            queryParameters['transactionDateAfter'] = requestParameters.transactionDateAfter;
        }

        if (requestParameters.isUsingShippoPlatform !== undefined) {
            queryParameters['isUsingShippoPlatform'] = requestParameters.isUsingShippoPlatform;
        }

        if (requestParameters.loadShippingCosts !== undefined) {
            queryParameters['loadShippingCosts'] = requestParameters.loadShippingCosts;
        }

        if (requestParameters.minWeight !== undefined) {
            queryParameters['minWeight'] = requestParameters.minWeight;
        }

        if (requestParameters.maxWeight !== undefined) {
            queryParameters['maxWeight'] = requestParameters.maxWeight;
        }

        if (requestParameters.minQuantity !== undefined) {
            queryParameters['minQuantity'] = requestParameters.minQuantity;
        }

        if (requestParameters.maxQuantity !== undefined) {
            queryParameters['maxQuantity'] = requestParameters.maxQuantity;
        }

        if (requestParameters.sourceType !== undefined) {
            queryParameters['sourceType'] = requestParameters.sourceType;
        }

        if (requestParameters.sourceId !== undefined) {
            queryParameters['sourceId'] = requestParameters.sourceId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/stores/{sellerId}/order-details:search`.replace(`{${"sellerId"}}`, encodeURIComponent(String(requestParameters.sellerId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async searchApiControllerSearchSellerOrderDetails(requestParameters: SearchApiControllerSearchSellerOrderDetailsRequest): Promise<OrderDetailsSearchResponse> {
        const response = await this.searchApiControllerSearchSellerOrderDetailsRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async searchApiControllerSearchSellerOrdersRaw(requestParameters: SearchApiControllerSearchSellerOrdersRequest): Promise<runtime.ApiResponse<OrdersSearchResponse>> {
        if (requestParameters.storeId === null || requestParameters.storeId === undefined) {
            throw new runtime.RequiredError('storeId','Required parameter requestParameters.storeId was null or undefined when calling searchApiControllerSearchSellerOrders.');
        }

        if (requestParameters.pageNo === null || requestParameters.pageNo === undefined) {
            throw new runtime.RequiredError('pageNo','Required parameter requestParameters.pageNo was null or undefined when calling searchApiControllerSearchSellerOrders.');
        }

        if (requestParameters.pageSize === null || requestParameters.pageSize === undefined) {
            throw new runtime.RequiredError('pageSize','Required parameter requestParameters.pageSize was null or undefined when calling searchApiControllerSearchSellerOrders.');
        }

        const queryParameters: any = {};

        if (requestParameters.pageNo !== undefined) {
            queryParameters['pageNo'] = requestParameters.pageNo;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['pageSize'] = requestParameters.pageSize;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.ids) {
            queryParameters['ids'] = requestParameters.ids;
        }

        if (requestParameters.query !== undefined) {
            queryParameters['query'] = requestParameters.query;
        }

        if (requestParameters.masterOrderId) {
            queryParameters['masterOrderId'] = requestParameters.masterOrderId;
        }

        if (requestParameters.orderNumber !== undefined) {
            queryParameters['orderNumber'] = requestParameters.orderNumber;
        }

        if (requestParameters.liveStreamId !== undefined) {
            queryParameters['liveStreamId'] = requestParameters.liveStreamId;
        }

        if (requestParameters.status) {
            queryParameters['status'] = requestParameters.status;
        }

        if (requestParameters.orderGroupStatus) {
            queryParameters['orderGroupStatus'] = requestParameters.orderGroupStatus;
        }

        if (requestParameters.pickupStatus) {
            queryParameters['pickupStatus'] = requestParameters.pickupStatus;
        }

        if (requestParameters.groupStatusMaster !== undefined) {
            queryParameters['groupStatusMaster'] = requestParameters.groupStatusMaster;
        }

        if (requestParameters.groupStatus) {
            queryParameters['groupStatus'] = requestParameters.groupStatus;
        }

        if (requestParameters.packed !== undefined) {
            queryParameters['packed'] = requestParameters.packed;
        }

        if (requestParameters.allOrders !== undefined) {
            queryParameters['allOrders'] = requestParameters.allOrders;
        }

        if (requestParameters.shippingMethod) {
            queryParameters['shippingMethod'] = requestParameters.shippingMethod;
        }

        if (requestParameters.createdBefore !== undefined) {
            queryParameters['createdBefore'] = requestParameters.createdBefore;
        }

        if (requestParameters.createdAfter !== undefined) {
            queryParameters['createdAfter'] = requestParameters.createdAfter;
        }

        if (requestParameters.couponCode !== undefined) {
            queryParameters['couponCode'] = requestParameters.couponCode;
        }

        if (requestParameters.aggregateTax !== undefined) {
            queryParameters['aggregateTax'] = requestParameters.aggregateTax;
        }

        if (requestParameters.buyerUserType !== undefined) {
            queryParameters['buyerUserType'] = requestParameters.buyerUserType;
        }

        if (requestParameters.platform !== undefined) {
            queryParameters['platform'] = requestParameters.platform;
        }

        if (requestParameters.listingType !== undefined) {
            queryParameters['listingType'] = requestParameters.listingType;
        }

        if (requestParameters.noLiveStreamId !== undefined) {
            queryParameters['noLiveStreamId'] = requestParameters.noLiveStreamId;
        }

        if (requestParameters.sortBy !== undefined) {
            queryParameters['sortBy'] = requestParameters.sortBy;
        }

        if (requestParameters.sellerId !== undefined) {
            queryParameters['sellerId'] = requestParameters.sellerId;
        }

        if (requestParameters.buyerId !== undefined) {
            queryParameters['buyerId'] = requestParameters.buyerId;
        }

        if (requestParameters.listingId !== undefined) {
            queryParameters['listingId'] = requestParameters.listingId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/stores/{storeId}/orders:search`.replace(`{${"storeId"}}`, encodeURIComponent(String(requestParameters.storeId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async searchApiControllerSearchSellerOrders(requestParameters: SearchApiControllerSearchSellerOrdersRequest): Promise<OrdersSearchResponse> {
        const response = await this.searchApiControllerSearchSellerOrdersRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async searchApiControllerSearchSellerPeriodStatsRaw(requestParameters: SearchApiControllerSearchSellerPeriodStatsRequest): Promise<runtime.ApiResponse<SearchSellerPeriodStatsResponse>> {
        if (requestParameters.sellerId === null || requestParameters.sellerId === undefined) {
            throw new runtime.RequiredError('sellerId','Required parameter requestParameters.sellerId was null or undefined when calling searchApiControllerSearchSellerPeriodStats.');
        }

        if (requestParameters.period === null || requestParameters.period === undefined) {
            throw new runtime.RequiredError('period','Required parameter requestParameters.period was null or undefined when calling searchApiControllerSearchSellerPeriodStats.');
        }

        const queryParameters: any = {};

        if (requestParameters.period !== undefined) {
            queryParameters['period'] = requestParameters.period;
        }

        if (requestParameters.periodStartDate !== undefined) {
            queryParameters['periodStartDate'] = requestParameters.periodStartDate;
        }

        if (requestParameters.periodEndDate !== undefined) {
            queryParameters['periodEndDate'] = requestParameters.periodEndDate;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/stores/{sellerId}/period-stats:search`.replace(`{${"sellerId"}}`, encodeURIComponent(String(requestParameters.sellerId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async searchApiControllerSearchSellerPeriodStats(requestParameters: SearchApiControllerSearchSellerPeriodStatsRequest): Promise<SearchSellerPeriodStatsResponse> {
        const response = await this.searchApiControllerSearchSellerPeriodStatsRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async searchApiControllerSearchSellerStatsRaw(requestParameters: SearchApiControllerSearchSellerStatsRequest): Promise<runtime.ApiResponse<UserDetailSearchResponse>> {
        if (requestParameters.pageNo === null || requestParameters.pageNo === undefined) {
            throw new runtime.RequiredError('pageNo','Required parameter requestParameters.pageNo was null or undefined when calling searchApiControllerSearchSellerStats.');
        }

        if (requestParameters.pageSize === null || requestParameters.pageSize === undefined) {
            throw new runtime.RequiredError('pageSize','Required parameter requestParameters.pageSize was null or undefined when calling searchApiControllerSearchSellerStats.');
        }

        const queryParameters: any = {};

        if (requestParameters.pageNo !== undefined) {
            queryParameters['pageNo'] = requestParameters.pageNo;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['pageSize'] = requestParameters.pageSize;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.id) {
            queryParameters['id'] = requestParameters.id;
        }

        if (requestParameters.agencyId !== undefined) {
            queryParameters['agencyId'] = requestParameters.agencyId;
        }

        if (requestParameters.popStoreOnly !== undefined) {
            queryParameters['popStoreOnly'] = requestParameters.popStoreOnly;
        }

        if (requestParameters.storeType) {
            queryParameters['storeType'] = requestParameters.storeType;
        }

        if (requestParameters.loadAgency !== undefined) {
            queryParameters['loadAgency'] = requestParameters.loadAgency;
        }

        if (requestParameters.phone !== undefined) {
            queryParameters['phone'] = requestParameters.phone;
        }

        if (requestParameters.minLastLiveStreamDate !== undefined) {
            queryParameters['minLastLiveStreamDate'] = requestParameters.minLastLiveStreamDate;
        }

        if (requestParameters.maxLastLiveStreamDate !== undefined) {
            queryParameters['maxLastLiveStreamDate'] = requestParameters.maxLastLiveStreamDate;
        }

        if (requestParameters.sellerOnboardingCompleted !== undefined) {
            queryParameters['sellerOnboardingCompleted'] = requestParameters.sellerOnboardingCompleted;
        }

        if (requestParameters.commentChatConnectStatus !== undefined) {
            queryParameters['commentChatConnectStatus'] = requestParameters.commentChatConnectStatus;
        }

        if (requestParameters.commentChatOnboardingFinished !== undefined) {
            queryParameters['commentChatOnboardingFinished'] = requestParameters.commentChatOnboardingFinished;
        }

        if (requestParameters.billingCountryCodes) {
            queryParameters['billingCountryCodes'] = requestParameters.billingCountryCodes;
        }

        if (requestParameters.query !== undefined) {
            queryParameters['query'] = requestParameters.query;
        }

        if (requestParameters.sortBy !== undefined) {
            queryParameters['sortBy'] = requestParameters.sortBy;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/seller-stats:search`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async searchApiControllerSearchSellerStats(requestParameters: SearchApiControllerSearchSellerStatsRequest): Promise<UserDetailSearchResponse> {
        const response = await this.searchApiControllerSearchSellerStatsRaw(requestParameters);
        return await response.value();
    }

    /**
     * Public API
     */
    async searchApiControllerSearchSellerTagsRaw(requestParameters: SearchApiControllerSearchSellerTagsRequest): Promise<runtime.ApiResponse<SearchSellerTagsResponse>> {
        if (requestParameters.pageNo === null || requestParameters.pageNo === undefined) {
            throw new runtime.RequiredError('pageNo','Required parameter requestParameters.pageNo was null or undefined when calling searchApiControllerSearchSellerTags.');
        }

        if (requestParameters.pageSize === null || requestParameters.pageSize === undefined) {
            throw new runtime.RequiredError('pageSize','Required parameter requestParameters.pageSize was null or undefined when calling searchApiControllerSearchSellerTags.');
        }

        const queryParameters: any = {};

        if (requestParameters.pageNo !== undefined) {
            queryParameters['pageNo'] = requestParameters.pageNo;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['pageSize'] = requestParameters.pageSize;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.sortBy !== undefined) {
            queryParameters['sortBy'] = requestParameters.sortBy;
        }

        if (requestParameters.query !== undefined) {
            queryParameters['query'] = requestParameters.query;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/seller-tags:search`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Public API
     */
    async searchApiControllerSearchSellerTags(requestParameters: SearchApiControllerSearchSellerTagsRequest): Promise<SearchSellerTagsResponse> {
        const response = await this.searchApiControllerSearchSellerTagsRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async searchApiControllerSearchSellerViewersRaw(requestParameters: SearchApiControllerSearchSellerViewersRequest): Promise<runtime.ApiResponse<SearchSellerViewersResponse>> {
        if (requestParameters.sellerId === null || requestParameters.sellerId === undefined) {
            throw new runtime.RequiredError('sellerId','Required parameter requestParameters.sellerId was null or undefined when calling searchApiControllerSearchSellerViewers.');
        }

        if (requestParameters.searchSellerViewersParams === null || requestParameters.searchSellerViewersParams === undefined) {
            throw new runtime.RequiredError('searchSellerViewersParams','Required parameter requestParameters.searchSellerViewersParams was null or undefined when calling searchApiControllerSearchSellerViewers.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/stores/{sellerId}/user-stats:search`.replace(`{${"sellerId"}}`, encodeURIComponent(String(requestParameters.sellerId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.searchSellerViewersParams,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async searchApiControllerSearchSellerViewers(requestParameters: SearchApiControllerSearchSellerViewersRequest): Promise<SearchSellerViewersResponse> {
        const response = await this.searchApiControllerSearchSellerViewersRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async searchApiControllerSearchSeriesRaw(requestParameters: SearchApiControllerSearchSeriesRequest): Promise<runtime.ApiResponse<SeriesSearchResponse>> {
        if (requestParameters.storeId === null || requestParameters.storeId === undefined) {
            throw new runtime.RequiredError('storeId','Required parameter requestParameters.storeId was null or undefined when calling searchApiControllerSearchSeries.');
        }

        if (requestParameters.pageNo === null || requestParameters.pageNo === undefined) {
            throw new runtime.RequiredError('pageNo','Required parameter requestParameters.pageNo was null or undefined when calling searchApiControllerSearchSeries.');
        }

        if (requestParameters.pageSize === null || requestParameters.pageSize === undefined) {
            throw new runtime.RequiredError('pageSize','Required parameter requestParameters.pageSize was null or undefined when calling searchApiControllerSearchSeries.');
        }

        const queryParameters: any = {};

        if (requestParameters.pageNo !== undefined) {
            queryParameters['pageNo'] = requestParameters.pageNo;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['pageSize'] = requestParameters.pageSize;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.query !== undefined) {
            queryParameters['query'] = requestParameters.query;
        }

        if (requestParameters.id) {
            queryParameters['id'] = requestParameters.id;
        }

        if (requestParameters.accessLevel) {
            queryParameters['accessLevel'] = requestParameters.accessLevel;
        }

        if (requestParameters.popClipId) {
            queryParameters['popClipId'] = requestParameters.popClipId;
        }

        if (requestParameters.type) {
            queryParameters['type'] = requestParameters.type;
        }

        if (requestParameters.parentId) {
            queryParameters['parentId'] = requestParameters.parentId;
        }

        if (requestParameters.archived !== undefined) {
            queryParameters['archived'] = requestParameters.archived;
        }

        if (requestParameters.sortBy !== undefined) {
            queryParameters['sortBy'] = requestParameters.sortBy;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/stores/{storeId}/series:search`.replace(`{${"storeId"}}`, encodeURIComponent(String(requestParameters.storeId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async searchApiControllerSearchSeries(requestParameters: SearchApiControllerSearchSeriesRequest): Promise<SeriesSearchResponse> {
        const response = await this.searchApiControllerSearchSeriesRaw(requestParameters);
        return await response.value();
    }

    /**
     * Use v2
     */
    async searchApiControllerSearchSeriesElementsRaw(requestParameters: SearchApiControllerSearchSeriesElementsRequest): Promise<runtime.ApiResponse<SeriesElementSearchResponse>> {
        if (requestParameters.storeId === null || requestParameters.storeId === undefined) {
            throw new runtime.RequiredError('storeId','Required parameter requestParameters.storeId was null or undefined when calling searchApiControllerSearchSeriesElements.');
        }

        if (requestParameters.seriesId === null || requestParameters.seriesId === undefined) {
            throw new runtime.RequiredError('seriesId','Required parameter requestParameters.seriesId was null or undefined when calling searchApiControllerSearchSeriesElements.');
        }

        if (requestParameters.pageNo === null || requestParameters.pageNo === undefined) {
            throw new runtime.RequiredError('pageNo','Required parameter requestParameters.pageNo was null or undefined when calling searchApiControllerSearchSeriesElements.');
        }

        if (requestParameters.pageSize === null || requestParameters.pageSize === undefined) {
            throw new runtime.RequiredError('pageSize','Required parameter requestParameters.pageSize was null or undefined when calling searchApiControllerSearchSeriesElements.');
        }

        const queryParameters: any = {};

        if (requestParameters.pageNo !== undefined) {
            queryParameters['pageNo'] = requestParameters.pageNo;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['pageSize'] = requestParameters.pageSize;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.query !== undefined) {
            queryParameters['query'] = requestParameters.query;
        }

        if (requestParameters.id) {
            queryParameters['id'] = requestParameters.id;
        }

        if (requestParameters.popClipId) {
            queryParameters['popClipId'] = requestParameters.popClipId;
        }

        if (requestParameters.includeElementsFromSubSeries !== undefined) {
            queryParameters['includeElementsFromSubSeries'] = requestParameters.includeElementsFromSubSeries;
        }

        if (requestParameters.sortBy !== undefined) {
            queryParameters['sortBy'] = requestParameters.sortBy;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/stores/{storeId}/series/{seriesId}/elements:search`.replace(`{${"storeId"}}`, encodeURIComponent(String(requestParameters.storeId))).replace(`{${"seriesId"}}`, encodeURIComponent(String(requestParameters.seriesId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Use v2
     */
    async searchApiControllerSearchSeriesElements(requestParameters: SearchApiControllerSearchSeriesElementsRequest): Promise<SeriesElementSearchResponse> {
        const response = await this.searchApiControllerSearchSeriesElementsRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async searchApiControllerSearchSeriesElementsV2Raw(requestParameters: SearchApiControllerSearchSeriesElementsV2Request): Promise<runtime.ApiResponse<SeriesElementSearchResponseV2>> {
        if (requestParameters.storeId === null || requestParameters.storeId === undefined) {
            throw new runtime.RequiredError('storeId','Required parameter requestParameters.storeId was null or undefined when calling searchApiControllerSearchSeriesElementsV2.');
        }

        if (requestParameters.seriesId === null || requestParameters.seriesId === undefined) {
            throw new runtime.RequiredError('seriesId','Required parameter requestParameters.seriesId was null or undefined when calling searchApiControllerSearchSeriesElementsV2.');
        }

        if (requestParameters.pageNo === null || requestParameters.pageNo === undefined) {
            throw new runtime.RequiredError('pageNo','Required parameter requestParameters.pageNo was null or undefined when calling searchApiControllerSearchSeriesElementsV2.');
        }

        if (requestParameters.pageSize === null || requestParameters.pageSize === undefined) {
            throw new runtime.RequiredError('pageSize','Required parameter requestParameters.pageSize was null or undefined when calling searchApiControllerSearchSeriesElementsV2.');
        }

        const queryParameters: any = {};

        if (requestParameters.pageNo !== undefined) {
            queryParameters['pageNo'] = requestParameters.pageNo;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['pageSize'] = requestParameters.pageSize;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.query !== undefined) {
            queryParameters['query'] = requestParameters.query;
        }

        if (requestParameters.id) {
            queryParameters['id'] = requestParameters.id;
        }

        if (requestParameters.popClipId) {
            queryParameters['popClipId'] = requestParameters.popClipId;
        }

        if (requestParameters.includeElementsFromSubSeries !== undefined) {
            queryParameters['includeElementsFromSubSeries'] = requestParameters.includeElementsFromSubSeries;
        }

        if (requestParameters.sortBy !== undefined) {
            queryParameters['sortBy'] = requestParameters.sortBy;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v2/stores/{storeId}/series/{seriesId}/elements:search`.replace(`{${"storeId"}}`, encodeURIComponent(String(requestParameters.storeId))).replace(`{${"seriesId"}}`, encodeURIComponent(String(requestParameters.seriesId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async searchApiControllerSearchSeriesElementsV2(requestParameters: SearchApiControllerSearchSeriesElementsV2Request): Promise<SeriesElementSearchResponseV2> {
        const response = await this.searchApiControllerSearchSeriesElementsV2Raw(requestParameters);
        return await response.value();
    }

    /**
     */
    async searchApiControllerSearchShipmentsRaw(requestParameters: SearchApiControllerSearchShipmentsRequest): Promise<runtime.ApiResponse<SearchShipmentsResponse>> {
        if (requestParameters.pageNo === null || requestParameters.pageNo === undefined) {
            throw new runtime.RequiredError('pageNo','Required parameter requestParameters.pageNo was null or undefined when calling searchApiControllerSearchShipments.');
        }

        if (requestParameters.pageSize === null || requestParameters.pageSize === undefined) {
            throw new runtime.RequiredError('pageSize','Required parameter requestParameters.pageSize was null or undefined when calling searchApiControllerSearchShipments.');
        }

        const queryParameters: any = {};

        if (requestParameters.pageNo !== undefined) {
            queryParameters['pageNo'] = requestParameters.pageNo;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['pageSize'] = requestParameters.pageSize;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.buyerId !== undefined) {
            queryParameters['buyerId'] = requestParameters.buyerId;
        }

        if (requestParameters.sellerId !== undefined) {
            queryParameters['sellerId'] = requestParameters.sellerId;
        }

        if (requestParameters.orderId !== undefined) {
            queryParameters['orderId'] = requestParameters.orderId;
        }

        if (requestParameters.shippoTransactionId !== undefined) {
            queryParameters['shippoTransactionId'] = requestParameters.shippoTransactionId;
        }

        if (requestParameters.trackingStatus !== undefined) {
            queryParameters['trackingStatus'] = requestParameters.trackingStatus;
        }

        if (requestParameters.carrier) {
            queryParameters['carrier'] = requestParameters.carrier;
        }

        if (requestParameters.sortBy !== undefined) {
            queryParameters['sortBy'] = requestParameters.sortBy;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/shipments:search`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async searchApiControllerSearchShipments(requestParameters: SearchApiControllerSearchShipmentsRequest): Promise<SearchShipmentsResponse> {
        const response = await this.searchApiControllerSearchShipmentsRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async searchApiControllerSearchShowEventFeaturedStoresRaw(requestParameters: SearchApiControllerSearchShowEventFeaturedStoresRequest): Promise<runtime.ApiResponse<FeaturedStoresSearchResponse>> {
        if (requestParameters.showEventId === null || requestParameters.showEventId === undefined) {
            throw new runtime.RequiredError('showEventId','Required parameter requestParameters.showEventId was null or undefined when calling searchApiControllerSearchShowEventFeaturedStores.');
        }

        if (requestParameters.pageNo === null || requestParameters.pageNo === undefined) {
            throw new runtime.RequiredError('pageNo','Required parameter requestParameters.pageNo was null or undefined when calling searchApiControllerSearchShowEventFeaturedStores.');
        }

        if (requestParameters.pageSize === null || requestParameters.pageSize === undefined) {
            throw new runtime.RequiredError('pageSize','Required parameter requestParameters.pageSize was null or undefined when calling searchApiControllerSearchShowEventFeaturedStores.');
        }

        const queryParameters: any = {};

        if (requestParameters.pageNo !== undefined) {
            queryParameters['pageNo'] = requestParameters.pageNo;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['pageSize'] = requestParameters.pageSize;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.sortBy !== undefined) {
            queryParameters['sortBy'] = requestParameters.sortBy;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/show-events/{showEventId}/featured-stores:search`.replace(`{${"showEventId"}}`, encodeURIComponent(String(requestParameters.showEventId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async searchApiControllerSearchShowEventFeaturedStores(requestParameters: SearchApiControllerSearchShowEventFeaturedStoresRequest): Promise<FeaturedStoresSearchResponse> {
        const response = await this.searchApiControllerSearchShowEventFeaturedStoresRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async searchApiControllerSearchShowEventSellerApplicationsRaw(requestParameters: SearchApiControllerSearchShowEventSellerApplicationsRequest): Promise<runtime.ApiResponse<SearchShowEventSellerApplicationsResponse>> {
        if (requestParameters.eventId === null || requestParameters.eventId === undefined) {
            throw new runtime.RequiredError('eventId','Required parameter requestParameters.eventId was null or undefined when calling searchApiControllerSearchShowEventSellerApplications.');
        }

        if (requestParameters.pageNo === null || requestParameters.pageNo === undefined) {
            throw new runtime.RequiredError('pageNo','Required parameter requestParameters.pageNo was null or undefined when calling searchApiControllerSearchShowEventSellerApplications.');
        }

        if (requestParameters.pageSize === null || requestParameters.pageSize === undefined) {
            throw new runtime.RequiredError('pageSize','Required parameter requestParameters.pageSize was null or undefined when calling searchApiControllerSearchShowEventSellerApplications.');
        }

        const queryParameters: any = {};

        if (requestParameters.pageNo !== undefined) {
            queryParameters['pageNo'] = requestParameters.pageNo;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['pageSize'] = requestParameters.pageSize;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.id) {
            queryParameters['id'] = requestParameters.id;
        }

        if (requestParameters.sellerId !== undefined) {
            queryParameters['sellerId'] = requestParameters.sellerId;
        }

        if (requestParameters.status) {
            queryParameters['status'] = requestParameters.status;
        }

        if (requestParameters.sellerUserGroupIds) {
            queryParameters['sellerUserGroupIds'] = requestParameters.sellerUserGroupIds;
        }

        if (requestParameters.templateId !== undefined) {
            queryParameters['templateId'] = requestParameters.templateId;
        }

        if (requestParameters.sortBy !== undefined) {
            queryParameters['sortBy'] = requestParameters.sortBy;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/show-events/{eventId}/seller-applications:search`.replace(`{${"eventId"}}`, encodeURIComponent(String(requestParameters.eventId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async searchApiControllerSearchShowEventSellerApplications(requestParameters: SearchApiControllerSearchShowEventSellerApplicationsRequest): Promise<SearchShowEventSellerApplicationsResponse> {
        const response = await this.searchApiControllerSearchShowEventSellerApplicationsRaw(requestParameters);
        return await response.value();
    }

    /**
     * Public API
     */
    async searchApiControllerSearchShowEventsRaw(requestParameters: SearchApiControllerSearchShowEventsRequest): Promise<runtime.ApiResponse<ShowEventsSearchResponse>> {
        if (requestParameters.pageNo === null || requestParameters.pageNo === undefined) {
            throw new runtime.RequiredError('pageNo','Required parameter requestParameters.pageNo was null or undefined when calling searchApiControllerSearchShowEvents.');
        }

        if (requestParameters.pageSize === null || requestParameters.pageSize === undefined) {
            throw new runtime.RequiredError('pageSize','Required parameter requestParameters.pageSize was null or undefined when calling searchApiControllerSearchShowEvents.');
        }

        const queryParameters: any = {};

        if (requestParameters.pageNo !== undefined) {
            queryParameters['pageNo'] = requestParameters.pageNo;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['pageSize'] = requestParameters.pageSize;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.id) {
            queryParameters['id'] = requestParameters.id;
        }

        if (requestParameters.sellerIds) {
            queryParameters['sellerIds'] = requestParameters.sellerIds;
        }

        if (requestParameters.sellerUserGroupIds) {
            queryParameters['sellerUserGroupIds'] = requestParameters.sellerUserGroupIds;
        }

        if (requestParameters.query !== undefined) {
            queryParameters['query'] = requestParameters.query;
        }

        if (requestParameters.active !== undefined) {
            queryParameters['active'] = requestParameters.active;
        }

        if (requestParameters.isClosed !== undefined) {
            queryParameters['isClosed'] = requestParameters.isClosed;
        }

        if (requestParameters.countScheduledShows !== undefined) {
            queryParameters['countScheduledShows'] = requestParameters.countScheduledShows;
        }

        if (requestParameters.sortBy !== undefined) {
            queryParameters['sortBy'] = requestParameters.sortBy;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/show-events:search`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Public API
     */
    async searchApiControllerSearchShowEvents(requestParameters: SearchApiControllerSearchShowEventsRequest): Promise<ShowEventsSearchResponse> {
        const response = await this.searchApiControllerSearchShowEventsRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async searchApiControllerSearchShowEventsFeaturedShowsRaw(requestParameters: SearchApiControllerSearchShowEventsFeaturedShowsRequest): Promise<runtime.ApiResponse<ShowEventsFeaturedShowSearchResponse>> {
        if (requestParameters.showEventId === null || requestParameters.showEventId === undefined) {
            throw new runtime.RequiredError('showEventId','Required parameter requestParameters.showEventId was null or undefined when calling searchApiControllerSearchShowEventsFeaturedShows.');
        }

        if (requestParameters.pageNo === null || requestParameters.pageNo === undefined) {
            throw new runtime.RequiredError('pageNo','Required parameter requestParameters.pageNo was null or undefined when calling searchApiControllerSearchShowEventsFeaturedShows.');
        }

        if (requestParameters.pageSize === null || requestParameters.pageSize === undefined) {
            throw new runtime.RequiredError('pageSize','Required parameter requestParameters.pageSize was null or undefined when calling searchApiControllerSearchShowEventsFeaturedShows.');
        }

        const queryParameters: any = {};

        if (requestParameters.pageNo !== undefined) {
            queryParameters['pageNo'] = requestParameters.pageNo;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['pageSize'] = requestParameters.pageSize;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.id) {
            queryParameters['id'] = requestParameters.id;
        }

        if (requestParameters.query !== undefined) {
            queryParameters['query'] = requestParameters.query;
        }

        if (requestParameters.active !== undefined) {
            queryParameters['active'] = requestParameters.active;
        }

        if (requestParameters.autoFeaturedStoreShow !== undefined) {
            queryParameters['autoFeaturedStoreShow'] = requestParameters.autoFeaturedStoreShow;
        }

        if (requestParameters.filterOutExpiredUpcomingShows !== undefined) {
            queryParameters['filterOutExpiredUpcomingShows'] = requestParameters.filterOutExpiredUpcomingShows;
        }

        if (requestParameters.filterOutLiveLiveStreams !== undefined) {
            queryParameters['filterOutLiveLiveStreams'] = requestParameters.filterOutLiveLiveStreams;
        }

        if (requestParameters.minSortedAt !== undefined) {
            queryParameters['minSortedAt'] = requestParameters.minSortedAt;
        }

        if (requestParameters.type) {
            queryParameters['type'] = requestParameters.type;
        }

        if (requestParameters.sortBy !== undefined) {
            queryParameters['sortBy'] = requestParameters.sortBy;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/show-events/{showEventId}/featured-shows:search`.replace(`{${"showEventId"}}`, encodeURIComponent(String(requestParameters.showEventId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async searchApiControllerSearchShowEventsFeaturedShows(requestParameters: SearchApiControllerSearchShowEventsFeaturedShowsRequest): Promise<ShowEventsFeaturedShowSearchResponse> {
        const response = await this.searchApiControllerSearchShowEventsFeaturedShowsRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async searchApiControllerSearchShowEventsSellerApplicationsRaw(requestParameters: SearchApiControllerSearchShowEventsSellerApplicationsRequest): Promise<runtime.ApiResponse<SearchShowEventSellerApplicationsResponse>> {
        if (requestParameters.pageNo === null || requestParameters.pageNo === undefined) {
            throw new runtime.RequiredError('pageNo','Required parameter requestParameters.pageNo was null or undefined when calling searchApiControllerSearchShowEventsSellerApplications.');
        }

        if (requestParameters.pageSize === null || requestParameters.pageSize === undefined) {
            throw new runtime.RequiredError('pageSize','Required parameter requestParameters.pageSize was null or undefined when calling searchApiControllerSearchShowEventsSellerApplications.');
        }

        const queryParameters: any = {};

        if (requestParameters.pageNo !== undefined) {
            queryParameters['pageNo'] = requestParameters.pageNo;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['pageSize'] = requestParameters.pageSize;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.id) {
            queryParameters['id'] = requestParameters.id;
        }

        if (requestParameters.sellerId !== undefined) {
            queryParameters['sellerId'] = requestParameters.sellerId;
        }

        if (requestParameters.status) {
            queryParameters['status'] = requestParameters.status;
        }

        if (requestParameters.sellerUserGroupIds) {
            queryParameters['sellerUserGroupIds'] = requestParameters.sellerUserGroupIds;
        }

        if (requestParameters.templateId !== undefined) {
            queryParameters['templateId'] = requestParameters.templateId;
        }

        if (requestParameters.sortBy !== undefined) {
            queryParameters['sortBy'] = requestParameters.sortBy;
        }

        if (requestParameters.eventId !== undefined) {
            queryParameters['eventId'] = requestParameters.eventId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/show-events/seller-applications:search`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async searchApiControllerSearchShowEventsSellerApplications(requestParameters: SearchApiControllerSearchShowEventsSellerApplicationsRequest): Promise<SearchShowEventSellerApplicationsResponse> {
        const response = await this.searchApiControllerSearchShowEventsSellerApplicationsRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async searchApiControllerSearchShowEventsTicketsRaw(requestParameters: SearchApiControllerSearchShowEventsTicketsRequest): Promise<runtime.ApiResponse<ShowTicketsSearchResponse>> {
        if (requestParameters.pageNo === null || requestParameters.pageNo === undefined) {
            throw new runtime.RequiredError('pageNo','Required parameter requestParameters.pageNo was null or undefined when calling searchApiControllerSearchShowEventsTickets.');
        }

        if (requestParameters.pageSize === null || requestParameters.pageSize === undefined) {
            throw new runtime.RequiredError('pageSize','Required parameter requestParameters.pageSize was null or undefined when calling searchApiControllerSearchShowEventsTickets.');
        }

        if (requestParameters.eventId === null || requestParameters.eventId === undefined) {
            throw new runtime.RequiredError('eventId','Required parameter requestParameters.eventId was null or undefined when calling searchApiControllerSearchShowEventsTickets.');
        }

        const queryParameters: any = {};

        if (requestParameters.pageNo !== undefined) {
            queryParameters['pageNo'] = requestParameters.pageNo;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['pageSize'] = requestParameters.pageSize;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.isActive !== undefined) {
            queryParameters['isActive'] = requestParameters.isActive;
        }

        if (requestParameters.query !== undefined) {
            queryParameters['query'] = requestParameters.query;
        }

        if (requestParameters.sortBy !== undefined) {
            queryParameters['sortBy'] = requestParameters.sortBy;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/show-events/{eventId}/tickets:search`.replace(`{${"eventId"}}`, encodeURIComponent(String(requestParameters.eventId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async searchApiControllerSearchShowEventsTickets(requestParameters: SearchApiControllerSearchShowEventsTicketsRequest): Promise<ShowTicketsSearchResponse> {
        const response = await this.searchApiControllerSearchShowEventsTicketsRaw(requestParameters);
        return await response.value();
    }

    /**
     * Public API
     */
    async searchApiControllerSearchShowsRaw(requestParameters: SearchApiControllerSearchShowsRequest): Promise<runtime.ApiResponse<SearchShowsResponse>> {
        if (requestParameters.pageNo === null || requestParameters.pageNo === undefined) {
            throw new runtime.RequiredError('pageNo','Required parameter requestParameters.pageNo was null or undefined when calling searchApiControllerSearchShows.');
        }

        if (requestParameters.pageSize === null || requestParameters.pageSize === undefined) {
            throw new runtime.RequiredError('pageSize','Required parameter requestParameters.pageSize was null or undefined when calling searchApiControllerSearchShows.');
        }

        const queryParameters: any = {};

        if (requestParameters.pageNo !== undefined) {
            queryParameters['pageNo'] = requestParameters.pageNo;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['pageSize'] = requestParameters.pageSize;
        }

        if (requestParameters.query !== undefined) {
            queryParameters['query'] = requestParameters.query;
        }

        if (requestParameters.categoryRowId !== undefined) {
            queryParameters['categoryRowId'] = requestParameters.categoryRowId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xPopPlatform !== undefined && requestParameters.xPopPlatform !== null) {
            headerParameters['x-pop-platform'] = String(requestParameters.xPopPlatform);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/shows:search`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Public API
     */
    async searchApiControllerSearchShows(requestParameters: SearchApiControllerSearchShowsRequest): Promise<SearchShowsResponse> {
        const response = await this.searchApiControllerSearchShowsRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async searchApiControllerSearchStoreBlockedUsersRaw(requestParameters: SearchApiControllerSearchStoreBlockedUsersRequest): Promise<runtime.ApiResponse<SearchStoreBlockedUsersResponse>> {
        if (requestParameters.storeId === null || requestParameters.storeId === undefined) {
            throw new runtime.RequiredError('storeId','Required parameter requestParameters.storeId was null or undefined when calling searchApiControllerSearchStoreBlockedUsers.');
        }

        if (requestParameters.pageNo === null || requestParameters.pageNo === undefined) {
            throw new runtime.RequiredError('pageNo','Required parameter requestParameters.pageNo was null or undefined when calling searchApiControllerSearchStoreBlockedUsers.');
        }

        if (requestParameters.pageSize === null || requestParameters.pageSize === undefined) {
            throw new runtime.RequiredError('pageSize','Required parameter requestParameters.pageSize was null or undefined when calling searchApiControllerSearchStoreBlockedUsers.');
        }

        const queryParameters: any = {};

        if (requestParameters.pageNo !== undefined) {
            queryParameters['pageNo'] = requestParameters.pageNo;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['pageSize'] = requestParameters.pageSize;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.id) {
            queryParameters['id'] = requestParameters.id;
        }

        if (requestParameters.query !== undefined) {
            queryParameters['query'] = requestParameters.query;
        }

        if (requestParameters.reason) {
            queryParameters['reason'] = requestParameters.reason;
        }

        if (requestParameters.sortBy !== undefined) {
            queryParameters['sortBy'] = requestParameters.sortBy;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/stores/{storeId}/blocked:search`.replace(`{${"storeId"}}`, encodeURIComponent(String(requestParameters.storeId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async searchApiControllerSearchStoreBlockedUsers(requestParameters: SearchApiControllerSearchStoreBlockedUsersRequest): Promise<SearchStoreBlockedUsersResponse> {
        const response = await this.searchApiControllerSearchStoreBlockedUsersRaw(requestParameters);
        return await response.value();
    }

    /**
     * Use v2
     */
    async searchApiControllerSearchStoreLevelSeriesElementsRaw(requestParameters: SearchApiControllerSearchStoreLevelSeriesElementsRequest): Promise<runtime.ApiResponse<SeriesElementSearchResponse>> {
        if (requestParameters.storeId === null || requestParameters.storeId === undefined) {
            throw new runtime.RequiredError('storeId','Required parameter requestParameters.storeId was null or undefined when calling searchApiControllerSearchStoreLevelSeriesElements.');
        }

        if (requestParameters.pageNo === null || requestParameters.pageNo === undefined) {
            throw new runtime.RequiredError('pageNo','Required parameter requestParameters.pageNo was null or undefined when calling searchApiControllerSearchStoreLevelSeriesElements.');
        }

        if (requestParameters.pageSize === null || requestParameters.pageSize === undefined) {
            throw new runtime.RequiredError('pageSize','Required parameter requestParameters.pageSize was null or undefined when calling searchApiControllerSearchStoreLevelSeriesElements.');
        }

        const queryParameters: any = {};

        if (requestParameters.pageNo !== undefined) {
            queryParameters['pageNo'] = requestParameters.pageNo;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['pageSize'] = requestParameters.pageSize;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.query !== undefined) {
            queryParameters['query'] = requestParameters.query;
        }

        if (requestParameters.id) {
            queryParameters['id'] = requestParameters.id;
        }

        if (requestParameters.popClipId) {
            queryParameters['popClipId'] = requestParameters.popClipId;
        }

        if (requestParameters.includeElementsFromSubSeries !== undefined) {
            queryParameters['includeElementsFromSubSeries'] = requestParameters.includeElementsFromSubSeries;
        }

        if (requestParameters.sortBy !== undefined) {
            queryParameters['sortBy'] = requestParameters.sortBy;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/stores/{storeId}/series-elements:search`.replace(`{${"storeId"}}`, encodeURIComponent(String(requestParameters.storeId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Use v2
     */
    async searchApiControllerSearchStoreLevelSeriesElements(requestParameters: SearchApiControllerSearchStoreLevelSeriesElementsRequest): Promise<SeriesElementSearchResponse> {
        const response = await this.searchApiControllerSearchStoreLevelSeriesElementsRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async searchApiControllerSearchStoreLevelSeriesElementsV2Raw(requestParameters: SearchApiControllerSearchStoreLevelSeriesElementsV2Request): Promise<runtime.ApiResponse<SeriesElementSearchResponseV2>> {
        if (requestParameters.storeId === null || requestParameters.storeId === undefined) {
            throw new runtime.RequiredError('storeId','Required parameter requestParameters.storeId was null or undefined when calling searchApiControllerSearchStoreLevelSeriesElementsV2.');
        }

        if (requestParameters.pageNo === null || requestParameters.pageNo === undefined) {
            throw new runtime.RequiredError('pageNo','Required parameter requestParameters.pageNo was null or undefined when calling searchApiControllerSearchStoreLevelSeriesElementsV2.');
        }

        if (requestParameters.pageSize === null || requestParameters.pageSize === undefined) {
            throw new runtime.RequiredError('pageSize','Required parameter requestParameters.pageSize was null or undefined when calling searchApiControllerSearchStoreLevelSeriesElementsV2.');
        }

        const queryParameters: any = {};

        if (requestParameters.pageNo !== undefined) {
            queryParameters['pageNo'] = requestParameters.pageNo;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['pageSize'] = requestParameters.pageSize;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.query !== undefined) {
            queryParameters['query'] = requestParameters.query;
        }

        if (requestParameters.id) {
            queryParameters['id'] = requestParameters.id;
        }

        if (requestParameters.popClipId) {
            queryParameters['popClipId'] = requestParameters.popClipId;
        }

        if (requestParameters.includeElementsFromSubSeries !== undefined) {
            queryParameters['includeElementsFromSubSeries'] = requestParameters.includeElementsFromSubSeries;
        }

        if (requestParameters.sortBy !== undefined) {
            queryParameters['sortBy'] = requestParameters.sortBy;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v2/stores/{storeId}/series-elements:search`.replace(`{${"storeId"}}`, encodeURIComponent(String(requestParameters.storeId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async searchApiControllerSearchStoreLevelSeriesElementsV2(requestParameters: SearchApiControllerSearchStoreLevelSeriesElementsV2Request): Promise<SeriesElementSearchResponseV2> {
        const response = await this.searchApiControllerSearchStoreLevelSeriesElementsV2Raw(requestParameters);
        return await response.value();
    }

    /**
     */
    async searchApiControllerSearchStoreListingShopifyStoreIdsRaw(requestParameters: SearchApiControllerSearchStoreListingShopifyStoreIdsRequest): Promise<runtime.ApiResponse<Array<string>>> {
        if (requestParameters.sellerId === null || requestParameters.sellerId === undefined) {
            throw new runtime.RequiredError('sellerId','Required parameter requestParameters.sellerId was null or undefined when calling searchApiControllerSearchStoreListingShopifyStoreIds.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/stores/{sellerId}/shopify-stores:search`.replace(`{${"sellerId"}}`, encodeURIComponent(String(requestParameters.sellerId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     */
    async searchApiControllerSearchStoreListingShopifyStoreIds(requestParameters: SearchApiControllerSearchStoreListingShopifyStoreIdsRequest): Promise<Array<string>> {
        const response = await this.searchApiControllerSearchStoreListingShopifyStoreIdsRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async searchApiControllerSearchStoreLiveStreamsRaw(requestParameters: SearchApiControllerSearchStoreLiveStreamsRequest): Promise<runtime.ApiResponse<LiveStreamsSearchResponse>> {
        if (requestParameters.sellerId === null || requestParameters.sellerId === undefined) {
            throw new runtime.RequiredError('sellerId','Required parameter requestParameters.sellerId was null or undefined when calling searchApiControllerSearchStoreLiveStreams.');
        }

        if (requestParameters.pageNo === null || requestParameters.pageNo === undefined) {
            throw new runtime.RequiredError('pageNo','Required parameter requestParameters.pageNo was null or undefined when calling searchApiControllerSearchStoreLiveStreams.');
        }

        if (requestParameters.pageSize === null || requestParameters.pageSize === undefined) {
            throw new runtime.RequiredError('pageSize','Required parameter requestParameters.pageSize was null or undefined when calling searchApiControllerSearchStoreLiveStreams.');
        }

        const queryParameters: any = {};

        if (requestParameters.pageNo !== undefined) {
            queryParameters['pageNo'] = requestParameters.pageNo;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['pageSize'] = requestParameters.pageSize;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.id) {
            queryParameters['id'] = requestParameters.id;
        }

        if (requestParameters.eventId !== undefined) {
            queryParameters['eventId'] = requestParameters.eventId;
        }

        if (requestParameters.title !== undefined) {
            queryParameters['title'] = requestParameters.title;
        }

        if (requestParameters.query !== undefined) {
            queryParameters['query'] = requestParameters.query;
        }

        if (requestParameters.storeName !== undefined) {
            queryParameters['storeName'] = requestParameters.storeName;
        }

        if (requestParameters.status !== undefined) {
            queryParameters['status'] = requestParameters.status;
        }

        if (requestParameters.isReplayable !== undefined) {
            queryParameters['isReplayable'] = requestParameters.isReplayable;
        }

        if (requestParameters.permission) {
            queryParameters['permission'] = requestParameters.permission;
        }

        if (requestParameters.sortBy !== undefined) {
            queryParameters['sortBy'] = requestParameters.sortBy;
        }

        if (requestParameters.liveOrEnded !== undefined) {
            queryParameters['liveOrEnded'] = requestParameters.liveOrEnded;
        }

        if (requestParameters.minCreatedAt !== undefined) {
            queryParameters['minCreatedAt'] = requestParameters.minCreatedAt;
        }

        if (requestParameters.maxCreatedAt !== undefined) {
            queryParameters['maxCreatedAt'] = requestParameters.maxCreatedAt;
        }

        if (requestParameters.shippingMode) {
            queryParameters['shippingMode'] = requestParameters.shippingMode;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/stores/{sellerId}/live-streams:search`.replace(`{${"sellerId"}}`, encodeURIComponent(String(requestParameters.sellerId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async searchApiControllerSearchStoreLiveStreams(requestParameters: SearchApiControllerSearchStoreLiveStreamsRequest): Promise<LiveStreamsSearchResponse> {
        const response = await this.searchApiControllerSearchStoreLiveStreamsRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async searchApiControllerSearchStoresRaw(requestParameters: SearchApiControllerSearchStoresRequest): Promise<runtime.ApiResponse<StoresSearchResponse>> {
        if (requestParameters.pageNo === null || requestParameters.pageNo === undefined) {
            throw new runtime.RequiredError('pageNo','Required parameter requestParameters.pageNo was null or undefined when calling searchApiControllerSearchStores.');
        }

        if (requestParameters.pageSize === null || requestParameters.pageSize === undefined) {
            throw new runtime.RequiredError('pageSize','Required parameter requestParameters.pageSize was null or undefined when calling searchApiControllerSearchStores.');
        }

        if (requestParameters.filterBy === null || requestParameters.filterBy === undefined) {
            throw new runtime.RequiredError('filterBy','Required parameter requestParameters.filterBy was null or undefined when calling searchApiControllerSearchStores.');
        }

        const queryParameters: any = {};

        if (requestParameters.pageNo !== undefined) {
            queryParameters['pageNo'] = requestParameters.pageNo;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['pageSize'] = requestParameters.pageSize;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.id) {
            queryParameters['id'] = requestParameters.id;
        }

        if (requestParameters.query !== undefined) {
            queryParameters['query'] = requestParameters.query;
        }

        if (requestParameters.filterBy !== undefined) {
            queryParameters['filterBy'] = requestParameters.filterBy;
        }

        if (requestParameters.sortBy !== undefined) {
            queryParameters['sortBy'] = requestParameters.sortBy;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v2/stores:search`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async searchApiControllerSearchStores(requestParameters: SearchApiControllerSearchStoresRequest): Promise<StoresSearchResponse> {
        const response = await this.searchApiControllerSearchStoresRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async searchApiControllerSearchThemeTemplatesRaw(requestParameters: SearchApiControllerSearchThemeTemplatesRequest): Promise<runtime.ApiResponse<ThemeTemplatesSearchResponse>> {
        if (requestParameters.storeId === null || requestParameters.storeId === undefined) {
            throw new runtime.RequiredError('storeId','Required parameter requestParameters.storeId was null or undefined when calling searchApiControllerSearchThemeTemplates.');
        }

        if (requestParameters.pageNo === null || requestParameters.pageNo === undefined) {
            throw new runtime.RequiredError('pageNo','Required parameter requestParameters.pageNo was null or undefined when calling searchApiControllerSearchThemeTemplates.');
        }

        if (requestParameters.pageSize === null || requestParameters.pageSize === undefined) {
            throw new runtime.RequiredError('pageSize','Required parameter requestParameters.pageSize was null or undefined when calling searchApiControllerSearchThemeTemplates.');
        }

        if (requestParameters.purpose === null || requestParameters.purpose === undefined) {
            throw new runtime.RequiredError('purpose','Required parameter requestParameters.purpose was null or undefined when calling searchApiControllerSearchThemeTemplates.');
        }

        const queryParameters: any = {};

        if (requestParameters.pageNo !== undefined) {
            queryParameters['pageNo'] = requestParameters.pageNo;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['pageSize'] = requestParameters.pageSize;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.id) {
            queryParameters['id'] = requestParameters.id;
        }

        if (requestParameters.name !== undefined) {
            queryParameters['name'] = requestParameters.name;
        }

        if (requestParameters.sortBy !== undefined) {
            queryParameters['sortBy'] = requestParameters.sortBy;
        }

        if (requestParameters.purpose !== undefined) {
            queryParameters['purpose'] = requestParameters.purpose;
        }

        if (requestParameters.type !== undefined) {
            queryParameters['type'] = requestParameters.type;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/stores/{storeId}/themes-templates:search`.replace(`{${"storeId"}}`, encodeURIComponent(String(requestParameters.storeId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async searchApiControllerSearchThemeTemplates(requestParameters: SearchApiControllerSearchThemeTemplatesRequest): Promise<ThemeTemplatesSearchResponse> {
        const response = await this.searchApiControllerSearchThemeTemplatesRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async searchApiControllerSearchUpcomingShowsRaw(requestParameters: SearchApiControllerSearchUpcomingShowsRequest): Promise<runtime.ApiResponse<UpcomingShowSearchResponse>> {
        if (requestParameters.pageNo === null || requestParameters.pageNo === undefined) {
            throw new runtime.RequiredError('pageNo','Required parameter requestParameters.pageNo was null or undefined when calling searchApiControllerSearchUpcomingShows.');
        }

        if (requestParameters.pageSize === null || requestParameters.pageSize === undefined) {
            throw new runtime.RequiredError('pageSize','Required parameter requestParameters.pageSize was null or undefined when calling searchApiControllerSearchUpcomingShows.');
        }

        const queryParameters: any = {};

        if (requestParameters.pageNo !== undefined) {
            queryParameters['pageNo'] = requestParameters.pageNo;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['pageSize'] = requestParameters.pageSize;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.id) {
            queryParameters['id'] = requestParameters.id;
        }

        if (requestParameters.query !== undefined) {
            queryParameters['query'] = requestParameters.query;
        }

        if (requestParameters.storeName !== undefined) {
            queryParameters['storeName'] = requestParameters.storeName;
        }

        if (requestParameters.userId !== undefined) {
            queryParameters['userId'] = requestParameters.userId;
        }

        if (requestParameters.available !== undefined) {
            queryParameters['available'] = requestParameters.available;
        }

        if (requestParameters.noEventId !== undefined) {
            queryParameters['noEventId'] = requestParameters.noEventId;
        }

        if (requestParameters.loadWatchListCount !== undefined) {
            queryParameters['loadWatchListCount'] = requestParameters.loadWatchListCount;
        }

        if (requestParameters.minStartsAt !== undefined) {
            queryParameters['minStartsAt'] = requestParameters.minStartsAt;
        }

        if (requestParameters.maxStartsAt !== undefined) {
            queryParameters['maxStartsAt'] = requestParameters.maxStartsAt;
        }

        if (requestParameters.sortBy !== undefined) {
            queryParameters['sortBy'] = requestParameters.sortBy;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/upcoming-shows:search`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async searchApiControllerSearchUpcomingShows(requestParameters: SearchApiControllerSearchUpcomingShowsRequest): Promise<UpcomingShowSearchResponse> {
        const response = await this.searchApiControllerSearchUpcomingShowsRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async searchApiControllerSearchUpcomingShowsWatchersRaw(requestParameters: SearchApiControllerSearchUpcomingShowsWatchersRequest): Promise<runtime.ApiResponse<UpcomingShowsWatchersSearchResponse>> {
        if (requestParameters.upcomingShowId === null || requestParameters.upcomingShowId === undefined) {
            throw new runtime.RequiredError('upcomingShowId','Required parameter requestParameters.upcomingShowId was null or undefined when calling searchApiControllerSearchUpcomingShowsWatchers.');
        }

        if (requestParameters.pageNo === null || requestParameters.pageNo === undefined) {
            throw new runtime.RequiredError('pageNo','Required parameter requestParameters.pageNo was null or undefined when calling searchApiControllerSearchUpcomingShowsWatchers.');
        }

        if (requestParameters.pageSize === null || requestParameters.pageSize === undefined) {
            throw new runtime.RequiredError('pageSize','Required parameter requestParameters.pageSize was null or undefined when calling searchApiControllerSearchUpcomingShowsWatchers.');
        }

        const queryParameters: any = {};

        if (requestParameters.pageNo !== undefined) {
            queryParameters['pageNo'] = requestParameters.pageNo;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['pageSize'] = requestParameters.pageSize;
        }

        if (requestParameters.isFollower !== undefined) {
            queryParameters['isFollower'] = requestParameters.isFollower;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/upcoming-shows/{upcomingShowId}/watchers:search`.replace(`{${"upcomingShowId"}}`, encodeURIComponent(String(requestParameters.upcomingShowId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async searchApiControllerSearchUpcomingShowsWatchers(requestParameters: SearchApiControllerSearchUpcomingShowsWatchersRequest): Promise<UpcomingShowsWatchersSearchResponse> {
        const response = await this.searchApiControllerSearchUpcomingShowsWatchersRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async searchApiControllerSearchUserDetailsRaw(requestParameters: SearchApiControllerSearchUserDetailsRequest): Promise<runtime.ApiResponse<UserDetailSearchResponse>> {
        if (requestParameters.pageNo === null || requestParameters.pageNo === undefined) {
            throw new runtime.RequiredError('pageNo','Required parameter requestParameters.pageNo was null or undefined when calling searchApiControllerSearchUserDetails.');
        }

        if (requestParameters.pageSize === null || requestParameters.pageSize === undefined) {
            throw new runtime.RequiredError('pageSize','Required parameter requestParameters.pageSize was null or undefined when calling searchApiControllerSearchUserDetails.');
        }

        const queryParameters: any = {};

        if (requestParameters.pageNo !== undefined) {
            queryParameters['pageNo'] = requestParameters.pageNo;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['pageSize'] = requestParameters.pageSize;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.id) {
            queryParameters['id'] = requestParameters.id;
        }

        if (requestParameters.filterBy !== undefined) {
            queryParameters['filterBy'] = requestParameters.filterBy;
        }

        if (requestParameters.query !== undefined) {
            queryParameters['query'] = requestParameters.query;
        }

        if (requestParameters.userType) {
            queryParameters['userType'] = requestParameters.userType;
        }

        if (requestParameters.phone !== undefined) {
            queryParameters['phone'] = requestParameters.phone;
        }

        if (requestParameters.agencyId !== undefined) {
            queryParameters['agencyId'] = requestParameters.agencyId;
        }

        if (requestParameters.minPendingBalance !== undefined) {
            queryParameters['minPendingBalance'] = requestParameters.minPendingBalance;
        }

        if (requestParameters.popStoreOnly !== undefined) {
            queryParameters['popStoreOnly'] = requestParameters.popStoreOnly;
        }

        if (requestParameters.pslOnly !== undefined) {
            queryParameters['pslOnly'] = requestParameters.pslOnly;
        }

        if (requestParameters.storeType) {
            queryParameters['storeType'] = requestParameters.storeType;
        }

        if (requestParameters.billingCountryCodes) {
            queryParameters['billingCountryCodes'] = requestParameters.billingCountryCodes;
        }

        if (requestParameters.sortBy !== undefined) {
            queryParameters['sortBy'] = requestParameters.sortBy;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/user-details:search`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async searchApiControllerSearchUserDetails(requestParameters: SearchApiControllerSearchUserDetailsRequest): Promise<UserDetailSearchResponse> {
        const response = await this.searchApiControllerSearchUserDetailsRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async searchApiControllerSearchUserGroupsRaw(requestParameters: SearchApiControllerSearchUserGroupsRequest): Promise<runtime.ApiResponse<UserGroupsSearchResponse>> {
        if (requestParameters.pageNo === null || requestParameters.pageNo === undefined) {
            throw new runtime.RequiredError('pageNo','Required parameter requestParameters.pageNo was null or undefined when calling searchApiControllerSearchUserGroups.');
        }

        if (requestParameters.pageSize === null || requestParameters.pageSize === undefined) {
            throw new runtime.RequiredError('pageSize','Required parameter requestParameters.pageSize was null or undefined when calling searchApiControllerSearchUserGroups.');
        }

        const queryParameters: any = {};

        if (requestParameters.pageNo !== undefined) {
            queryParameters['pageNo'] = requestParameters.pageNo;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['pageSize'] = requestParameters.pageSize;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.query !== undefined) {
            queryParameters['query'] = requestParameters.query;
        }

        if (requestParameters.id) {
            queryParameters['id'] = requestParameters.id;
        }

        if (requestParameters.active !== undefined) {
            queryParameters['active'] = requestParameters.active;
        }

        if (requestParameters.sortBy !== undefined) {
            queryParameters['sortBy'] = requestParameters.sortBy;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/user-groups:search`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async searchApiControllerSearchUserGroups(requestParameters: SearchApiControllerSearchUserGroupsRequest): Promise<UserGroupsSearchResponse> {
        const response = await this.searchApiControllerSearchUserGroupsRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async searchApiControllerSearchUserGroupsUsersRaw(requestParameters: SearchApiControllerSearchUserGroupsUsersRequest): Promise<runtime.ApiResponse<ProfileSearchResponse>> {
        if (requestParameters.userGroupId === null || requestParameters.userGroupId === undefined) {
            throw new runtime.RequiredError('userGroupId','Required parameter requestParameters.userGroupId was null or undefined when calling searchApiControllerSearchUserGroupsUsers.');
        }

        if (requestParameters.pageNo === null || requestParameters.pageNo === undefined) {
            throw new runtime.RequiredError('pageNo','Required parameter requestParameters.pageNo was null or undefined when calling searchApiControllerSearchUserGroupsUsers.');
        }

        if (requestParameters.pageSize === null || requestParameters.pageSize === undefined) {
            throw new runtime.RequiredError('pageSize','Required parameter requestParameters.pageSize was null or undefined when calling searchApiControllerSearchUserGroupsUsers.');
        }

        const queryParameters: any = {};

        if (requestParameters.pageNo !== undefined) {
            queryParameters['pageNo'] = requestParameters.pageNo;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['pageSize'] = requestParameters.pageSize;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.query !== undefined) {
            queryParameters['query'] = requestParameters.query;
        }

        if (requestParameters.userType) {
            queryParameters['userType'] = requestParameters.userType;
        }

        if (requestParameters.sortBy !== undefined) {
            queryParameters['sortBy'] = requestParameters.sortBy;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/user-groups/{userGroupId}/users:search`.replace(`{${"userGroupId"}}`, encodeURIComponent(String(requestParameters.userGroupId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async searchApiControllerSearchUserGroupsUsers(requestParameters: SearchApiControllerSearchUserGroupsUsersRequest): Promise<ProfileSearchResponse> {
        const response = await this.searchApiControllerSearchUserGroupsUsersRaw(requestParameters);
        return await response.value();
    }

    /**
     * for user in app
     */
    async searchApiControllerSearchUserMessagesRaw(requestParameters: SearchApiControllerSearchUserMessagesRequest): Promise<runtime.ApiResponse<MessagesSearchResponse>> {
        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling searchApiControllerSearchUserMessages.');
        }

        if (requestParameters.pageNo === null || requestParameters.pageNo === undefined) {
            throw new runtime.RequiredError('pageNo','Required parameter requestParameters.pageNo was null or undefined when calling searchApiControllerSearchUserMessages.');
        }

        if (requestParameters.pageSize === null || requestParameters.pageSize === undefined) {
            throw new runtime.RequiredError('pageSize','Required parameter requestParameters.pageSize was null or undefined when calling searchApiControllerSearchUserMessages.');
        }

        if (requestParameters.type === null || requestParameters.type === undefined) {
            throw new runtime.RequiredError('type','Required parameter requestParameters.type was null or undefined when calling searchApiControllerSearchUserMessages.');
        }

        const queryParameters: any = {};

        if (requestParameters.pageNo !== undefined) {
            queryParameters['pageNo'] = requestParameters.pageNo;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['pageSize'] = requestParameters.pageSize;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.available !== undefined) {
            queryParameters['available'] = requestParameters.available;
        }

        if (requestParameters.sortBy !== undefined) {
            queryParameters['sortBy'] = requestParameters.sortBy;
        }

        if (requestParameters.type !== undefined) {
            queryParameters['type'] = requestParameters.type;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/users/{userId}/messages:search`.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     * for user in app
     */
    async searchApiControllerSearchUserMessages(requestParameters: SearchApiControllerSearchUserMessagesRequest): Promise<MessagesSearchResponse> {
        const response = await this.searchApiControllerSearchUserMessagesRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async searchApiControllerSearchUserOrdersRaw(requestParameters: SearchApiControllerSearchUserOrdersRequest): Promise<runtime.ApiResponse<OrdersSearchResponse>> {
        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling searchApiControllerSearchUserOrders.');
        }

        if (requestParameters.pageNo === null || requestParameters.pageNo === undefined) {
            throw new runtime.RequiredError('pageNo','Required parameter requestParameters.pageNo was null or undefined when calling searchApiControllerSearchUserOrders.');
        }

        if (requestParameters.pageSize === null || requestParameters.pageSize === undefined) {
            throw new runtime.RequiredError('pageSize','Required parameter requestParameters.pageSize was null or undefined when calling searchApiControllerSearchUserOrders.');
        }

        const queryParameters: any = {};

        if (requestParameters.pageNo !== undefined) {
            queryParameters['pageNo'] = requestParameters.pageNo;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['pageSize'] = requestParameters.pageSize;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.ids) {
            queryParameters['ids'] = requestParameters.ids;
        }

        if (requestParameters.query !== undefined) {
            queryParameters['query'] = requestParameters.query;
        }

        if (requestParameters.masterOrderId) {
            queryParameters['masterOrderId'] = requestParameters.masterOrderId;
        }

        if (requestParameters.orderNumber !== undefined) {
            queryParameters['orderNumber'] = requestParameters.orderNumber;
        }

        if (requestParameters.liveStreamId !== undefined) {
            queryParameters['liveStreamId'] = requestParameters.liveStreamId;
        }

        if (requestParameters.status) {
            queryParameters['status'] = requestParameters.status;
        }

        if (requestParameters.orderGroupStatus) {
            queryParameters['orderGroupStatus'] = requestParameters.orderGroupStatus;
        }

        if (requestParameters.pickupStatus) {
            queryParameters['pickupStatus'] = requestParameters.pickupStatus;
        }

        if (requestParameters.groupStatusMaster !== undefined) {
            queryParameters['groupStatusMaster'] = requestParameters.groupStatusMaster;
        }

        if (requestParameters.groupStatus) {
            queryParameters['groupStatus'] = requestParameters.groupStatus;
        }

        if (requestParameters.packed !== undefined) {
            queryParameters['packed'] = requestParameters.packed;
        }

        if (requestParameters.allOrders !== undefined) {
            queryParameters['allOrders'] = requestParameters.allOrders;
        }

        if (requestParameters.shippingMethod) {
            queryParameters['shippingMethod'] = requestParameters.shippingMethod;
        }

        if (requestParameters.createdBefore !== undefined) {
            queryParameters['createdBefore'] = requestParameters.createdBefore;
        }

        if (requestParameters.createdAfter !== undefined) {
            queryParameters['createdAfter'] = requestParameters.createdAfter;
        }

        if (requestParameters.couponCode !== undefined) {
            queryParameters['couponCode'] = requestParameters.couponCode;
        }

        if (requestParameters.aggregateTax !== undefined) {
            queryParameters['aggregateTax'] = requestParameters.aggregateTax;
        }

        if (requestParameters.buyerUserType !== undefined) {
            queryParameters['buyerUserType'] = requestParameters.buyerUserType;
        }

        if (requestParameters.platform !== undefined) {
            queryParameters['platform'] = requestParameters.platform;
        }

        if (requestParameters.listingType !== undefined) {
            queryParameters['listingType'] = requestParameters.listingType;
        }

        if (requestParameters.noLiveStreamId !== undefined) {
            queryParameters['noLiveStreamId'] = requestParameters.noLiveStreamId;
        }

        if (requestParameters.sortBy !== undefined) {
            queryParameters['sortBy'] = requestParameters.sortBy;
        }

        if (requestParameters.sellerId !== undefined) {
            queryParameters['sellerId'] = requestParameters.sellerId;
        }

        if (requestParameters.buyerId !== undefined) {
            queryParameters['buyerId'] = requestParameters.buyerId;
        }

        if (requestParameters.listingId !== undefined) {
            queryParameters['listingId'] = requestParameters.listingId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/users/{userId}/orders:search`.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async searchApiControllerSearchUserOrders(requestParameters: SearchApiControllerSearchUserOrdersRequest): Promise<OrdersSearchResponse> {
        const response = await this.searchApiControllerSearchUserOrdersRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async searchApiControllerSearchUserStatsUserReferralPresentersRaw(requestParameters: SearchApiControllerSearchUserStatsUserReferralPresentersRequest): Promise<runtime.ApiResponse<UserReferralsSearchResponse>> {
        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling searchApiControllerSearchUserStatsUserReferralPresenters.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/user-stats/{userId}/referral-presenters:search`.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async searchApiControllerSearchUserStatsUserReferralPresenters(requestParameters: SearchApiControllerSearchUserStatsUserReferralPresentersRequest): Promise<UserReferralsSearchResponse> {
        const response = await this.searchApiControllerSearchUserStatsUserReferralPresentersRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async searchApiControllerSearchUserStatsUserReferralsRaw(requestParameters: SearchApiControllerSearchUserStatsUserReferralsRequest): Promise<runtime.ApiResponse<UserReferralsSearchResponse>> {
        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling searchApiControllerSearchUserStatsUserReferrals.');
        }

        if (requestParameters.pageNo === null || requestParameters.pageNo === undefined) {
            throw new runtime.RequiredError('pageNo','Required parameter requestParameters.pageNo was null or undefined when calling searchApiControllerSearchUserStatsUserReferrals.');
        }

        if (requestParameters.pageSize === null || requestParameters.pageSize === undefined) {
            throw new runtime.RequiredError('pageSize','Required parameter requestParameters.pageSize was null or undefined when calling searchApiControllerSearchUserStatsUserReferrals.');
        }

        const queryParameters: any = {};

        if (requestParameters.pageNo !== undefined) {
            queryParameters['pageNo'] = requestParameters.pageNo;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['pageSize'] = requestParameters.pageSize;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.referrerUserType) {
            queryParameters['referrerUserType'] = requestParameters.referrerUserType;
        }

        if (requestParameters.presenteeUserType) {
            queryParameters['presenteeUserType'] = requestParameters.presenteeUserType;
        }

        if (requestParameters.minCreatedAt !== undefined) {
            queryParameters['minCreatedAt'] = requestParameters.minCreatedAt;
        }

        if (requestParameters.maxCreatedAt !== undefined) {
            queryParameters['maxCreatedAt'] = requestParameters.maxCreatedAt;
        }

        if (requestParameters.sortBy !== undefined) {
            queryParameters['sortBy'] = requestParameters.sortBy;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/user-stats/{userId}/user-referrals:search`.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async searchApiControllerSearchUserStatsUserReferrals(requestParameters: SearchApiControllerSearchUserStatsUserReferralsRequest): Promise<UserReferralsSearchResponse> {
        const response = await this.searchApiControllerSearchUserStatsUserReferralsRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async searchApiControllerSearchUserStatsUserReferralsByAdminRaw(requestParameters: SearchApiControllerSearchUserStatsUserReferralsByAdminRequest): Promise<runtime.ApiResponse<UserReferralsSearchResponse>> {
        if (requestParameters.pageNo === null || requestParameters.pageNo === undefined) {
            throw new runtime.RequiredError('pageNo','Required parameter requestParameters.pageNo was null or undefined when calling searchApiControllerSearchUserStatsUserReferralsByAdmin.');
        }

        if (requestParameters.pageSize === null || requestParameters.pageSize === undefined) {
            throw new runtime.RequiredError('pageSize','Required parameter requestParameters.pageSize was null or undefined when calling searchApiControllerSearchUserStatsUserReferralsByAdmin.');
        }

        const queryParameters: any = {};

        if (requestParameters.pageNo !== undefined) {
            queryParameters['pageNo'] = requestParameters.pageNo;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['pageSize'] = requestParameters.pageSize;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.referrerUserType) {
            queryParameters['referrerUserType'] = requestParameters.referrerUserType;
        }

        if (requestParameters.presenteeUserType) {
            queryParameters['presenteeUserType'] = requestParameters.presenteeUserType;
        }

        if (requestParameters.minCreatedAt !== undefined) {
            queryParameters['minCreatedAt'] = requestParameters.minCreatedAt;
        }

        if (requestParameters.maxCreatedAt !== undefined) {
            queryParameters['maxCreatedAt'] = requestParameters.maxCreatedAt;
        }

        if (requestParameters.sortBy !== undefined) {
            queryParameters['sortBy'] = requestParameters.sortBy;
        }

        if (requestParameters.type !== undefined) {
            queryParameters['type'] = requestParameters.type;
        }

        if (requestParameters.subType !== undefined) {
            queryParameters['subType'] = requestParameters.subType;
        }

        if (requestParameters.presenteeUserId) {
            queryParameters['presenteeUserId'] = requestParameters.presenteeUserId;
        }

        if (requestParameters.referrerUserId !== undefined) {
            queryParameters['referrerUserId'] = requestParameters.referrerUserId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/user-stats/user-referrals:search`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async searchApiControllerSearchUserStatsUserReferralsByAdmin(requestParameters: SearchApiControllerSearchUserStatsUserReferralsByAdminRequest): Promise<UserReferralsSearchResponse> {
        const response = await this.searchApiControllerSearchUserStatsUserReferralsByAdminRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async searchApiControllerSearchWithdrawTransactionsRaw(requestParameters: SearchApiControllerSearchWithdrawTransactionsRequest): Promise<runtime.ApiResponse<WithdrawTransactionsSearchResponse>> {
        if (requestParameters.pageNo === null || requestParameters.pageNo === undefined) {
            throw new runtime.RequiredError('pageNo','Required parameter requestParameters.pageNo was null or undefined when calling searchApiControllerSearchWithdrawTransactions.');
        }

        if (requestParameters.pageSize === null || requestParameters.pageSize === undefined) {
            throw new runtime.RequiredError('pageSize','Required parameter requestParameters.pageSize was null or undefined when calling searchApiControllerSearchWithdrawTransactions.');
        }

        const queryParameters: any = {};

        if (requestParameters.pageNo !== undefined) {
            queryParameters['pageNo'] = requestParameters.pageNo;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['pageSize'] = requestParameters.pageSize;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.id) {
            queryParameters['id'] = requestParameters.id;
        }

        if (requestParameters.query !== undefined) {
            queryParameters['query'] = requestParameters.query;
        }

        if (requestParameters.status) {
            queryParameters['status'] = requestParameters.status;
        }

        if (requestParameters.userId !== undefined) {
            queryParameters['userId'] = requestParameters.userId;
        }

        if (requestParameters.minCreatedAt !== undefined) {
            queryParameters['minCreatedAt'] = requestParameters.minCreatedAt;
        }

        if (requestParameters.maxCreatedAt !== undefined) {
            queryParameters['maxCreatedAt'] = requestParameters.maxCreatedAt;
        }

        if (requestParameters.sortBy !== undefined) {
            queryParameters['sortBy'] = requestParameters.sortBy;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/withdraw-transactions:search`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async searchApiControllerSearchWithdrawTransactions(requestParameters: SearchApiControllerSearchWithdrawTransactionsRequest): Promise<WithdrawTransactionsSearchResponse> {
        const response = await this.searchApiControllerSearchWithdrawTransactionsRaw(requestParameters);
        return await response.value();
    }

    /**
     * search withdraw transactions in seller dashboard
     */
    async searchApiControllerSearchWithdrawTransactionsBySellerRaw(requestParameters: SearchApiControllerSearchWithdrawTransactionsBySellerRequest): Promise<runtime.ApiResponse<WithdrawTransactionsSearchResponse>> {
        if (requestParameters.sellerId === null || requestParameters.sellerId === undefined) {
            throw new runtime.RequiredError('sellerId','Required parameter requestParameters.sellerId was null or undefined when calling searchApiControllerSearchWithdrawTransactionsBySeller.');
        }

        if (requestParameters.pageNo === null || requestParameters.pageNo === undefined) {
            throw new runtime.RequiredError('pageNo','Required parameter requestParameters.pageNo was null or undefined when calling searchApiControllerSearchWithdrawTransactionsBySeller.');
        }

        if (requestParameters.pageSize === null || requestParameters.pageSize === undefined) {
            throw new runtime.RequiredError('pageSize','Required parameter requestParameters.pageSize was null or undefined when calling searchApiControllerSearchWithdrawTransactionsBySeller.');
        }

        const queryParameters: any = {};

        if (requestParameters.pageNo !== undefined) {
            queryParameters['pageNo'] = requestParameters.pageNo;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['pageSize'] = requestParameters.pageSize;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.id) {
            queryParameters['id'] = requestParameters.id;
        }

        if (requestParameters.query !== undefined) {
            queryParameters['query'] = requestParameters.query;
        }

        if (requestParameters.status) {
            queryParameters['status'] = requestParameters.status;
        }

        if (requestParameters.userId !== undefined) {
            queryParameters['userId'] = requestParameters.userId;
        }

        if (requestParameters.minCreatedAt !== undefined) {
            queryParameters['minCreatedAt'] = requestParameters.minCreatedAt;
        }

        if (requestParameters.maxCreatedAt !== undefined) {
            queryParameters['maxCreatedAt'] = requestParameters.maxCreatedAt;
        }

        if (requestParameters.sortBy !== undefined) {
            queryParameters['sortBy'] = requestParameters.sortBy;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/stores/{sellerId}/withdraw-transactions:search`.replace(`{${"sellerId"}}`, encodeURIComponent(String(requestParameters.sellerId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     * search withdraw transactions in seller dashboard
     */
    async searchApiControllerSearchWithdrawTransactionsBySeller(requestParameters: SearchApiControllerSearchWithdrawTransactionsBySellerRequest): Promise<WithdrawTransactionsSearchResponse> {
        const response = await this.searchApiControllerSearchWithdrawTransactionsBySellerRaw(requestParameters);
        return await response.value();
    }

}

/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerAdminSearchThemeTemplatesOrderEnum {
    Asc = 'asc',
    Desc = 'desc'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerAdminSearchThemeTemplatesSortByEnum {
    CreatedAt = 'createdAt',
    UpdatedAt = 'updatedAt',
    Position = 'position'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerAggregateSellerPeriodStatsPeriodEnum {
    Day = 'day',
    Week = 'week',
    Month = 'month',
    Year = 'year'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerExportMyStoreListingsOrderEnum {
    Asc = 'asc',
    Desc = 'desc'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerExportMyStoreListingsTypeEnum {
    Physical = 'PHYSICAL',
    Digital = 'DIGITAL',
    External = 'EXTERNAL',
    Meeting = 'MEETING',
    Affiliate = 'AFFILIATE',
    Derived = 'DERIVED'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerExportMyStoreListingsExcludeTypeEnum {
    Physical = 'PHYSICAL',
    Digital = 'DIGITAL',
    External = 'EXTERNAL',
    Meeting = 'MEETING',
    Affiliate = 'AFFILIATE',
    Derived = 'DERIVED'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerExportMyStoreListingsStatusEnum {
    Active = 'active',
    Archived = 'archived'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerExportMyStoreListingsSortByEnum {
    Id = 'id',
    Name = 'name',
    CreatedAt = 'createdAt',
    Quantity = 'quantity',
    Price = 'price',
    DiscountPrice = 'discountPrice',
    ShippingFee = 'shippingFee',
    MeetingStartDate = 'meeting.startDate'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerExportMyStoreListingsTagsFilterOperatorEnum {
    ContainsAny = 'CONTAINS_ANY',
    ContainsAll = 'CONTAINS_ALL',
    NotContainsAny = 'NOT_CONTAINS_ANY',
    NotContainsAll = 'NOT_CONTAINS_ALL'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerExportSellerOrderDetailsOrderEnum {
    Asc = 'asc',
    Desc = 'desc'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerExportSellerOrderDetailsStatusEnum {
    Created = 'created',
    Completed = 'completed',
    Canceled = 'canceled',
    PendingPayment = 'pendingPayment',
    ProcessingPayment = 'processingPayment',
    Closed = 'closed'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerExportSellerOrderDetailsOrderGroupStatusEnum {
    Open = 'open',
    Processing = 'processing',
    Fulfilling = 'fulfilling',
    Completed = 'completed',
    Canceled = 'canceled'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerExportSellerOrderDetailsPickupStatusEnum {
    Open = 'open',
    New = 'new',
    Processing = 'processing',
    Pending = 'pending',
    Packed = 'packed',
    Completed = 'completed',
    Canceled = 'canceled'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerExportSellerOrderDetailsGroupStatusEnum {
    Master = 'master',
    Customer = 'customer'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerExportSellerOrderDetailsShippingMethodEnum {
    DropshipSupplierProvide = 'dropshipSupplierProvide',
    SellerProvide = 'sellerProvide',
    PopshopProvide = 'popshopProvide',
    Pickup = 'pickup'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerExportSellerOrderDetailsBuyerUserTypeEnum {
    Guest = 'guest',
    Normal = 'normal',
    Seller = 'seller',
    VerifiedSeller = 'verifiedSeller'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerExportSellerOrderDetailsPlatformEnum {
    PopshopLive = 'popshop.live',
    PopStore = 'pop.store'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerExportSellerOrderDetailsListingTypeEnum {
    Physical = 'PHYSICAL',
    Digital = 'DIGITAL',
    External = 'EXTERNAL',
    Meeting = 'MEETING',
    Affiliate = 'AFFILIATE',
    Derived = 'DERIVED'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerExportSellerOrderDetailsMainStatusEnum {
    Created = 'created',
    Completed = 'completed',
    Canceled = 'canceled',
    PendingPayment = 'pendingPayment',
    ProcessingPayment = 'processingPayment',
    Closed = 'closed'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerExportSellerOrderDetailsShippingLabelStatusEnum {
    Disabled = 'disabled',
    NoLabel = 'noLabel',
    Generating = 'generating',
    Generated = 'generated',
    PreGenerated = 'preGenerated',
    Failed = 'failed'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerExportSellerOrderDetailsMainShippingLabelStatusEnum {
    Disabled = 'disabled',
    NoLabel = 'noLabel',
    Generating = 'generating',
    Generated = 'generated',
    PreGenerated = 'preGenerated',
    Failed = 'failed'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerExportSellerOrderDetailsShippingStatusEnum {
    Unknown = 'UNKNOWN',
    Delivered = 'DELIVERED',
    PreTransit = 'PRE_TRANSIT',
    Transit = 'TRANSIT',
    Failure = 'FAILURE',
    Returned = 'RETURNED'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerExportSellerOrderDetailsRateStatusEnum {
    Pending = 'pending',
    Failed = 'failed',
    Success = 'success'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerExportSellerOrderDetailsMainShippingStatusEnum {
    Unknown = 'UNKNOWN',
    Delivered = 'DELIVERED',
    PreTransit = 'PRE_TRANSIT',
    Transit = 'TRANSIT',
    Failure = 'FAILURE',
    Returned = 'RETURNED'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerExportSellerOrderDetailsFilterLabelStatusEnum {
    Opened = 'Opened',
    NeedLabel = 'NeedLabel',
    Generated = 'Generated',
    FlatRate = 'FlatRate',
    Cancelled = 'Cancelled'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerExportSellerOrderDetailsSortByEnum {
    BuyerFullName = 'buyerFullName',
    OrderNumber = 'orderNumber',
    Total = 'total',
    CreatedAt = 'createdAt',
    UpdatedAt = 'updatedAt',
    Bonus = 'bonus',
    ShippingFee = 'shippingFee',
    PickupStatus = 'pickupStatus',
    TotalPriceIncludeSlaveOrders = 'totalPriceIncludeSlaveOrders',
    ListingQuantity = 'listingQuantity',
    ListingWeightInLb = 'listingWeightInLb',
    AdjustShippingFee = 'adjustShippingFee'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerExportSellerOrderDetailsPaymentTypeEnum {
    Credit = 'credit',
    Applepay = 'applepay',
    Empty = 'empty'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerExportSellerOrderDetailsSourceTypeEnum {
    UpcomingShow = 'UPCOMING_SHOW',
    LiveStream = 'LIVE_STREAM',
    Store = 'STORE',
    TwoWayStream = 'TWO_WAY_STREAM',
    ReferralGifting = 'REFERRAL_GIFTING',
    SendItem = 'SEND_ITEM',
    TopProducts = 'TOP_PRODUCTS',
    Shop = 'SHOP',
    Replay = 'REPLAY',
    CommentChat = 'COMMENT_CHAT'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerExportWithdrawTransactionsBySellerOrderEnum {
    Asc = 'asc',
    Desc = 'desc'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerExportWithdrawTransactionsBySellerStatusEnum {
    Approved = 'approved',
    Rejected = 'rejected',
    Pending = 'pending'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerExportWithdrawTransactionsBySellerSortByEnum {
    Id = 'id',
    CreatedAt = 'createdAt',
    UpdatedAt = 'updatedAt',
    Amount = 'amount',
    Balance = 'balance'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerGetBlockedAccessSourcesOrderEnum {
    Asc = 'asc',
    Desc = 'desc'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerGetBlockedAccessSourcesTypeEnum {
    Ip = 'ip',
    Device = 'device'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerGetBlockedAccessSourcesSortByEnum {
    CreatedAt = 'createdAt',
    BlockedAt = 'blockedAt'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerGetOnboardingPushRecipientsOrderEnum {
    Asc = 'asc',
    Desc = 'desc'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerGetOnboardingPushRecipientsSortByEnum {
    Id = 'id',
    CreatedAt = 'createdAt',
    UpdatedAt = 'updatedAt',
    ViewedAt = 'viewedAt'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerGetOnboardingPushesOrderEnum {
    Asc = 'asc',
    Desc = 'desc'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerGetOnboardingPushesSortByEnum {
    StartTime = 'startTime',
    EndTime = 'endTime',
    TotalViewers = 'totalViewers',
    CreatedAt = 'createdAt',
    UpdatedAt = 'updatedAt'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchOrderEnum {
    Asc = 'asc',
    Desc = 'desc'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchSortByEnum {
    StoreName = 'storeName'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchAccountsXPopPlatformEnum {
    Psl = 'psl',
    Popstore = 'popstore'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchAgenciesOrderEnum {
    Asc = 'asc',
    Desc = 'desc'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchAgenciesStatusEnum {
    Active = 'active',
    Disabled = 'disabled'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchAgenciesSortByEnum {
    CreatedAt = 'createdAt',
    UpdatedAt = 'updatedAt'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchAgencyUsersOrderEnum {
    Asc = 'asc',
    Desc = 'desc'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchAgencyUsersSortByEnum {
    CreatedAt = 'createdAt',
    UpdatedAt = 'updatedAt'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchAllStoresListingsOrderEnum {
    Asc = 'asc',
    Desc = 'desc'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchAllStoresListingsTypeEnum {
    Physical = 'PHYSICAL',
    Digital = 'DIGITAL',
    External = 'EXTERNAL',
    Meeting = 'MEETING',
    Affiliate = 'AFFILIATE',
    Derived = 'DERIVED'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchAllStoresListingsExcludeTypeEnum {
    Physical = 'PHYSICAL',
    Digital = 'DIGITAL',
    External = 'EXTERNAL',
    Meeting = 'MEETING',
    Affiliate = 'AFFILIATE',
    Derived = 'DERIVED'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchAllStoresListingsStatusEnum {
    Active = 'active',
    Archived = 'archived'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchAllStoresListingsModerationStatusEnum {
    Pending = 'Pending',
    Accepted = 'Accepted',
    Rejected = 'Rejected',
    ReviewRequired = 'ReviewRequired'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchAllStoresListingsSortByEnum {
    Id = 'id',
    Name = 'name',
    CreatedAt = 'createdAt',
    Quantity = 'quantity',
    Price = 'price',
    DiscountPrice = 'discountPrice',
    ShippingFee = 'shippingFee',
    MeetingStartDate = 'meeting.startDate'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchAppSellerApplicationsOrderEnum {
    Asc = 'asc',
    Desc = 'desc'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchAppSellerApplicationsSortByEnum {
    CreatedAt = 'createdAt',
    StoreName = 'storeName',
    Status = 'status'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchAppSellerApplicationsStoreTypeEnum {
    Business = 'Business',
    Creator = 'Creator',
    CommentChat = 'CommentChat',
    Vfs = 'VFS'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchAppSellerApplicationsStatusEnum {
    Submitted = 'submitted',
    Approved = 'approved',
    Rejected = 'rejected'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchBadgeUsersOrderEnum {
    Asc = 'asc',
    Desc = 'desc'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchBadgeUsersSortByEnum {
    EarnedAt = 'earnedAt',
    CreatedAt = 'createdAt'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchBadgesOrderEnum {
    Asc = 'asc',
    Desc = 'desc'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchBadgesStatusEnum {
    Draft = 'DRAFT',
    Pending = 'PENDING',
    Approved = 'APPROVED',
    EditRequire = 'EDIT_REQUIRE'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchBadgesSortByEnum {
    CreatedAt = 'createdAt'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchBadgesByUserIdOrderEnum {
    Asc = 'asc',
    Desc = 'desc'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchBadgesByUserIdSortByEnum {
    EarnedAt = 'earnedAt',
    CreatedAt = 'createdAt'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchCampaignsOrderEnum {
    Asc = 'asc',
    Desc = 'desc'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchCampaignsSortByEnum {
    Id = 'id',
    CreatedAt = 'createdAt'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchCategoriesOrderEnum {
    Asc = 'asc',
    Desc = 'desc'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchCategoriesRootCategoryEnum {
    Psl = 'psl',
    PopStore = 'popStore'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchCategoriesSortByEnum {
    Sort = 'sort',
    Name = 'name',
    Title = 'title',
    Slug = 'slug',
    RootCategory = 'rootCategory',
    CreatedAt = 'createdAt',
    UpdatedAt = 'updatedAt'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchCategorizedResourcesOrderEnum {
    Asc = 'asc',
    Desc = 'desc'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchCategorizedResourcesResourceTypeEnum {
    Store = 'STORE',
    UpcomingShow = 'UPCOMING_SHOW',
    LiveStream = 'LIVE_STREAM',
    User = 'USER'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchCategorizedResourcesSortByEnum {
    Id = 'id',
    Sort = 'sort',
    CreatedAt = 'createdAt'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchCategoryDiscoveryRowCategorizedResourcesOrderEnum {
    Asc = 'asc',
    Desc = 'desc'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchCategoryDiscoveryRowCategorizedResourcesResourceTypeEnum {
    Store = 'STORE',
    UpcomingShow = 'UPCOMING_SHOW',
    LiveStream = 'LIVE_STREAM',
    User = 'USER'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchCategoryDiscoveryRowCategorizedResourcesSortByEnum {
    Id = 'id',
    Sort = 'sort',
    CreatedAt = 'createdAt'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchCategoryDiscoveryRowsOrderEnum {
    Asc = 'asc',
    Desc = 'desc'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchCategoryDiscoveryRowsSortByEnum {
    CreatedAt = 'createdAt',
    SortedAt = 'sortedAt'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchCategoryRowFeaturedStoresOrderEnum {
    Asc = 'asc',
    Desc = 'desc'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchCategoryRowFeaturedStoresSortByEnum {
    SortedAt = 'sortedAt'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchCommunityWaitlistUsersOrderEnum {
    Asc = 'asc',
    Desc = 'desc'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchCommunityWaitlistUsersSortByEnum {
    CreatedAt = 'createdAt'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchCouponsOrderEnum {
    Asc = 'asc',
    Desc = 'desc'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchCouponsCouponCreateMethodEnum {
    SellerProvide = 'sellerProvide',
    PopshopProvide = 'popshopProvide'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchCouponsSortByEnum {
    Code = 'code',
    CreatedAt = 'createdAt'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchFeaturedShowsOrderEnum {
    Asc = 'asc',
    Desc = 'desc'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchFeaturedShowsTypeEnum {
    UpcomingShow = 'upcomingShow',
    LiveShow = 'liveShow',
    Event = 'event'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchFeaturedShowsSortByEnum {
    Id = 'id',
    SortedAt = 'sortedAt',
    Type = 'type',
    Active = 'active'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchFeaturedStoresOrderEnum {
    Asc = 'asc',
    Desc = 'desc'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchFeaturedStoresSortByEnum {
    SortedAt = 'sortedAt',
    Position = 'position'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchFeaturedStoresPublicListingsOrderEnum {
    Asc = 'asc',
    Desc = 'desc'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchFeaturedStoresPublicListingsSortByEnum {
    Id = 'id',
    Name = 'name',
    CreatedAt = 'createdAt',
    Quantity = 'quantity',
    Price = 'price',
    DiscountPrice = 'discountPrice',
    ShippingFee = 'shippingFee',
    SoldQuantityLast7Days = 'soldQuantityLast7Days',
    StoreFrontNameKeyword = 'storeFrontName.keyword',
    MeetingStartDate = 'meeting.startDate'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchFeaturedTagsOrderEnum {
    Asc = 'asc',
    Desc = 'desc'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchFeaturedTagsSortByEnum {
    TagName = 'tagName',
    SortedAt = 'sortedAt'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchGiveawaysBySellerOrderEnum {
    Asc = 'asc',
    Desc = 'desc'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchGiveawaysBySellerSourceEnum {
    UpcomingShow = 'upcomingShow',
    LiveStream = 'liveStream'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchGiveawaysBySellerSortByEnum {
    EntryCloseAt = 'entryCloseAt',
    CreatedAt = 'createdAt',
    UpdatedAt = 'updatedAt',
    TotalEntrants = 'totalEntrants'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchGoogleProductCategoriesOrderEnum {
    Asc = 'asc',
    Desc = 'desc'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchGoogleProductCategoriesSortByEnum {
    Id = 'id',
    CreatedAt = 'createdAt',
    Name = 'name',
    FullName = 'fullName'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchIncentivePayoutsOrderEnum {
    Asc = 'asc',
    Desc = 'desc'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchIncentivePayoutsStatusEnum {
    Pending = 'Pending',
    Processed = 'Processed',
    Completed = 'Completed',
    Failed = 'Failed'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchIncentivePayoutsSortByEnum {
    Id = 'id',
    CreatedAt = 'createdAt',
    CreatorName = 'creatorName',
    StoreName = 'storeName'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchLinksOrderEnum {
    Asc = 'asc',
    Desc = 'desc'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchLinksTypeEnum {
    Share = 'SHARE',
    Campaign = 'CAMPAIGN',
    ReferralGifting = 'REFERRAL_GIFTING'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchLinksShareTargetTypeEnum {
    Profile = 'PROFILE',
    Store = 'STORE',
    LiveStream = 'LIVE_STREAM',
    Replay = 'REPLAY',
    UpcomingShow = 'UPCOMING_SHOW',
    ListingLiveStream = 'LISTING_LIVE_STREAM',
    ListingReplay = 'LISTING_REPLAY',
    ListingEvergreen = 'LISTING_EVERGREEN',
    ListingUpcomingShow = 'LISTING_UPCOMING_SHOW',
    ListingPromotion = 'LISTING_PROMOTION',
    Event = 'EVENT',
    EventDiscovery = 'EVENT_DISCOVERY',
    EventTicket = 'EVENT_TICKET',
    HomePage = 'HOME_PAGE',
    Promotion = 'PROMOTION',
    ReferralGifting = 'REFERRAL_GIFTING',
    UserBadge = 'USER_BADGE',
    LiveStreamGiveaway = 'LIVE_STREAM_GIVEAWAY',
    UpcomingShowGiveaway = 'UPCOMING_SHOW_GIVEAWAY',
    PopClip = 'POP_CLIP',
    BecomeASeller = 'BECOME_A_SELLER'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchLinksSortByEnum {
    Id = 'id',
    CreatedAt = 'createdAt'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchLiveStreamBuyerAddressesOrderEnum {
    Asc = 'asc',
    Desc = 'desc'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchLiveStreamBuyerAddressesSortByEnum {
    LatestOrderCreatedAt = 'latest_order_created_at',
    FullName = 'full_name'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchLiveStreamCommentsOrderEnum {
    Asc = 'asc',
    Desc = 'desc'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchLiveStreamCommentsTypeEnum {
    Comment = 'comment',
    UserEnter = 'userEnter',
    UserFollow = 'userFollow',
    Purchase = 'purchase',
    Share = 'share',
    Gifting = 'gifting',
    Wave = 'wave',
    WavedToUserEnter = 'wavedToUserEnter'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchLiveStreamCommentsSortByEnum {
    CreatedAt = 'createdAt',
    UpvoteCount = 'upvoteCount'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchLiveStreamsOrderEnum {
    Asc = 'asc',
    Desc = 'desc'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchLiveStreamsStatusEnum {
    Initialized = 'initialized',
    Available = 'available',
    Finished = 'finished',
    Aborted = 'aborted'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchLiveStreamsPermissionEnum {
    All = 'all',
    Follower = 'follower',
    Subscriber = 'subscriber',
    NoOne = 'no-one'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchLiveStreamsSortByEnum {
    Title = 'title',
    StoreFrontName = 'storeFrontName',
    CreatedAt = 'createdAt',
    DisconnectedAt = 'disconnectedAt',
    LastReplayedAt = 'lastReplayedAt'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchLiveStreamsListingsOrderEnum {
    Asc = 'asc',
    Desc = 'desc'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchLiveStreamsListingsStatusEnum {
    All = 'all',
    Active = 'active',
    Archived = 'archived'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchLiveStreamsListingsSortByEnum {
    Id = 'id',
    Name = 'name',
    CreatedAt = 'createdAt',
    Quantity = 'quantity',
    Price = 'price',
    DiscountPrice = 'discountPrice',
    ShippingFee = 'shippingFee'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchMailsFilterByEnum {
    ExternalId = 'externalId',
    To = 'to',
    TemplateName = 'templateName',
    Any = 'any'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchMailsOrderEnum {
    Asc = 'asc',
    Desc = 'desc'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchMailsSortByEnum {
    Id = 'id',
    CreatedAt = 'createdAt'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchMailsStateEnum {
    Pending = 'PENDING',
    Processing = 'PROCESSING',
    Success = 'SUCCESS',
    Error = 'ERROR'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchMessagesFilterByEnum {
    All = 'all',
    Sku = 'sku',
    ListingName = 'listingName',
    CustomerName = 'customerName',
    ShowName = 'showName'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchMessagesOrderEnum {
    Asc = 'asc',
    Desc = 'desc'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchMessagesReportFilterByEnum {
    All = 'all',
    None = 'none',
    Unresolved = 'unresolved',
    Resolved = 'resolved'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchMessagesPurposeEnum {
    Review = 'review',
    ThankYou = 'thankYou'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchMessagesThankYouTypeEnum {
    RecipientToBuyer = 'RecipientToBuyer',
    SellerToBuyer = 'SellerToBuyer'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchMessagesSortByEnum {
    Id = 'id',
    CreatedAt = 'createdAt',
    UpdatedAt = 'updatedAt',
    UpvoteCount = 'upvoteCount',
    TotalReportCount = 'totalReportCount',
    NewReportCount = 'newReportCount'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchMessagesReportsOrderEnum {
    Asc = 'asc',
    Desc = 'desc'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchMessagesReportsReasonEnum {
    Spam = 'spam',
    Inappropriate = 'inappropriate',
    Aggressive = 'aggressive'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchMessagesReportsResolveStatusEnum {
    Unresolved = 'Unresolved',
    Resolved = 'Resolved',
    Dismissed = 'Dismissed'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchMessagesReportsSortByEnum {
    Id = 'id',
    CreatedAt = 'createdAt',
    UpdatedAt = 'updatedAt'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchMyStoreListingsOrderEnum {
    Asc = 'asc',
    Desc = 'desc'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchMyStoreListingsTypeEnum {
    Physical = 'PHYSICAL',
    Digital = 'DIGITAL',
    External = 'EXTERNAL',
    Meeting = 'MEETING',
    Affiliate = 'AFFILIATE',
    Derived = 'DERIVED'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchMyStoreListingsExcludeTypeEnum {
    Physical = 'PHYSICAL',
    Digital = 'DIGITAL',
    External = 'EXTERNAL',
    Meeting = 'MEETING',
    Affiliate = 'AFFILIATE',
    Derived = 'DERIVED'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchMyStoreListingsStatusEnum {
    Active = 'active',
    Archived = 'archived'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchMyStoreListingsSortByEnum {
    Id = 'id',
    Name = 'name',
    CreatedAt = 'createdAt',
    Quantity = 'quantity',
    Price = 'price',
    DiscountPrice = 'discountPrice',
    ShippingFee = 'shippingFee',
    MeetingStartDate = 'meeting.startDate'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchMyStoreListingsTagsFilterOperatorEnum {
    ContainsAny = 'CONTAINS_ANY',
    ContainsAll = 'CONTAINS_ALL',
    NotContainsAny = 'NOT_CONTAINS_ANY',
    NotContainsAll = 'NOT_CONTAINS_ALL'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchMyStorePublicListingsOrderEnum {
    Asc = 'asc',
    Desc = 'desc'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchMyStorePublicListingsStatusEnum {
    Active = 'active',
    Archived = 'archived'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchMyStorePublicListingsSortByEnum {
    Id = 'id',
    Name = 'name',
    CreatedAt = 'createdAt',
    Quantity = 'quantity',
    Price = 'price',
    DiscountPrice = 'discountPrice',
    ShippingFee = 'shippingFee',
    SoldQuantityLast7Days = 'soldQuantityLast7Days',
    StoreFrontNameKeyword = 'storeFrontName.keyword',
    MeetingStartDate = 'meeting.startDate'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchMyStorePublicListingsTagsFilterOperatorEnum {
    ContainsAny = 'CONTAINS_ANY',
    ContainsAll = 'CONTAINS_ALL',
    NotContainsAny = 'NOT_CONTAINS_ANY',
    NotContainsAll = 'NOT_CONTAINS_ALL'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchMyStorePublicListingsListingTypeEnum {
    Physical = 'PHYSICAL',
    Digital = 'DIGITAL',
    External = 'EXTERNAL',
    Meeting = 'MEETING',
    Affiliate = 'AFFILIATE',
    Derived = 'DERIVED'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchMyStorePublicListingsExcludeListingTypeEnum {
    Physical = 'PHYSICAL',
    Digital = 'DIGITAL',
    External = 'EXTERNAL',
    Meeting = 'MEETING',
    Affiliate = 'AFFILIATE',
    Derived = 'DERIVED'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchOrderTransactionsOrderEnum {
    Asc = 'asc',
    Desc = 'desc'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchOrderTransactionsTypeEnum {
    Sale = 'sale',
    RefundBraintree = 'refundBraintree',
    ShippingFee = 'shippingFee',
    RefundShippingFee = 'refundShippingFee',
    Bonus = 'bonus',
    RefundBonus = 'refundBonus',
    ProductCoupon = 'productCoupon',
    RefundProductCoupon = 'refundProductCoupon'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchOrderTransactionsStatusEnum {
    Pending = 'pending',
    Completed = 'completed',
    Canceled = 'canceled'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchOrderTransactionsSortByEnum {
    CreatedAt = 'createdAt',
    UpdatedAt = 'updatedAt',
    Amount = 'amount',
    FromBraintree = 'fromBraintree'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchOrdersOrderEnum {
    Asc = 'asc',
    Desc = 'desc'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchOrdersStatusEnum {
    Created = 'created',
    Completed = 'completed',
    Canceled = 'canceled',
    PendingPayment = 'pendingPayment',
    ProcessingPayment = 'processingPayment',
    Closed = 'closed'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchOrdersOrderGroupStatusEnum {
    Open = 'open',
    Processing = 'processing',
    Fulfilling = 'fulfilling',
    Completed = 'completed',
    Canceled = 'canceled'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchOrdersPickupStatusEnum {
    Open = 'open',
    New = 'new',
    Processing = 'processing',
    Pending = 'pending',
    Packed = 'packed',
    Completed = 'completed',
    Canceled = 'canceled'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchOrdersGroupStatusEnum {
    Master = 'master',
    Customer = 'customer'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchOrdersShippingMethodEnum {
    DropshipSupplierProvide = 'dropshipSupplierProvide',
    SellerProvide = 'sellerProvide',
    PopshopProvide = 'popshopProvide',
    Pickup = 'pickup'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchOrdersBuyerUserTypeEnum {
    Guest = 'guest',
    Normal = 'normal',
    Seller = 'seller',
    VerifiedSeller = 'verifiedSeller'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchOrdersPlatformEnum {
    PopshopLive = 'popshop.live',
    PopStore = 'pop.store'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchOrdersListingTypeEnum {
    Physical = 'PHYSICAL',
    Digital = 'DIGITAL',
    External = 'EXTERNAL',
    Meeting = 'MEETING',
    Affiliate = 'AFFILIATE',
    Derived = 'DERIVED'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchOrdersFilterByEnum {
    SellerFirstName = 'seller.firstName',
    SellerLastName = 'seller.lastName',
    SellerEmail = 'seller.email',
    BuyerFirstName = 'buyer.firstName',
    BuyerLastName = 'buyer.lastName',
    BuyerEmail = 'buyer.email'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchOrdersGiftingStatusEnum {
    Pending = 'PENDING',
    Accepted = 'ACCEPTED',
    Rejected = 'REJECTED'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchOrdersSourceTypeEnum {
    UpcomingShow = 'UPCOMING_SHOW',
    LiveStream = 'LIVE_STREAM',
    Store = 'STORE',
    TwoWayStream = 'TWO_WAY_STREAM',
    ReferralGifting = 'REFERRAL_GIFTING',
    SendItem = 'SEND_ITEM',
    TopProducts = 'TOP_PRODUCTS',
    Shop = 'SHOP',
    Replay = 'REPLAY',
    CommentChat = 'COMMENT_CHAT'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchOrdersShipmentOriginalParcelSourceEnum {
    Default = 'DEFAULT',
    ShowEvent = 'SHOW_EVENT'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchOrdersRefundWholenessEnum {
    None = 'NONE',
    Legacy = 'LEGACY',
    Partial = 'PARTIAL',
    Full = 'FULL'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchOrdersSortByEnum {
    BuyerFullName = 'buyerFullName',
    OrderNumber = 'orderNumber',
    Total = 'total',
    CreatedAt = 'createdAt',
    UpdatedAt = 'updatedAt',
    Bonus = 'bonus',
    ShippingFee = 'shippingFee',
    PickupStatus = 'pickupStatus'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchPopStoreDropshipApplicationsOrderEnum {
    Asc = 'asc',
    Desc = 'desc'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchPopStoreDropshipApplicationsSortByEnum {
    CreatedAt = 'createdAt',
    UpdatedAt = 'updatedAt'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchPopStoreOnboardingContestSubmissionsOrderEnum {
    Asc = 'asc',
    Desc = 'desc'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchPopStoreOnboardingContestSubmissionsSortByEnum {
    CreatedAt = 'createdAt'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchPopStoreOnboardingSessionsOrderEnum {
    Asc = 'asc',
    Desc = 'desc'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchPopStoreOnboardingSessionsSortByEnum {
    CreatedAt = 'created_at'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchPopStoreReplayLiveStreamsOrderEnum {
    Asc = 'asc',
    Desc = 'desc'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchPopStoreReplayLiveStreamsModerationStatusEnum {
    Pending = 'Pending',
    Accepted = 'Accepted',
    Rejected = 'Rejected',
    ReviewRequired = 'ReviewRequired'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchPopStoreReplayLiveStreamsSortByEnum {
    Title = 'title',
    StoreFrontName = 'storeFrontName',
    CreatedAt = 'createdAt',
    DisconnectedAt = 'disconnectedAt',
    LastReplayedAt = 'lastReplayedAt'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchPostsXPopPlatformEnum {
    Psl = 'psl',
    Popstore = 'popstore'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchPrivateProfilesPayoutHistoryOrderEnum {
    Asc = 'asc',
    Desc = 'desc'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchPrivateProfilesPayoutHistoryStatusEnum {
    Approved = 'approved',
    Pending = 'pending',
    Rejected = 'rejected',
    Canceled = 'canceled'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchPrivateProfilesPayoutHistorySourceTypeEnum {
    Admin = 'admin',
    Seller = 'seller'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchPrivateProfilesPayoutHistorySortByEnum {
    Id = 'id',
    CreatedAt = 'createdAt',
    UpdatedAt = 'updatedAt',
    Status = 'status',
    SourceType = 'sourceType'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchProductCollectionsOrderEnum {
    Asc = 'asc',
    Desc = 'desc'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchProductCollectionsSortByEnum {
    Id = 'id',
    CreatedAt = 'createdAt',
    UpdatedAt = 'updatedAt',
    Name = 'name',
    Sort = 'sort'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchProductsXPopPlatformEnum {
    Psl = 'psl',
    Popstore = 'popstore'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchProfilesOrderEnum {
    Asc = 'asc',
    Desc = 'desc'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchProfilesFilterByEnum {
    Any = 'any',
    FirstName = 'firstName',
    LastName = 'lastName',
    Email = 'email',
    StoreFrontName = 'storeFrontName',
    Username = 'username'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchProfilesUserTypeEnum {
    Guest = 'guest',
    Normal = 'normal',
    Seller = 'seller',
    VerifiedSeller = 'verifiedSeller'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchProfilesSortByEnum {
    Name = 'name',
    Email = 'email',
    CreatedAt = 'createdAt',
    StoreFrontName = 'storeFrontName'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchProfilesFollowersOrderEnum {
    Asc = 'asc',
    Desc = 'desc'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchProfilesFollowersSortByEnum {
    Id = 'id',
    Username = 'username',
    FirstName = 'firstName',
    LastName = 'lastName',
    StoreFrontName = 'storeFrontName',
    Timestamp = 'timestamp'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchProfilesFollowingsOrderEnum {
    Asc = 'asc',
    Desc = 'desc'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchProfilesFollowingsSortByEnum {
    Id = 'id',
    Username = 'username',
    FirstName = 'firstName',
    LastName = 'lastName',
    StoreFrontName = 'storeFrontName',
    Timestamp = 'timestamp'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchProfilesFollowingsUserTypeEnum {
    Guest = 'guest',
    Normal = 'normal',
    Seller = 'seller',
    VerifiedSeller = 'verifiedSeller'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchPslCategoriesOrderEnum {
    Asc = 'asc',
    Desc = 'desc'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchPslCategoriesSortByEnum {
    Id = 'id',
    CreatedAt = 'createdAt',
    Name = 'name',
    Sort = 'sort'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchPublicListingsOrderEnum {
    Asc = 'asc',
    Desc = 'desc'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchPublicListingsStatusEnum {
    Active = 'active',
    Archived = 'archived'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchPublicListingsSortByEnum {
    Id = 'id',
    Name = 'name',
    CreatedAt = 'createdAt',
    Quantity = 'quantity',
    Price = 'price',
    DiscountPrice = 'discountPrice',
    ShippingFee = 'shippingFee',
    SoldQuantityLast7Days = 'soldQuantityLast7Days',
    StoreFrontNameKeyword = 'storeFrontName.keyword',
    MeetingStartDate = 'meeting.startDate'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchPublicListingsTagsFilterOperatorEnum {
    ContainsAny = 'CONTAINS_ANY',
    ContainsAll = 'CONTAINS_ALL',
    NotContainsAny = 'NOT_CONTAINS_ANY',
    NotContainsAll = 'NOT_CONTAINS_ALL'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchPublicListingsListingTypeEnum {
    Physical = 'PHYSICAL',
    Digital = 'DIGITAL',
    External = 'EXTERNAL',
    Meeting = 'MEETING',
    Affiliate = 'AFFILIATE',
    Derived = 'DERIVED'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchPublicListingsExcludeListingTypeEnum {
    Physical = 'PHYSICAL',
    Digital = 'DIGITAL',
    External = 'EXTERNAL',
    Meeting = 'MEETING',
    Affiliate = 'AFFILIATE',
    Derived = 'DERIVED'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchPublicListingsV2OrderEnum {
    Asc = 'asc',
    Desc = 'desc'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchPublicListingsV2StatusEnum {
    Active = 'active',
    Archived = 'archived'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchPublicListingsV2SortByEnum {
    Id = 'id',
    Name = 'name',
    CreatedAt = 'createdAt',
    Quantity = 'quantity',
    Price = 'price',
    DiscountPrice = 'discountPrice',
    ShippingFee = 'shippingFee',
    SoldQuantityLast7Days = 'soldQuantityLast7Days',
    StoreFrontNameKeyword = 'storeFrontName.keyword',
    MeetingStartDate = 'meeting.startDate'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchPublicListingsV2TagsFilterOperatorEnum {
    ContainsAny = 'CONTAINS_ANY',
    ContainsAll = 'CONTAINS_ALL',
    NotContainsAny = 'NOT_CONTAINS_ANY',
    NotContainsAll = 'NOT_CONTAINS_ALL'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchPublicListingsV2ListingTypeEnum {
    Physical = 'PHYSICAL',
    Digital = 'DIGITAL',
    External = 'EXTERNAL',
    Meeting = 'MEETING',
    Affiliate = 'AFFILIATE',
    Derived = 'DERIVED'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchPublicListingsV2ExcludeListingTypeEnum {
    Physical = 'PHYSICAL',
    Digital = 'DIGITAL',
    External = 'EXTERNAL',
    Meeting = 'MEETING',
    Affiliate = 'AFFILIATE',
    Derived = 'DERIVED'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchPublicListingsV2XPopPlatformEnum {
    Psl = 'psl',
    Popstore = 'popstore'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchRedeemedCouponsOrderEnum {
    Asc = 'asc',
    Desc = 'desc'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchRedeemedCouponsFilterByEnum {
    Any = 'any',
    Code = 'code',
    SellerName = 'sellerName',
    SellerId = 'sellerId',
    BuyerName = 'buyerName',
    BuyerId = 'buyerId'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchRedeemedCouponsSortByEnum {
    UsedAt = 'usedAt',
    ExpiredAt = 'expiredAt',
    StartedAt = 'startedAt',
    CreatedAt = 'createdAt'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchReferralGiftsOrderEnum {
    Asc = 'asc',
    Desc = 'desc'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchReferralGiftsSortByEnum {
    SortedAt = 'sortedAt',
    CreatedAt = 'createdAt'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchReplayLiveStreamsOrderEnum {
    Asc = 'asc',
    Desc = 'desc'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchReplayLiveStreamsModerationStatusEnum {
    Pending = 'Pending',
    Accepted = 'Accepted',
    Rejected = 'Rejected',
    ReviewRequired = 'ReviewRequired'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchReplayLiveStreamsSortByEnum {
    Title = 'title',
    StoreFrontName = 'storeFrontName',
    CreatedAt = 'createdAt',
    DisconnectedAt = 'disconnectedAt',
    LastReplayedAt = 'lastReplayedAt'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchReviewsByUserOrderEnum {
    Asc = 'asc',
    Desc = 'desc'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchReviewsByUserSortByEnum {
    Id = 'id',
    CreatedAt = 'createdAt',
    UpdatedAt = 'updatedAt',
    UpvoteCount = 'upvoteCount',
    TotalReportCount = 'totalReportCount',
    NewReportCount = 'newReportCount'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchReviewsToSellerOrderEnum {
    Asc = 'asc',
    Desc = 'desc'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchReviewsToSellerSortByEnum {
    Id = 'id',
    CreatedAt = 'createdAt',
    UpdatedAt = 'updatedAt',
    UpvoteCount = 'upvoteCount',
    TotalReportCount = 'totalReportCount',
    NewReportCount = 'newReportCount'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchRolesOrderEnum {
    Asc = 'asc',
    Desc = 'desc'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchRolesRolesEnum {
    Moderator = 'moderator',
    Seller = 'seller',
    SystemAdmin = 'system-admin',
    User = 'user',
    Finance = 'finance',
    AgencyAdmin = 'agency-admin',
    AgencyUser = 'agency-user'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchRolesSortByEnum {
    Id = 'id'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchSellerIncentivePayoutsOrderEnum {
    Asc = 'asc',
    Desc = 'desc'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchSellerIncentivePayoutsStatusEnum {
    Pending = 'Pending',
    Processed = 'Processed',
    Completed = 'Completed',
    Failed = 'Failed'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchSellerIncentivePayoutsSortByEnum {
    Id = 'id',
    CreatedAt = 'createdAt',
    CreatorName = 'creatorName',
    StoreName = 'storeName'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchSellerMessagesFilterByEnum {
    All = 'all',
    Sku = 'sku',
    ListingName = 'listingName',
    CustomerName = 'customerName',
    ShowName = 'showName'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchSellerMessagesOrderEnum {
    Asc = 'asc',
    Desc = 'desc'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchSellerMessagesReportFilterByEnum {
    All = 'all',
    None = 'none',
    Unresolved = 'unresolved',
    Resolved = 'resolved'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchSellerMessagesPurposeEnum {
    Review = 'review',
    ThankYou = 'thankYou'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchSellerMessagesThankYouTypeEnum {
    RecipientToBuyer = 'RecipientToBuyer',
    SellerToBuyer = 'SellerToBuyer'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchSellerMessagesSortByEnum {
    Id = 'id',
    CreatedAt = 'createdAt',
    UpdatedAt = 'updatedAt',
    UpvoteCount = 'upvoteCount',
    TotalReportCount = 'totalReportCount',
    NewReportCount = 'newReportCount'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchSellerOrderDetailsOrderEnum {
    Asc = 'asc',
    Desc = 'desc'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchSellerOrderDetailsStatusEnum {
    Created = 'created',
    Completed = 'completed',
    Canceled = 'canceled',
    PendingPayment = 'pendingPayment',
    ProcessingPayment = 'processingPayment',
    Closed = 'closed'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchSellerOrderDetailsOrderGroupStatusEnum {
    Open = 'open',
    Processing = 'processing',
    Fulfilling = 'fulfilling',
    Completed = 'completed',
    Canceled = 'canceled'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchSellerOrderDetailsPickupStatusEnum {
    Open = 'open',
    New = 'new',
    Processing = 'processing',
    Pending = 'pending',
    Packed = 'packed',
    Completed = 'completed',
    Canceled = 'canceled'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchSellerOrderDetailsGroupStatusEnum {
    Master = 'master',
    Customer = 'customer'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchSellerOrderDetailsShippingMethodEnum {
    DropshipSupplierProvide = 'dropshipSupplierProvide',
    SellerProvide = 'sellerProvide',
    PopshopProvide = 'popshopProvide',
    Pickup = 'pickup'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchSellerOrderDetailsBuyerUserTypeEnum {
    Guest = 'guest',
    Normal = 'normal',
    Seller = 'seller',
    VerifiedSeller = 'verifiedSeller'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchSellerOrderDetailsPlatformEnum {
    PopshopLive = 'popshop.live',
    PopStore = 'pop.store'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchSellerOrderDetailsListingTypeEnum {
    Physical = 'PHYSICAL',
    Digital = 'DIGITAL',
    External = 'EXTERNAL',
    Meeting = 'MEETING',
    Affiliate = 'AFFILIATE',
    Derived = 'DERIVED'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchSellerOrderDetailsMainStatusEnum {
    Created = 'created',
    Completed = 'completed',
    Canceled = 'canceled',
    PendingPayment = 'pendingPayment',
    ProcessingPayment = 'processingPayment',
    Closed = 'closed'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchSellerOrderDetailsShippingLabelStatusEnum {
    Disabled = 'disabled',
    NoLabel = 'noLabel',
    Generating = 'generating',
    Generated = 'generated',
    PreGenerated = 'preGenerated',
    Failed = 'failed'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchSellerOrderDetailsMainShippingLabelStatusEnum {
    Disabled = 'disabled',
    NoLabel = 'noLabel',
    Generating = 'generating',
    Generated = 'generated',
    PreGenerated = 'preGenerated',
    Failed = 'failed'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchSellerOrderDetailsShippingStatusEnum {
    Unknown = 'UNKNOWN',
    Delivered = 'DELIVERED',
    PreTransit = 'PRE_TRANSIT',
    Transit = 'TRANSIT',
    Failure = 'FAILURE',
    Returned = 'RETURNED'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchSellerOrderDetailsRateStatusEnum {
    Pending = 'pending',
    Failed = 'failed',
    Success = 'success'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchSellerOrderDetailsMainShippingStatusEnum {
    Unknown = 'UNKNOWN',
    Delivered = 'DELIVERED',
    PreTransit = 'PRE_TRANSIT',
    Transit = 'TRANSIT',
    Failure = 'FAILURE',
    Returned = 'RETURNED'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchSellerOrderDetailsFilterLabelStatusEnum {
    Opened = 'Opened',
    NeedLabel = 'NeedLabel',
    Generated = 'Generated',
    FlatRate = 'FlatRate',
    Cancelled = 'Cancelled'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchSellerOrderDetailsSortByEnum {
    BuyerFullName = 'buyerFullName',
    OrderNumber = 'orderNumber',
    Total = 'total',
    CreatedAt = 'createdAt',
    UpdatedAt = 'updatedAt',
    Bonus = 'bonus',
    ShippingFee = 'shippingFee',
    PickupStatus = 'pickupStatus',
    TotalPriceIncludeSlaveOrders = 'totalPriceIncludeSlaveOrders',
    ListingQuantity = 'listingQuantity',
    ListingWeightInLb = 'listingWeightInLb',
    AdjustShippingFee = 'adjustShippingFee'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchSellerOrderDetailsPaymentTypeEnum {
    Credit = 'credit',
    Applepay = 'applepay',
    Empty = 'empty'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchSellerOrderDetailsSourceTypeEnum {
    UpcomingShow = 'UPCOMING_SHOW',
    LiveStream = 'LIVE_STREAM',
    Store = 'STORE',
    TwoWayStream = 'TWO_WAY_STREAM',
    ReferralGifting = 'REFERRAL_GIFTING',
    SendItem = 'SEND_ITEM',
    TopProducts = 'TOP_PRODUCTS',
    Shop = 'SHOP',
    Replay = 'REPLAY',
    CommentChat = 'COMMENT_CHAT'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchSellerOrdersOrderEnum {
    Asc = 'asc',
    Desc = 'desc'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchSellerOrdersStatusEnum {
    Created = 'created',
    Completed = 'completed',
    Canceled = 'canceled',
    PendingPayment = 'pendingPayment',
    ProcessingPayment = 'processingPayment',
    Closed = 'closed'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchSellerOrdersOrderGroupStatusEnum {
    Open = 'open',
    Processing = 'processing',
    Fulfilling = 'fulfilling',
    Completed = 'completed',
    Canceled = 'canceled'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchSellerOrdersPickupStatusEnum {
    Open = 'open',
    New = 'new',
    Processing = 'processing',
    Pending = 'pending',
    Packed = 'packed',
    Completed = 'completed',
    Canceled = 'canceled'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchSellerOrdersGroupStatusEnum {
    Master = 'master',
    Customer = 'customer'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchSellerOrdersShippingMethodEnum {
    DropshipSupplierProvide = 'dropshipSupplierProvide',
    SellerProvide = 'sellerProvide',
    PopshopProvide = 'popshopProvide',
    Pickup = 'pickup'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchSellerOrdersBuyerUserTypeEnum {
    Guest = 'guest',
    Normal = 'normal',
    Seller = 'seller',
    VerifiedSeller = 'verifiedSeller'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchSellerOrdersPlatformEnum {
    PopshopLive = 'popshop.live',
    PopStore = 'pop.store'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchSellerOrdersListingTypeEnum {
    Physical = 'PHYSICAL',
    Digital = 'DIGITAL',
    External = 'EXTERNAL',
    Meeting = 'MEETING',
    Affiliate = 'AFFILIATE',
    Derived = 'DERIVED'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchSellerOrdersSortByEnum {
    BuyerFullName = 'buyerFullName',
    OrderNumber = 'orderNumber',
    Total = 'total',
    CreatedAt = 'createdAt',
    UpdatedAt = 'updatedAt',
    Bonus = 'bonus',
    ShippingFee = 'shippingFee',
    PickupStatus = 'pickupStatus'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchSellerPeriodStatsPeriodEnum {
    Day = 'day',
    Week = 'week',
    Month = 'month',
    Year = 'year'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchSellerStatsOrderEnum {
    Asc = 'asc',
    Desc = 'desc'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchSellerStatsCommentChatConnectStatusEnum {
    Connecting = 'connecting',
    Authorized = 'authorized',
    Success = 'success',
    Error = 'error'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchSellerStatsSortByEnum {
    StoreFrontName = 'storeFrontName',
    Name = 'name',
    ShowCount = 'showCount',
    ViewerCount = 'viewerCount',
    CommentCount = 'commentCount',
    MainOrderCount = 'mainOrderCount',
    PurchaseCount = 'purchaseCount',
    LikeCount = 'likeCount',
    Revenue = 'revenue',
    DurationSecond = 'durationSecond',
    StoreCreatedAt = 'storeCreatedAt',
    LastLiveStreamDate = 'lastLiveStreamDate'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchSellerTagsOrderEnum {
    Asc = 'asc',
    Desc = 'desc'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchSellerTagsSortByEnum {
    Id = 'id',
    TagName = 'tagName'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchSeriesOrderEnum {
    Asc = 'asc',
    Desc = 'desc'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchSeriesSortByEnum {
    Id = 'id',
    CreatedAt = 'createdAt',
    UpdatedAt = 'updatedAt',
    Name = 'name',
    Sort = 'sort'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchSeriesElementsOrderEnum {
    Asc = 'asc',
    Desc = 'desc'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchSeriesElementsV2OrderEnum {
    Asc = 'asc',
    Desc = 'desc'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchShipmentsOrderEnum {
    Asc = 'asc',
    Desc = 'desc'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchShipmentsCarrierEnum {
    Shippo = 'SHIPPO',
    Usps = 'USPS',
    Ups = 'UPS',
    CanadaPost = 'CANADA_POST',
    DhlExpress = 'DHL_EXPRESS',
    DpdUk = 'DPD_UK',
    HermesUk = 'HERMES_UK'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchShipmentsSortByEnum {
    CreatedAt = 'createdAt',
    UpdateAt = 'updateAt',
    TrackingNumber = 'trackingNumber',
    Amount = 'amount'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchShowEventFeaturedStoresOrderEnum {
    Asc = 'asc',
    Desc = 'desc'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchShowEventFeaturedStoresSortByEnum {
    SortedAt = 'sortedAt',
    Position = 'position'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchShowEventSellerApplicationsOrderEnum {
    Asc = 'asc',
    Desc = 'desc'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchShowEventSellerApplicationsStatusEnum {
    Approved = 'approved',
    Pending = 'pending',
    Rejected = 'rejected'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchShowEventSellerApplicationsSortByEnum {
    CreatedAt = 'createdAt'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchShowEventsOrderEnum {
    Asc = 'asc',
    Desc = 'desc'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchShowEventsSortByEnum {
    Id = 'id',
    SortedAt = 'sortedAt',
    Name = 'name',
    CreatedAt = 'createdAt'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchShowEventsFeaturedShowsOrderEnum {
    Asc = 'asc',
    Desc = 'desc'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchShowEventsFeaturedShowsTypeEnum {
    UpcomingShow = 'upcomingShow',
    LiveShow = 'liveShow',
    Event = 'event'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchShowEventsFeaturedShowsSortByEnum {
    Id = 'id',
    SortedAt = 'sortedAt',
    Type = 'type',
    Active = 'active'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchShowEventsSellerApplicationsOrderEnum {
    Asc = 'asc',
    Desc = 'desc'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchShowEventsSellerApplicationsStatusEnum {
    Approved = 'approved',
    Pending = 'pending',
    Rejected = 'rejected'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchShowEventsSellerApplicationsSortByEnum {
    CreatedAt = 'createdAt'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchShowEventsTicketsOrderEnum {
    Asc = 'asc',
    Desc = 'desc'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchShowEventsTicketsSortByEnum {
    Id = 'id',
    CreatedAt = 'createdAt',
    Name = 'name',
    SortedAt = 'sortedAt'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchShowsXPopPlatformEnum {
    Psl = 'psl',
    Popstore = 'popstore'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchStoreBlockedUsersOrderEnum {
    Asc = 'asc',
    Desc = 'desc'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchStoreBlockedUsersReasonEnum {
    Spam = 'spam',
    Inappropriate = 'inappropriate',
    Aggressive = 'aggressive',
    SellerBlock = 'seller_block'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchStoreBlockedUsersSortByEnum {
    Reason = 'reason',
    BlockedAt = 'blockedAt'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchStoreLevelSeriesElementsOrderEnum {
    Asc = 'asc',
    Desc = 'desc'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchStoreLevelSeriesElementsV2OrderEnum {
    Asc = 'asc',
    Desc = 'desc'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchStoreLiveStreamsOrderEnum {
    Asc = 'asc',
    Desc = 'desc'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchStoreLiveStreamsStatusEnum {
    Initialized = 'initialized',
    Available = 'available',
    Finished = 'finished',
    Aborted = 'aborted'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchStoreLiveStreamsPermissionEnum {
    All = 'all',
    Follower = 'follower',
    Subscriber = 'subscriber',
    NoOne = 'no-one'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchStoreLiveStreamsSortByEnum {
    Title = 'title',
    StoreFrontName = 'storeFrontName',
    CreatedAt = 'createdAt',
    DisconnectedAt = 'disconnectedAt',
    LastReplayedAt = 'lastReplayedAt'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchStoreLiveStreamsShippingModeEnum {
    Shipping = 'shipping',
    Pickup = 'pickup'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchStoresFilterByEnum {
    Any = 'any',
    Name = 'name',
    FirstName = 'firstName',
    LastName = 'lastName',
    Email = 'email',
    FullName = 'fullName'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchStoresOrderEnum {
    Asc = 'asc',
    Desc = 'desc'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchStoresSortByEnum {
    Name = 'name'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchThemeTemplatesOrderEnum {
    Asc = 'asc',
    Desc = 'desc'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchThemeTemplatesSortByEnum {
    CreatedAt = 'createdAt',
    UpdatedAt = 'updatedAt',
    Position = 'position'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchUpcomingShowsOrderEnum {
    Asc = 'asc',
    Desc = 'desc'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchUpcomingShowsSortByEnum {
    StartsAt = 'startsAt'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchUserDetailsOrderEnum {
    Asc = 'asc',
    Desc = 'desc'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchUserDetailsFilterByEnum {
    Any = 'any',
    FirstName = 'firstName',
    LastName = 'lastName',
    Email = 'email',
    StoreFrontName = 'storeFrontName',
    Username = 'username'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchUserDetailsUserTypeEnum {
    Guest = 'guest',
    Normal = 'normal',
    Seller = 'seller',
    VerifiedSeller = 'verifiedSeller'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchUserDetailsSortByEnum {
    Name = 'name',
    Email = 'email',
    CreatedAt = 'createdAt',
    StoreFrontName = 'storeFrontName',
    Balance = 'balance',
    PendingBalance = 'pendingBalance'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchUserGroupsOrderEnum {
    Asc = 'asc',
    Desc = 'desc'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchUserGroupsSortByEnum {
    CreatedAt = 'createdAt',
    Name = 'name'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchUserGroupsUsersOrderEnum {
    Asc = 'asc',
    Desc = 'desc'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchUserGroupsUsersUserTypeEnum {
    Guest = 'guest',
    Normal = 'normal',
    Seller = 'seller',
    VerifiedSeller = 'verifiedSeller'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchUserGroupsUsersSortByEnum {
    Id = 'id',
    Name = 'name',
    StoreName = 'storeName',
    CreatedAt = 'createdAt'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchUserMessagesTypeEnum {
    Review = 'review',
    Thankyou = 'thankyou',
    ThankyouFromGiftReceiver = 'thankyouFromGiftReceiver'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchUserMessagesOrderEnum {
    Asc = 'asc',
    Desc = 'desc'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchUserMessagesSortByEnum {
    Id = 'id',
    CreatedAt = 'createdAt',
    UpdatedAt = 'updatedAt',
    UpvoteCount = 'upvoteCount',
    TotalReportCount = 'totalReportCount',
    NewReportCount = 'newReportCount'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchUserOrdersOrderEnum {
    Asc = 'asc',
    Desc = 'desc'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchUserOrdersStatusEnum {
    Created = 'created',
    Completed = 'completed',
    Canceled = 'canceled',
    PendingPayment = 'pendingPayment',
    ProcessingPayment = 'processingPayment',
    Closed = 'closed'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchUserOrdersOrderGroupStatusEnum {
    Open = 'open',
    Processing = 'processing',
    Fulfilling = 'fulfilling',
    Completed = 'completed',
    Canceled = 'canceled'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchUserOrdersPickupStatusEnum {
    Open = 'open',
    New = 'new',
    Processing = 'processing',
    Pending = 'pending',
    Packed = 'packed',
    Completed = 'completed',
    Canceled = 'canceled'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchUserOrdersGroupStatusEnum {
    Master = 'master',
    Customer = 'customer'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchUserOrdersShippingMethodEnum {
    DropshipSupplierProvide = 'dropshipSupplierProvide',
    SellerProvide = 'sellerProvide',
    PopshopProvide = 'popshopProvide',
    Pickup = 'pickup'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchUserOrdersBuyerUserTypeEnum {
    Guest = 'guest',
    Normal = 'normal',
    Seller = 'seller',
    VerifiedSeller = 'verifiedSeller'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchUserOrdersPlatformEnum {
    PopshopLive = 'popshop.live',
    PopStore = 'pop.store'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchUserOrdersListingTypeEnum {
    Physical = 'PHYSICAL',
    Digital = 'DIGITAL',
    External = 'EXTERNAL',
    Meeting = 'MEETING',
    Affiliate = 'AFFILIATE',
    Derived = 'DERIVED'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchUserOrdersSortByEnum {
    BuyerFullName = 'buyerFullName',
    OrderNumber = 'orderNumber',
    Total = 'total',
    CreatedAt = 'createdAt',
    UpdatedAt = 'updatedAt',
    Bonus = 'bonus',
    ShippingFee = 'shippingFee',
    PickupStatus = 'pickupStatus'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchUserStatsUserReferralsOrderEnum {
    Asc = 'asc',
    Desc = 'desc'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchUserStatsUserReferralsReferrerUserTypeEnum {
    Guest = 'guest',
    Normal = 'normal',
    Seller = 'seller',
    VerifiedSeller = 'verifiedSeller'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchUserStatsUserReferralsPresenteeUserTypeEnum {
    Guest = 'guest',
    Normal = 'normal',
    Seller = 'seller',
    VerifiedSeller = 'verifiedSeller'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchUserStatsUserReferralsSortByEnum {
    Id = 'id',
    CreatedAt = 'createdAt'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchUserStatsUserReferralsByAdminOrderEnum {
    Asc = 'asc',
    Desc = 'desc'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchUserStatsUserReferralsByAdminReferrerUserTypeEnum {
    Guest = 'guest',
    Normal = 'normal',
    Seller = 'seller',
    VerifiedSeller = 'verifiedSeller'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchUserStatsUserReferralsByAdminPresenteeUserTypeEnum {
    Guest = 'guest',
    Normal = 'normal',
    Seller = 'seller',
    VerifiedSeller = 'verifiedSeller'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchUserStatsUserReferralsByAdminSortByEnum {
    Id = 'id',
    CreatedAt = 'createdAt'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchUserStatsUserReferralsByAdminTypeEnum {
    Share = 'SHARE',
    Passcode = 'PASSCODE'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchUserStatsUserReferralsByAdminSubTypeEnum {
    Profile = 'PROFILE',
    Store = 'STORE',
    LiveStream = 'LIVE_STREAM',
    Replay = 'REPLAY',
    UpcomingShow = 'UPCOMING_SHOW',
    ListingLiveStream = 'LISTING_LIVE_STREAM',
    ListingReplay = 'LISTING_REPLAY',
    ListingEvergreen = 'LISTING_EVERGREEN',
    ListingUpcomingShow = 'LISTING_UPCOMING_SHOW',
    ListingPromotion = 'LISTING_PROMOTION',
    Event = 'EVENT',
    EventDiscovery = 'EVENT_DISCOVERY',
    EventTicket = 'EVENT_TICKET',
    HomePage = 'HOME_PAGE',
    Promotion = 'PROMOTION',
    ReferralGifting = 'REFERRAL_GIFTING',
    UserBadge = 'USER_BADGE',
    LiveStreamGiveaway = 'LIVE_STREAM_GIVEAWAY',
    UpcomingShowGiveaway = 'UPCOMING_SHOW_GIVEAWAY',
    PopClip = 'POP_CLIP',
    BecomeASeller = 'BECOME_A_SELLER'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchWithdrawTransactionsOrderEnum {
    Asc = 'asc',
    Desc = 'desc'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchWithdrawTransactionsStatusEnum {
    Approved = 'approved',
    Rejected = 'rejected',
    Pending = 'pending'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchWithdrawTransactionsSortByEnum {
    Id = 'id',
    CreatedAt = 'createdAt',
    UpdatedAt = 'updatedAt',
    Amount = 'amount',
    Balance = 'balance'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchWithdrawTransactionsBySellerOrderEnum {
    Asc = 'asc',
    Desc = 'desc'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchWithdrawTransactionsBySellerStatusEnum {
    Approved = 'approved',
    Rejected = 'rejected',
    Pending = 'pending'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchApiControllerSearchWithdrawTransactionsBySellerSortByEnum {
    Id = 'id',
    CreatedAt = 'createdAt',
    UpdatedAt = 'updatedAt',
    Amount = 'amount',
    Balance = 'balance'
}
